import React from 'react'

// Andorra
const AdFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M0 0h144.7l36 254.6-36 257.4H0z' />
      <path fill='#d80027' d='M367.3 0H512v512H367.3l-29.7-257.3z' />
      <path fill='#ffda44' d='M144.7 0h222.6v512H144.7z' />
      <path fill='#d80027' d='M256 354.5V256h66.8v47.3zm-66.8-165.3H256V256h-66.8z' />
      <path
        fill='#ff9811'
        d='M289.4 167a22.3 22.3 0 0 0-33.4-19.3 22.1 22.1 0 0 0-11.1-3c-12.3 0-22.3 10-22.3 22.3H167v111.3c0 41.4 32.9 65.4 58.7 77.8a22.1 22.1 0 0 0-3 11.2 22.3 22.3 0 0 0 33.3 19.3 22.1 22.1 0 0 0 11.1 3 22.3 22.3 0 0 0 19.2-33.5c25.8-12.4 58.7-36.4 58.7-77.8V167zm22.3 111.3c0 5.8 0 23.4-27.5 40.9a136.5 136.5 0 0 1-28.2 13.3c-7-2.4-17.8-6.7-28.2-13.3-27.5-17.5-27.5-35.1-27.5-41v-77.9h111.4z'
      />
    </g>
  </svg>
)

// United Arab Emirates
const AeFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#a2001d' d='M0 0h167l52.3 252L167 512H0z' />
      <path fill='#eee' d='m167 167 170.8-44.6L512 167v178l-173.2 36.9L167 345z' />
      <path fill='#6da544' d='M167 0h345v167H167z' />
      <path fill='#333' d='M167 345h345v167H167z' />
    </g>
  </svg>
)

// Afghanistan
const AfFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M144.7 0h222.6l37 257.7-37 254.3H144.7l-42.4-255.2z' />
      <path fill='#496e2d' d='M367.3 0H512v512H367.3z' />
      <path fill='#333' d='M0 0h144.7v512H0z' />
      <g fill='#ffda44'>
        <path d='M256 167a89 89 0 1 0 0 178 89 89 0 0 0 0-178zm0 144.7a55.7 55.7 0 1 1 0-111.4 55.7 55.7 0 0 1 0 111.4z' />
        <path d='M256 222.6c-12.3 0-22.3 10-22.3 22.3v33.4h44.6v-33.4c0-12.3-10-22.3-22.3-22.3z' />
      </g>
    </g>
  </svg>
)

// Antigua and Barbuda
const AgFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#333' d='M0 .4h512l-34 229H36z' />
      <path
        fill='#ffda44'
        d='m367.3 205.3-109.7 19.4-112.9-19.4 45.5-21.3-24.2-44 49.3 9.4 6.3-49.9 34.4 36.7 34.4-36.6 6.3 50L346 140l-24.2 44z'
      />
      <path fill='#0052b4' d='M25.6 205.3h466.8L257 439.5z' />
      <path fill='#eee' d='M34 307.4h446L256 511.6z' />
      <path fill='#a2001d' d='m0 511.6 256 .4L0 .4zm256 .4 256-.4V0z' />
    </g>
  </svg>
)

// Anguilla
const AiFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M256 0h256v512H0V256Z' />
      <path
        fill='#eee'
        d='M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z'
      />
      <path fill='#d80027' d='M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z' />
      <path fill='#496e2d' d='M445.2 256.1zm-155.8 0z' />
      <path
        fill='#eee'
        d='M433 293.6a62.4 62.4 0 0 0 12.2-37.5V144.8a55.4 55.4 0 0 1-33.4 11.1 55.6 55.6 0 0 1-44.5-22.2 55.6 55.6 0 0 1-44.5 22.2 55.4 55.4 0 0 1-33.4-11.1v111.3c0 15 5 27.3 12.3 37.5h131.2z'
      />
      <path
        fill='#ff9811'
        d='M409.8 235.5a91 91 0 0 0 6.3-27.6c0-10.1-13.2-18.3-13.2-18.3s-13.2 8.2-13.2 18.3a91 91 0 0 0 6.3 27.6l-7.6 17.1a38.3 38.3 0 0 0 29 0zm-51.5-55.6a91 91 0 0 0-27 8.3c-8.8 5-9.3 20.5-9.3 20.5s13.7 7.4 22.4 2.3c5.5-3.1 15-11.8 20.8-19.2l18.6-2a38.4 38.4 0 0 0-4.7-14 38.4 38.4 0 0 0-9.7-11.1zm-22.4 72.2a91 91 0 0 0 20.7 19.3c8.8 5 22.5-2.3 22.5-2.3s-.6-15.5-9.3-20.5a91 91 0 0 0-27-8.4l-11.1-15.1a38.4 38.4 0 0 0-9.7 11 38.4 38.4 0 0 0-4.8 14z'
      />
      <path
        fill='#338af3'
        d='M299 289.5c20.7 33.3 68.3 44.5 68.3 44.5s47.6-11.2 68.4-44.5H298.9Z'
      />
    </g>
  </svg>
)

// Albania
const AlFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 0h512v512H0z' />
      <path
        fill='#333'
        d='M400.7 190H308a33.3 33.3 0 0 0-24.2-56.4 33.3 33.3 0 0 0-27.8 14.9 33.4 33.4 0 1 0-52 41.5h-92.7a45.8 45.8 0 0 0 46 44.5h-1.5c0 24.6 20 44.6 44.5 44.6 0 8 2.1 15.4 5.8 21.8l-37 37 28.4 28.3 40.2-40.2a30.5 30.5 0 0 0 4.9 1.4l-24.3 54.8L256 423l37.7-40.8-24.3-54.8a30.4 30.4 0 0 0 4.9-1.4l40.2 40.2 28.3-28.3-37-37a44.2 44.2 0 0 0 5.9-21.8c24.5 0 44.5-20 44.5-44.6h-1.5c24.6 0 46-19.9 46-44.5z'
      />
    </g>
  </svg>
)

// Armenia
const AmFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='m0 166.9 253-26.7L512 167v178l-261.1 26L0 344.8z' />
      <path fill='#d80027' d='M0 0h512v166.9H0z' />
      <path fill='#ff9811' d='M0 344.9h512V512H0z' />
    </g>
  </svg>
)

// Angola
const AoFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 0h512v256l-253 36.6L0 256z' />
      <path fill='#333' d='M0 256h512v256H0z' />
      <g fill='#ffda44'>
        <path d='m220.9 203.6 21.7 15.8-8.3 25.5L256 229l21.7 15.7-8.3-25.5 21.7-15.7h-26.8L256 178l-8.3 25.5z' />
        <path d='M320 145.1a127.2 127.2 0 0 0-64-17v33.3a94 94 0 0 1 47.3 12.7 94.7 94.7 0 0 1-94.6 163.8 94 94 0 0 1-31.6-29.8l-27.9 18.4a128.1 128.1 0 0 0 217.7-6.5A128.1 128.1 0 0 0 320 145.1z' />
        <path d='M182.2 233.7a33.4 33.4 0 0 0 13.3 45.4l108.4 59.2c-7.4 13.5-3.4 30 10 37.3l29.3 16a27.8 27.8 0 0 0 37.8-11l16-29.3z' />
      </g>
    </g>
  </svg>
)

// Antarctica
const AqFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#338af3' d='M0 0h512v512H0z' />
      <path
        fill='#eee'
        d='m135 343-41-70 17-38-40-51-9-37 74 51 45-11 19-67 50-29 75 11 87 45 4 74 28 10v76l-53 94-64 20-59-14 15-25-7-26-8 7z'
      />
    </g>
  </svg>
)

// Argentina
const ArFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#338af3' d='M0 0h512v144.7L488 256l24 111.3V512H0V367.3L26 256 0 144.7z' />
      <path fill='#eee' d='M0 144.7h512v222.6H0z' />
      <path
        fill='#ffda44'
        d='m332.4 256-31.2 14.7 16.7 30.3-34-6.5-4.2 34.3-23.7-25.2-23.6 25.2-4.3-34.3-34 6.5 16.6-30.3-31.2-14.7 31.3-14.7L194 211l34 6.5 4.3-34.3 23.6 25.2 23.6-25.2 4.4 34.3 34-6.5-16.7 30.3z'
      />
    </g>
  </svg>
)

// American Samoa
const AsFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M512 20.4V490L23.8 255.8z' />
      <path
        fill='#a2001d'
        d='M445.2 246.5h-30.5c8-9.6 7.5-23.7-1.5-32.7a24.2 24.2 0 0 0 0-34.2l-.5.5a25 25 0 0 0 .5-34.8l-137 137a23.9 23.9 0 0 0 34 0l2.6-2.5 65.6-6v28.3h22.3v-30.2l33.4-3z'
      />
      <path fill='#ffda44' d='M278.3 311.7 256 300.5l22.3-11.1H423v22.3z' />
      <path fill='#0052b4' d='M0 0v512h512L28.7 256.2 512 0z' />
      <path fill='#d80027' d='M512 0 0 256l512 256v-22L43.8 256 512 20.4z' />
    </g>
  </svg>
)

// Austria
const AtFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 0h512v167l-23.2 89.7L512 345v167H0V345l29.4-89L0 167z' />
      <path fill='#eee' d='M0 167h512v178H0z' />
    </g>
  </svg>
)

// Australia
const AuFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M0 0h512v512H0z' />
      <path
        fill='#eee'
        d='m154 300 14 30 32-8-14 30 25 20-32 7 1 33-26-21-26 21 1-33-33-7 26-20-14-30 32 8zm222-27h47l-38 27 15-44 14 44zm7-162 7 15 16-4-7 15 12 10-15 3v17l-13-11-13 11v-17l-15-3 12-10-7-15 16 4zm57 67 7 15 16-4-7 15 12 10-15 3v16l-13-10-13 11v-17l-15-3 12-10-7-15 16 4zm-122 22 7 15 16-4-7 15 12 10-15 3v16l-13-10-13 11v-17l-15-3 12-10-7-15 16 4zm65 156 7 15 16-4-7 15 12 10-15 3v17l-13-11-13 11v-17l-15-3 12-10-7-15 16 4zM0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z'
      />
      <path fill='#d80027' d='M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z' />
    </g>
  </svg>
)

// Aruba
const AwFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#ffda44'
        d='m0 322.8 253.6-18.4L512 322.8v33.4l-258 15.3L0 356.2zm0 66.8 257.2-13.8L512 389.6V423l-253 16.9L0 423z'
      />
      <path fill='#338af3' d='M0 0h512v322.8H0zm0 356.2h512v33.4H0zM0 423h512v89H0z' />
      <path fill='#eee' d='m117.3 161.5-50-22.1 50-22 22-50.1 22.2 50 50 22-50 22.2-22.1 50z' />
      <path
        fill='#d80027'
        d='m139.4 94.9 13.6 30.9 31 13.6-31 13.6-13.6 31-13.6-31-31-13.6 31-13.6z'
      />
    </g>
  </svg>
)

// Aland Islands
const AxFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#0052b4'
        d='M0 0h100.2l68.3 40.7L233.7 0H512v189.2l-45.5 66 45.5 68.6V512H233.7l-65.8-39.2-67.7 39.2H0V322.8l45.6-67.5L0 189.2z'
      />
      <path
        fill='#ffda44'
        d='M100.2 0v189.2H0v33.4l23 34-23 32.8v33.4h100.2V512h33.4l33.9-22.6 32.8 22.6h33.4V323.8H512v-34.4l-24.2-32.2 24.2-34.6v-33.4H233.7V0h-33.4l-32.6 20-34.1-20z'
      />
      <path
        fill='#d80027'
        d='M133.6 0v222.6H0v66.8h133.6V512h66.7V289.4H512v-66.8H200.3V0h-66.7z'
      />
    </g>
  </svg>
)

// Azerbaijan
const AzFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='m0 166.9 253-31.8 259 31.8v178l-257.5 37.4L0 345z' />
      <path fill='#338af3' d='M0 0h512v166.9H0z' />
      <path fill='#6da544' d='M0 344.9h512V512H0z' />
      <g fill='#eee'>
        <path d='M261.6 328.2a72.3 72.3 0 1 1 34.4-136 89 89 0 1 0 0 127.3 72 72 0 0 1-34.4 8.7z' />
        <path d='m317.2 206 9.6 26.8 25.8-12.3-12.2 25.8 26.9 9.6-27 9.6 12.3 25.8-25.8-12.3-9.6 27-9.6-27-25.8 12.3 12.3-25.8-27-9.6 27-9.6-12.3-25.8 25.8 12.3z' />
      </g>
    </g>
  </svg>
)

// Bosnia and Herzegovina
const BaFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ffda44' d='M0 0h445.3l33.9 255-33.9 257-323.7-134.3L0 66.8z' />
      <path fill='#0052b4' d='M0 66.8V512h445.4z' />
      <path fill='#0052b4' d='M445.3 0H512v512h-66.7z' />
      <path
        fill='#eee'
        d='m354.6 456-8.3 25.6h-26.8l21.7 15.8-8.3 25.5 21.7-15.8 21.7 15.8-8.3-25.5 21.7-15.8h-26.8zm-55-55.4-8.3 25.5h-26.8l21.7 15.8-8.3 25.5 21.7-15.8 21.7 15.8-8.3-25.5 21.7-15.8h-26.8zM244.4 345l-8.3 25.5h-26.8l21.7 15.8-8.3 25.5 21.7-15.8 21.7 15.8-8.3-25.5 21.7-15.8h-26.8zm-55.1-55.7-8.3 25.5h-26.8l21.7 15.8-8.3 25.5 21.7-15.8L211 356l-8.3-25.5 21.7-15.8h-26.8zm-55.4-55.7-8.3 25.5H98.8l21.7 15.8-8.3 25.5 21.7-15.8 21.7 15.8-8.3-25.5L169 259h-26.8zM78.7 178l-8.3 25.5H43.6l21.7 15.8-8.3 25.5L78.7 229l21.7 15.8-8.3-25.5 21.7-15.8H87zm-55.2-55.7-8.3 25.5h-26.8l21.7 15.8L1.8 189l21.7-15.8L45.2 189l-8.3-25.5 21.7-15.8H31.8z'
      />
    </g>
  </svg>
)

// Barbados
const BbFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#0052b4'
        d='M0 0h144.8l112.9 36.7L367.4 0H512v512H367.4l-108.9-38.1L144.8 512H0z'
      />
      <path fill='#ffda44' d='M144.8 0h222.6v512H144.8z' />
      <path
        fill='#333'
        d='m334.1 155.8 14.8 7.5-14.9-7.5-15-7.4c-.8 1.8-20.3 41.4-23.5 102h-22.7v-94.6l-16.7-22.2-16.7 22.2v94.6h-22.7a278.3 278.3 0 0 0-23.6-102l-29.8 14.9c.2.4 20.5 41.7 20.5 103.8v16.7h55.6v94.6h33.4v-94.6h55.6v-16.7c0-32 5.6-58.6 10.3-75.1 5-18 10.2-28.6 10.3-28.7l-15-7.5z'
      />
    </g>
  </svg>
)

// Bangladesh
const BdFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#496e2d' d='M0 0h512v512H0z' />
      <circle cx='200.3' cy='256' r='111.3' fill='#d80027' />
    </g>
  </svg>
)

// Belgium
const BeFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#333' d='M0 0h167l38.2 252.6L167 512H0z' />
      <path fill='#d80027' d='M345 0h167v512H345l-36.7-256z' />
      <path fill='#ffda44' d='M167 0h178v512H167z' />
    </g>
  </svg>
)

// Burkina Faso
const BfFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 0h512v256l-255.2 48L0 256z' />
      <path fill='#6da544' d='M0 256h512v256H0z' />
      <path
        fill='#ffda44'
        d='m256 167 19.3 59.5H338l-50.6 36.8 19.3 59.5L256 286l-50.6 36.8 19.3-59.5-50.6-36.8h62.6z'
      />
    </g>
  </svg>
)

// Bulgaria
const BgFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#496e2d' d='m0 166.9 258-31.7 254 31.7v178l-251.4 41.3L0 344.9z' />
      <path fill='#eee' d='M0 0h512v166.9H0z' />
      <path fill='#d80027' d='M0 344.9h512V512H0z' />
    </g>
  </svg>
)

// Bahrain
const BhFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M0 0h182.5l88.1 268.5-88 243.5H0z' />
      <path
        fill='#d80027'
        d='m182.5 0-82.3 42.7 82.3 42.7-82.3 42.6 82.3 42.7-82.3 42.7 82.3 42.6-82.3 42.7 82.3 42.7-82.3 42.6 82.3 42.7-82.3 42.7 82.3 42.6H512V0H182.5z'
      />
    </g>
  </svg>
)

// Burundi
const BiFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#eee'
        d='M0 0h47.2l207.5 30L464.8 0H512v47.2L477.4 256 512 464.8V512h-47.2l-209.1-35.8L47.2 512H0v-47.2l32.8-202.7L0 47.2z'
      />
      <path
        fill='#d80027'
        d='M47.2 0 256 208.8 464.8 0H47.2zM256 303.2 47.2 512h417.6L256 303.2z'
      />
      <path fill='#6da544' d='M0 47.2v417.6L208.8 256 0 47.2zm512 0L303.2 256 512 464.8V47.2z' />
      <circle cx='256' cy='256' r='111.3' fill='#eee' />
      <path
        fill='#d80027'
        d='m256 178 9.6 16.8H285l-9.6 16.7 9.6 16.7h-19.3l-9.6 16.7-9.6-16.7H227l9.6-16.7-9.6-16.7h19.3zm-49 78 9.6 16.7H236l-9.6 16.7 9.6 16.7h-19.3l-9.6 16.7-9.6-16.7H178l9.6-16.7-9.6-16.7h19.3zm98 0 9.6 16.7H334l-9.6 16.7 9.6 16.7h-19.3l-9.6 16.7-9.6-16.7H276l9.6-16.7-9.6-16.7h19.3z'
      />
    </g>
  </svg>
)

// Benin
const BjFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#6da544' d='M0 0h189.2l54 257.6-54 254.4H0z' />
      <path fill='#ffda44' d='M189.2 0H512v256l-159 53.5L189.1 256z' />
      <path fill='#d80027' d='M189.2 256H512v256H189.2z' />
    </g>
  </svg>
)

// Saint Barthelemy
const BlFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M0 0h512v512H0z' />
      <path
        fill='#acabb1'
        d='M167 178a28 28 0 0 0-28 28H55a28 28 0 0 0 28 28 28 28 0 0 0 28 28 28 28 0 0 0 28 28h234a28 28 0 0 0 28-28 28 28 0 0 0 28-28 28 28 0 0 0 28-28h-84a28 28 0 0 0-28-28z'
      />
      <path
        fill='#ffda44'
        d='M123 357h44v44h-44zm222 0h44v44h-44zm-178 11h178v44H167zm67-268v33.5L223 145l-12-6v-17h-44v56l89 14 89-14v-56h-44v17l-12 6-11-11.5V100z'
      />
      <path fill='#0052b4' d='M167 178v112c0 68 89 88.5 89 88.5s89-20.4 89-88.5V178z' />
      <path fill='#d80027' d='M167 222.1h178v69H167z' />
    </g>
  </svg>
)

// Bermuda
const BmFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M256 0h256v512H0V256z' />
      <path
        fill='#eee'
        d='M0 0h33.4l31.8 16.4 35-16.4H256v133.6l-9.3 33.7 9.3 41.5V256h-47.2l-39.3-7-35.9 7.1L0 256V100.2l15.4-34.5L0 33.4z'
      />
      <path fill='#496e2d' d='M445.2 256.1zm-155.8 0z' />
      <path fill='#d80027' d='m267 235.5-102-102h-31.4L267 267z' />
      <path fill='#d80027' d='M33.4 0v33.4H0v66.8h33.4v170.6h66.8V100.2h170.2V33.4H100.2V0z' />
      <path fill='#0052b4' d='M180.8 133.6H256v75.2zm-47.2 47.2v75.3l75.2-.1z' />
      <path fill='#eee' d='M289.4 133.6V256c0 59.6 155.8 59.6 155.8 0V133.6z' />
      <path fill='#6da544' d='M289.4 256c0 59.6 77.9 78 77.9 78s78-18.4 78-78h-156z' />
      <path fill='#a2001d' d='m367.3 207-36.2 15.6V256l36.2 22.3 36.2-22.3v-33.4z' />
      <path fill='#338af3' d='M331.1 189.2h72.4v33.4H331z' />
    </g>
  </svg>
)

// Brunei
const BnFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ffda44' d='M0 0h512v326.7l-19.3 76.5 19.3 77.7V512H0V185.2l21.4-76.5L0 31z' />
      <path fill='#eee' d='M0 31v117.2l512 295.7V326.7L0 31z' />
      <path fill='#333' d='M0 108.2v77L512 481v-77L0 108.2z' />
      <g fill='#d80027'>
        <path d='M328.3 228.2a72.3 72.3 0 1 1-136-34.4 89 89 0 1 0 127.3 0 72 72 0 0 1 8.7 34.4z' />
        <path d='M239.3 144.7h33.4v167h-33.4z' />
        <path d='M311.6 178H200.4c0 7.8 6.6 14 14.3 14h-.4a14 14 0 0 0 13.9 14 14 14 0 0 0 13.9 13.8h27.8a14 14 0 0 0 14-13.9 14 14 0 0 0 13.8-13.9h-.4c7.6 0 14.3-6.2 14.3-13.9zM178.1 322.9h155.8v33.4H178.1z' />
        <path d='M289.4 333.9h66.8v33.4h-66.8zm-133.6 0h66.8v33.4h-66.8z' />
      </g>
    </g>
  </svg>
)

// Bolivia
const BoFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ffda44' d='m0 167 252.9-29.3L512 167v178l-255.7 25.7L0 345z' />
      <path fill='#d80027' d='M0 0h512v167H0z' />
      <path fill='#6da544' d='M0 345h512v167H0z' />
    </g>
  </svg>
)

// Bonaire Sint Eustatius and Saba
const BqFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M113.7 119.8 276 0h236v31.7L306 289.5 31.6 512H0V276z' />
      <path fill='#ffda44' d='M0 0v276L276 0H0z' />
      <path fill='#0052b4' d='M512 31.7 31.7 512H512V31.7z' />
      <path
        fill='#333'
        d='m255 245.7 22.1-12-22-12a78 78 0 0 0-65-65l-12-22-12 22a78 78 0 0 0-65 65l-22 12 22 12a78 78 0 0 0 65 65l12 22.1 12-22a78 78 0 0 0 65-65zm-77 32.6a44.5 44.5 0 1 1 0-89 44.5 44.5 0 0 1 0 89z'
      />
      <path
        fill='#d80027'
        d='m178 200.3 9.7 16.7H207l-9.6 16.7 9.6 16.7h-19.3l-9.6 16.7-9.7-16.7h-19.2l9.6-16.7-9.6-16.7h19.2z'
      />
    </g>
  </svg>
)

// Brazil
const BrFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#6da544' d='M0 0h512v512H0z' />
      <path fill='#ffda44' d='M256 100.2 467.5 256 256 411.8 44.5 256z' />
      <path
        fill='#eee'
        d='M174.2 221a87 87 0 0 0-7.2 36.3l162 49.8a88.5 88.5 0 0 0 14.4-34c-40.6-65.3-119.7-80.3-169.1-52z'
      />
      <path
        fill='#0052b4'
        d='M255.7 167a89 89 0 0 0-41.9 10.6 89 89 0 0 0-39.6 43.4 181.7 181.7 0 0 1 169.1 52.2 89 89 0 0 0-9-59.4 89 89 0 0 0-78.6-46.8zM212 250.5a149 149 0 0 0-45 6.8 89 89 0 0 0 10.5 40.9 89 89 0 0 0 120.6 36.2 89 89 0 0 0 30.7-27.3A151 151 0 0 0 212 250.5z'
      />
    </g>
  </svg>
)

// Bahamas
const BsFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#338af3' d='M0 0h512v167l-37.4 89 37.4 89v167H0l49.6-252z' />
      <path fill='#ffda44' d='M108.3 167H512v178H108.3z' />
      <path fill='#333' d='M0 0v512l256-256L0 0z' />
    </g>
  </svg>
)

// Bhutan
const BtFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ffda44' d='M0 0h512L281 293.2 0 512z' />
      <path fill='#ff9811' d='M506.7 0 0 506.7v5.3h512V0h-5.3z' />
      <path
        fill='#eee'
        d='M398.2 142V97.7h-85.3l-6.5 6.5c-23.2 23.2-19.3 50.2-16.5 70 2.7 18.3 3 25.3-3.8 32-6.8 7-14 6.6-32.2 4-19.7-3-46.8-6.8-70 16.4-23.2 23.2-19.3 50.3-16.4 70 2.6 18.3 3 25.4-4 32.2-6.7 6.8-13.7 6.5-32 3.8-7.2-1-14.5-2-22.4-2.2l-.5 44.6c5 0 10.6.8 16.5 1.7 7 1 15 2.2 23.5 2.2 8.7 0 18-1.3 27-5.2v35.6h66.8v-33.4H209v-22.2h22.3v-33.4h-18c.9-10.8-.6-21.2-2-30-2.5-18.4-3-25.4 4-32.2 6.8-6.8 13.8-6.5 32.2-3.8 14.3 2 32.6 4.7 50.4-3v35.6h66.8v-33.4h-33.3V231h22.3v-33.4h-17.8a130 130 0 0 0-2-30c-1.8-12.8-2.5-20-.4-25.6z'
      />
    </g>
  </svg>
)

// Bouvet Island
const BvFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#d80027'
        d='M0 0h100.2l66.1 53.5L233.7 0H512v189.3L466.3 257l45.7 65.8V512H233.7l-68-50.7-65.5 50.7H0V322.8l51.4-68.5-51.4-65z'
      />
      <path
        fill='#eee'
        d='M100.2 0v189.3H0v33.4l24.6 33L0 289.5v33.4h100.2V512h33.4l30.6-26.3 36.1 26.3h33.4V322.8H512v-33.4l-24.6-33.7 24.6-33v-33.4H233.7V0h-33.4l-33.8 25.3L133.6 0z'
      />
      <path fill='#0052b4' d='M133.6 0v222.7H0v66.7h133.6V512h66.7V289.4H512v-66.7H200.3V0z' />
    </g>
  </svg>
)

// Botswana
const BwFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#338af3' d='M0 0h512v178l-31 76.9 31 79.1v178H0V334l37-80.7L0 178z' />
      <path fill='#333' d='m0 211.5 256-19.2 256 19.2v89l-254.6 20.7L0 300.5z' />
      <path fill='#eee' d='M0 178h512v33.5H0zm0 122.5h512V334H0z' />
    </g>
  </svg>
)

// Belarus
const ByFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M0 0h155.8l35 254.6-35 257.4H0z' />
      <path fill='#a2001d' d='M155.8 0H512v345.1l-183 37.4-173.2-37.4z' />
      <path fill='#6da544' d='M155.8 345.1H512V512H155.8z' />
      <path
        fill='#a2001d'
        d='M50 .2 22.3 50l27.8 50.4L77.9 50zm55.8 0L78 50l27.7 50.4 28-50.4zM50 137.5l-27.7 49.6 27.8 50.5 27.7-50.5zm55.8 0L78 187.1l27.7 50.5 28-50.5zM50 274.7l-27.7 49.7 27.8 50.4 27.8-50.4zm55.8 0L78 324.4l27.7 50.4 28-50.4zM50 412l-27.7 49.6 27.8 50.5 27.7-50.5zm55.8 0L78 461.6l27.7 50.5 28-50.5z'
      />
    </g>
  </svg>
)

// Belize
const BzFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='m0 44.5 257.8-23.7L512 44.5v423l-252.5 26L0 467.5z' />
      <circle cx='256' cy='256' r='122.4' fill='#eee' />
      <circle cx='256' cy='256' r='100.2' fill='#6da544' />
      <circle cx='256' cy='256' r='66.8' fill='#eee' />
      <path fill='#0052b4' d='M256 239.3 219.8 256v27.8l36.2 22.3 36.2-22.3V256z' />
      <path fill='#ffda44' d='M219.8 222.6h72.4V256h-72.4z' />
      <path fill='#a2001d' d='M0 0h512v44.5H0zm0 467.5h512V512H0z' />
    </g>
  </svg>
)

// Canada
const CaFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 0v512h144l112-64 112 64h144V0H368L256 64 144 0Z' />
      <path fill='#eee' d='M144 0h224v512H144Z' />
      <path
        fill='#d80027'
        d='m301 289 44-22-22-11v-22l-45 22 23-44h-23l-22-34-22 33h-23l23 45-45-22v22l-22 11 45 22-12 23h45v33h22v-33h45z'
      />
    </g>
  </svg>
)

// Cocos Islands
const CcFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#6da544' d='M0 0h512v512H0z' />
      <g fill='#ffda44'>
        <path d='m393 367.3 7 14.7 15.9-3.7-7.1 14.7 12.7 10-15.9 3.7V423L393 412.8 380.3 423v-16.3l-15.9-3.6 12.8-10.1-7.1-14.7L386 382zm-65.4-155.8 7 14.7 16-3.7-7.2 14.7 12.8 10-16 3.6.1 16.3-12.7-10.2-12.7 10.2v-16.3l-15.8-3.5 12.7-10.1-7-14.7 15.8 3.7zm65.4-89 7 14.6 15.9-3.6-7.1 14.6 12.7 10.1-15.9 3.6v16.3L393 167.9l-12.7 10.2v-16.3l-15.9-3.6 12.8-10-7.1-14.7L386 137zm57 66.7 7 14.7 16-3.7-7.1 14.7 12.7 10.1-15.9 3.6v16.3l-12.6-10.2-12.7 10.2v-16.3l-15.9-3.6 12.8-10.1-7.1-14.7L443 204zm-40.8 78 5.6 17h17.9l-14.5 10.4 5.5 17-14.5-10.5-14.4 10.6 5.5-17-14.5-10.6h18z' />
        <path d='M283.8 328.3a72.3 72.3 0 1 1 34.4-136 89 89 0 1 0 0 127.3 72 72 0 0 1-34.4 8.7zM161 100.2a44.5 44.5 0 0 0-77.1 0h77zm.1.2-38.7 38.7-38.7-38.7a44.3 44.3 0 0 0-5.8 22 44.5 44.5 0 1 0 89 0 44.3 44.3 0 0 0-5.8-22z' />
      </g>
      <path
        fill='#a2001d'
        d='M111.3 128v37.6a44.6 44.6 0 0 0 11.1 1.4c3.9 0 7.6-.5 11.2-1.4V128h-22.3z'
      />
    </g>
  </svg>
)

// Congo (the Democratic Republic)
const CdFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#338af3' d='M0 0h401.9L512 110.3V512H110.3L0 401.9z' />
      <path fill='#ffda44' d='M401.9 0 0 401.9V449l63 63h47.3L512 110.3V63L449 0z' />
      <path fill='#d80027' d='M449 0 0 449v63h63L512 63V0h-63z' />
      <path
        fill='#ffda44'
        d='m136.4 78 13.8 42.4H195l-36 26.3 13.7 42.5-36.2-26.3-36 26.3 13.7-42.5L78 120.4h44.7z'
      />
    </g>
  </svg>
)

// Central African Republic
const CfFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ffda44' d='m0 378.4 252.9-28.8L512 378.4V512H322.8L256 481l-66.8 31H0z' />
      <path fill='#6da544' d='m0 256 249.8-28L512 256v122.4H0z' />
      <path fill='#eee' d='m0 133.6 255.3-28.3L512 133.6V256H0z' />
      <path fill='#0052b4' d='M0 0h189.2L256 30l66.8-30H512v133.6H0z' />
      <path
        fill='#ffda44'
        d='m137.7 55.7 6.9 21.2H167L148.9 90l6.9 21.3-18.1-13.1-18 13.1 6.8-21.3-18-13h22.3z'
      />
      <path fill='#d80027' d='M189.2 0h133.6v512H189.2z' />
    </g>
  </svg>
)

// Congo
const CgFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ffda44' d='M384 0h128v128L352 352 128 512H0V384l160-224Z' />
      <path fill='#6da544' d='M0 384 384 0H0Z' />
      <path fill='#d80027' d='M512 128 128 512h384z' />
    </g>
  </svg>
)

// Switzerland
const ChFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 0h512v512H0z' />
      <path fill='#eee' d='M389.6 211.5h-89v-89h-89.1v89h-89v89h89v89h89v-89h89z' />
    </g>
  </svg>
)

// Cote d'Ivoire
const CiFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M167 0h178l31 253.2L345 512H167l-33.4-257.4z' />
      <path fill='#ff9811' d='M0 0h167v512H0z' />
      <path fill='#6da544' d='M345 0h167v512H345z' />
    </g>
  </svg>
)

// Cook Islands
const CkFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M256 0h256v512H0V256Z' />
      <path
        fill='#eee'
        d='M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z'
      />
      <path fill='#d80027' d='M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z' />
      <path
        fill='#eee'
        d='m345 256 4.8 14.6H365l-12.4 9 4.7 14.6-12.4-9-12.4 9 4.8-14.6-12.4-9h15.3zm-63 26 13.7 7 10.9-10.8-2.4 15.1 13.6 7-15.1 2.4-2.4 15.1-7-13.6-15.1 2.4 10.8-10.9zm-26 63 14.6-4.7V325l9 12.4 14.6-4.8-9 12.4 9 12.4-14.6-4.7-9 12.4v-15.3zm26 63 7-13.6-10.8-10.9 15.1 2.4 7-13.6 2.4 15 15.1 2.5-13.6 7 2.4 15-10.9-10.8zm63 26-4.7-14.5H325l12.4-9-4.8-14.6 12.4 9 12.4-9-4.7 14.6 12.4 9h-15.3zm63-26-13.6-7-10.9 10.9 2.4-15.2-13.6-7 15-2.3 2.5-15.1 7 13.6 15-2.4-10.8 10.9zm26-63-14.5 4.8V365l-9-12.4-14.6 4.7 9-12.4-9-12.4 14.6 4.8 9-12.4v15.3zm-26-63-7 13.7 10.9 10.9-15.2-2.4-7 13.6-2.3-15.1-15.1-2.4 13.6-7-2.4-15.1 10.9 10.8z'
      />
    </g>
  </svg>
)

// Chile
const ClFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='m0 256 254.5-51.3L512 256v256H0z' />
      <path fill='#0052b4' d='M0 0h256l52.7 132.8L256 256H0z' />
      <path
        fill='#eee'
        d='M256 0h256v256H256zM152.4 89l16.6 51h53.6l-43.4 31.6 16.6 51-43.4-31.5-43.4 31.5 16.6-51L82.2 140h53.6z'
      />
    </g>
  </svg>
)

// Cameroon
const CmFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M144.8 0h222.4l32 260-32 252H144.8l-32.1-256z' />
      <path
        fill='#ffda44'
        d='m256.1 167 22.1 68h71.5L292 277l22 68-57.8-42-57.9 42 22.1-68-57.8-42H234z'
      />
      <path fill='#496e2d' d='M0 0h144.8v512H0z' />
      <path fill='#ffda44' d='M367.2 0H512v512H367.2z' />
    </g>
  </svg>
)

// China
const CnFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 0h512v512H0z' />
      <path
        fill='#ffda44'
        d='m140.1 155.8 22.1 68h71.5l-57.8 42.1 22.1 68-57.9-42-57.9 42 22.2-68-57.9-42.1H118zm163.4 240.7-16.9-20.8-25 9.7 14.5-22.5-16.9-20.9 25.9 6.9 14.6-22.5 1.4 26.8 26 6.9-25.1 9.6zm33.6-61 8-25.6-21.9-15.5 26.8-.4 7.9-25.6 8.7 25.4 26.8-.3-21.5 16 8.6 25.4-21.9-15.5zm45.3-147.6L370.6 212l19.2 18.7-26.5-3.8-11.8 24-4.6-26.4-26.6-3.8 23.8-12.5-4.6-26.5 19.2 18.7zm-78.2-73-2 26.7 24.9 10.1-26.1 6.4-1.9 26.8-14.1-22.8-26.1 6.4 17.3-20.5-14.2-22.7 24.9 10.1z'
      />
    </g>
  </svg>
)

// Colombia
const CoFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='m0 384 255.8-29.7L512 384v128H0z' />
      <path fill='#0052b4' d='m0 256 259.5-31L512 256v128H0z' />
      <path fill='#ffda44' d='M0 0h512v256H0z' />
    </g>
  </svg>
)

// Costa Rica
const CrFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M0 0h512v89l-66.3 167.5L512 423v89H0v-89l69.7-167.3L0 89z' />
      <path fill='#eee' d='M0 89h512v78l-39.7 91.1L512 345v78H0v-78l36.3-85.6L0 167z' />
      <path fill='#d80027' d='M0 167h512v178H0z' />
    </g>
  </svg>
)

// Cuba
const CuFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#0052b4'
        d='M0 0h512v102.4L483.8 151l28.2 53.8v102.4l-30.5 50.7 30.5 51.7V512H0l39.8-257z'
      />
      <path fill='#ff9811' d='M0 44.5v423V256z' />
      <path fill='#eee' d='M27.2 102.4v102.4H512V102.4H27.2zm0 204.8v102.4H512V307.2H27.2z' />
      <path fill='#d80027' d='M0 0v512l256-256L0 0z' />
      <path
        fill='#eee'
        d='m103.6 189.2 16.6 51h53.6l-43.4 31.6 16.6 51-43.4-31.5-43.4 31.5 16.6-51-43.4-31.6H87z'
      />
    </g>
  </svg>
)

// Cabo Verde
const CvFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M0 0h512v256.2l-41.9 64.3 41.9 63.7V512H0V384.2L41.3 320 0 256.2z' />
      <path fill='#eee' d='M0 256.2h512v42.9l-15.7 21.6 15.7 21v42.5H0v-42.5l15.1-21.5L0 299z' />
      <path fill='#d80027' d='M0 299.1h512v42.6H0z' />
      <path
        fill='#ffda44'
        d='m182.8 190.4 5.2 16.4h17.1l-13.8 10 5.3 16.3-13.8-10-14 10 5.4-16.3-13.9-10h17.1zm0 213.3L188 420h17.1l-13.8 10 5.3 16.2-13.8-10-14 10L174 430l-14-10h17.2zm-99.2-72.1 5.2 16.2h17.1L92.1 358l5.2 16.2-13.7-10-14 10L75 358l-14-10.1h17.2zm37.9-119.8 5 16h17.2l-13.8 10.3 5.2 16.2-13.7-10-14 10 5.4-16.3-14-10.1H116zm-60.4 67h17l5.5-16.2 5.2 16.2h17.1L92.1 289l5.2 16.4L83.6 295l-14 10.3 5.4-16.4zm46.5 143 5.3-16.2L99 395.4h17.1l5.4-16.2 5.2 16.3h17.1L130 405.6l5.3 16.2-13.8-10zM282 331.6l-5.4 16.2h-17l13.8 10.2-5.3 16.2 13.9-10 13.8 10-5.2-16.3 13.7-10.1h-17zm-38-119.8-5.3 16.2h-17.1l14 10.2-5.4 16.2 13.9-10 13.8 10-5.3-16.3 13.8-10.1h-17zm60.3 67h-17l-5.3-16.2-5.4 16.2h-17l13.8 10.1-5.3 16.4L282 295l13.8 10.3-5.2-16.4zm-46.4 143-5.3-16.2 13.8-10.2h-17l-5.3-16.2-5.4 16.3h-17.1l14 10.1-5.4 16.2 13.9-10z'
      />
    </g>
  </svg>
)

// Curaçao
const CwFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M0 0h512v342.3l-22 34.2 22 32.5v103H0V409l25.4-31L0 342.2z' />
      <path
        fill='#eee'
        d='m175.2 164.2 13.8 42.5h44.7L197.6 233l13.8 42.5-36.2-26.3-36.1 26.3 13.8-42.5-36.2-26.3h44.7zm-76.7-44.5 8.2 25.5h26.9L111.9 161l8.3 25.5-21.7-15.7-21.7 15.7L85 161l-21.7-15.7h26.9z'
      />
      <path fill='#ffda44' d='M0 342.3h512V409H0z' />
    </g>
  </svg>
)

// Christmas Island
const CxFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#6da544' d='m0 0 216.9 301.6L512 512V0z' />
      <path fill='#0052b4' d='m0 0 512 512H0z' />
      <circle cx='256' cy='256' r='66.8' fill='#ffda44' />
      <path
        fill='#eee'
        d='m95.3 367.3 7 14.7 16-3.7L111 393l13 10-16 3.6.1 16.3-12.7-10.2L82.6 423v-16.3L66.9 403l12.6-10-7-14.7 15.8 3.7zM49.3 245l7.1 14.7 15.9-3.7-7.1 14.6 12.7 10.2-15.9 3.5v16.3l-12.6-10.2-12.7 10.2v-16.3l-15.9-3.5 12.8-10.2-7.1-14.6 15.8 3.7zm46-100.2 7 14.7 16-3.7-7.2 14.7 12.8 10-16 3.7.1 16.2-12.7-10.1-12.7 10.1v-16.2l-15.8-3.6 12.7-10.1-7-14.7 15.8 3.7zm57.1 78 7 14.6 15.9-3.7-7.1 14.7 12.7 10.1-15.8 3.6v16.3L152.4 268l-12.7 10.2V262l-15.8-3.6 12.7-10.1-7-14.7 15.8 3.7zm-40.8 66.7 5.5 17H135L120.5 317l5.6 17-14.5-10.5L97 333.9l5.6-17-14.5-10.5H106z'
      />
      <path
        fill='#6da544'
        d='M256 300.5h22.3s9.6-17 0-33.4l22.2-22.2-11.1-22.3h-11.1s-5.6 16.7-27.9 16.7-27.8-16.7-27.8-16.7h-11.1l11.1 22.3-11.1 22.2 11.1 11.2S233.7 256 256 267c0 0 9.5 14 0 33.4z'
      />
      <path
        fill='#ffda44'
        d='M422.2 140.2a44.7 44.7 0 0 0-30-50.8 83.1 83.1 0 0 1 7.5 49.9 45.6 45.6 0 0 0-10.4-11.6 45.7 45.7 0 0 0-53.7-2.4 85.3 85.3 0 0 1 35 16.7c8.3 6.6 15 15.5 20.2 24.1l-68 21.3c66.8 11.2 122.4-33.4 122.4-33.4-6.1-12.3-15.7-14.4-23-13.8z'
      />
    </g>
  </svg>
)

// Cyprus
const CyFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M0 0h512v512H0z' />
      <path
        fill='#6da544'
        d='M400.7 222.6h-33.4a111.3 111.3 0 0 1-222.6 0h-33.4c0 66.2 44.5 122 105.2 139.2a37 37 0 0 0 3.9 40.5l36.3-29.2 36.4 29.2a37 37 0 0 0 3.7-40.8 144.8 144.8 0 0 0 103.9-138.9z'
      />
      <path
        fill='#ffda44'
        d='M167 211.5s0 55.6 55.6 55.6l11.1 11.2H256s11.1-33.4 33.4-33.4c0 0 0-22.3 22.3-22.3H345s-11-44.5 44.6-77.9l-22.3-11.1s-78 55.6-133.6 44.5v22.2h-22.2l-11.2-11-33.3 22.2z'
      />
    </g>
  </svg>
)

// Czech Republic
const CzFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M0 0h512v256l-265 45.2z' />
      <path fill='#d80027' d='M210 256h302v256H0z' />
      <path fill='#0052b4' d='M0 0v512l256-256L0 0z' />
    </g>
  </svg>
)

// Germany
const DeFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ffda44' d='m0 345 256.7-25.5L512 345v167H0z' />
      <path fill='#d80027' d='m0 167 255-23 257 23v178H0z' />
      <path fill='#333' d='M0 0h512v167H0z' />
    </g>
  </svg>
)

// Djibouti
const DjFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#338af3' d='M0 0h512v256l-153.2 35.7L210 256z' />
      <path fill='#6da544' d='M210 256h302v256H0z' />
      <path fill='#eee' d='M0 0v512l256-256z' />
      <path
        fill='#d80027'
        d='m103.6 189.2 16.6 51h53.6l-43.4 31.6 16.6 51-43.4-31.5-43.4 31.5 16.6-51-43.4-31.6H87z'
      />
    </g>
  </svg>
)

// Denmark
const DkFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#d80027'
        d='M0 0h133.6l32.7 20.3 34-20.3H512v222.6L491.4 256l20.6 33.4V512H200.3l-31.7-20.4-35 20.4H0V289.4l29.4-33L0 222.7z'
      />
      <path fill='#eee' d='M133.6 0v222.6H0v66.8h133.6V512h66.7V289.4H512v-66.8H200.3V0h-66.7z' />
    </g>
  </svg>
)

// Dominica
const DmFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#496e2d'
        d='M0 0h208l48 32 48-32h208v208l-32 48 32 48v208H304l-48-32-48 32H0V304l32-48-32-48Z'
      />
      <path fill='#333' d='M512 240v32l-256 32L0 272v-32l256-32z' />
      <path fill='#ffda44' d='M512 208v32H0v-32z' />
      <path fill='#333' d='M240 0h32l32 256-32 256h-32l-32-256Z' />
      <path fill='#ffda44' d='M208 0h32v512h-32z' />
      <path fill='#eee' d='M272 0h32v512h-32z' />
      <path fill='#eee' d='M512 272v32H0v-32z' />
      <circle cx='256' cy='256' r='122.4' fill='#d80027' />
      <path
        fill='#496e2d'
        d='M284 270c-9-19-21-37-21-37v-13a14 14 0 0 0-27-2 11 11 0 0 0-4 21 16 16 0 0 1 9-9 14 14 0 0 0 2 2h2s-7 19-7 29c0 27 19 36 19 36l-10 9h19v-18l9 9s17-11 9-27zm-28-114 4 13h14l-11 8 4 12-11-8-11 8 4-12-11-8h14Zm-59 19 11 8 11-8-4 13 11 8h-14l-4 12-4-12h-14l11-8zm-36 50h13l4-13 4 13h14l-11 8 4 13-11-8-11 8 5-13zm0 62 11-8-5-13 11 8 11-8-4 13 11 8h-14l-4 13-4-13Zm36 50 4-13-11-8h14l4-12 4 12h13l-10 8 4 13-11-8zm59 19-4-13h-14l11-8-4-12 11 8 11-8-4 12 11 9h-14Zm59-19-11-8-11 8 4-13-10-8h13l4-12 4 12h14l-11 8zm36-50h-13l-4 13-4-13h-14l11-8-4-13 11 8 11-8-5 13zm0-62-11 8 5 13-11-8-11 8 4-13-11-8h14l4-13 4 13zm-36-50-4 13 11 8h-14l-4 12-4-12h-14l11-8-4-13 11 8z'
      />
    </g>
  </svg>
)

// Dominican Republic
const DoFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M35.5 256h444l32.5-66.8V0H322.8L256 31.8v444.6L189.2 512H0V322.8z' />
      <path
        fill='#0052b4'
        d='M479.5 256h-444L0 189.2V0h189.2L256 31.8v444.6l66.8 35.6H512V322.8z'
      />
      <path fill='#eee' d='M189.2 0h133.6v189.2H512v133.6H322.8V512H189.2V322.8H0V189.2h189.2z' />
      <path
        fill='#496e2d'
        d='M322.8 256a66.8 66.8 0 1 1-133.6 0c0-36.9 66.8-66.8 66.8-66.8s66.8 30 66.8 66.8z'
      />
      <path fill='#0052b4' d='M189.2 256a66.8 66.8 0 1 1 133.6 0' />
      <path fill='#d80027' d='M218.4 222.6v41.7a37.6 37.6 0 1 0 75.2 0v-41.7z' />
    </g>
  </svg>
)

// Algeria
const DzFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#496e2d' d='M0 0h256l45.3 251.8L256 512H0z' />
      <path fill='#eee' d='M256 0h256v512H256z' />
      <g fill='#d80027'>
        <path d='m311 206.9-21 29-34-11 21 28.8-21 29 34-11.1 21 29v-35.8l34-11.1-34-11z' />
        <path d='M277.2 328.3a72.3 72.3 0 1 1 34.5-136 89 89 0 1 0 0 127.3 72 72 0 0 1-34.5 8.7z' />
      </g>
    </g>
  </svg>
)

// Ecuador
const EcFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='m0 384 254.7-32.7L512 383.9V512H0z' />
      <path fill='#0052b4' d='m0 256 255-27 257 27v128H0z' />
      <path fill='#ffda44' d='M0 0h512v256H0z' />
      <circle cx='256' cy='256' r='89' fill='#ffda44' />
      <path
        fill='#338af3'
        d='M256 311.6c-30.7 0-55.7-25-55.7-55.6v-33.4a55.7 55.7 0 0 1 111.4 0V256c0 30.6-25 55.6-55.7 55.6z'
      />
      <path
        fill='#333'
        d='M345 122.4h-66.7a22.3 22.3 0 0 0-44.6 0H167a23 23 0 0 0 23 22.3h-.8c0 12.3 10 22.3 22.3 22.3 0 12.3 10 22.2 22.2 22.2h44.6c12.3 0 22.2-10 22.2-22.2 12.3 0 22.3-10 22.3-22.3h-.8a23 23 0 0 0 23-22.3z'
      />
    </g>
  </svg>
)

// Estonia
const EeFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#333' d='m0 167 254.6-36.6L512 166.9v178l-254.6 36.4L0 344.9z' />
      <path fill='#0052b4' d='M0 0h512v166.9H0z' />
      <path fill='#eee' d='M0 344.9h512V512H0z' />
    </g>
  </svg>
)

// Egypt
const EgFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='m0 144 256-32 256 32v224l-256 32L0 368Z' />
      <path fill='#d80027' d='M0 0h512v144H0Z' />
      <path fill='#333' d='M0 368h512v144H0Z' />
      <path
        fill='#ff9811'
        d='M250 191c-8 0-17 4-22 14 5-3 16-1 16 13 0 4-2 8-5 10-8 0-14-14-29-14-10 0-19 7-19 17v69l46-7-14 27h66l-14-27 46 7v-69c0-10-9-17-19-17-15 0-21 14-29 14 8-23-7-37-23-37z'
      />
    </g>
  </svg>
)

// Western Sahara
const EhFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='m90.1 144.8 210.5-27.7L512 144.8v222.6l-209 32.4-213-32.4z' />
      <path fill='#333' d='M0 0h512v144.8H28.2z' />
      <path fill='#496e2d' d='M39.5 367.4H512V512H0z' />
      <path
        fill='#d80027'
        d='M0 .1V512h.1L256 256.1 0 .1zm365.1 178.1a78 78 0 1 0 18.9 154 78 78 0 0 1 0-152.2 78.2 78.2 0 0 0-18.9-1.8z'
      />
      <path
        fill='#d80027'
        d='m387.3 206.1 11 34h35.8l-29 21 11.1 34-29-21-28.9 21 11.1-34-29-21h35.8z'
      />
    </g>
  </svg>
)

// Eritrea
const ErFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#6da544' d='M0 0h512v256H62z' />
      <path fill='#338af3' d='M62 256h450v256H0z' />
      <path fill='#d80027' d='M0 0v512l512-256z' />
      <path
        fill='#ffda44'
        d='M133.6 150.3c-49.1 0-89 40-89 89v33.4a89.1 89.1 0 0 0 178 0v-33.4c0-49-40-89-89-89zm55.6 122.4c0 24.9-16.4 46-39 53v-36.3l23.7-23.6-23.6-23.6v-19.6h-33.4V256l-23.6 23.6 23.6 23.6v22.6a55.7 55.7 0 0 1-39-53.1v-33.4a55.7 55.7 0 0 1 111.3 0z'
      />
    </g>
  </svg>
)

// Spain
const EsFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ffda44' d='m0 128 256-32 256 32v256l-256 32L0 384Z' />
      <path fill='#d80027' d='M0 0h512v128H0zm0 384h512v128H0z' />
      <g fill='#eee'>
        <path d='M144 304h-16v-80h16zm128 0h16v-80h-16z' />
        <ellipse cx='208' cy='296' rx='48' ry='32' />
      </g>
      <g fill='#d80027'>
        <rect width='16' height='24' x='128' y='192' rx='8' />
        <rect width='16' height='24' x='272' y='192' rx='8' />
        <path d='M208 272v24a24 24 0 0 0 24 24 24 24 0 0 0 24-24v-24h-24z' />
      </g>
      <rect width='32' height='16' x='120' y='208' fill='#ff9811' ry='8' />
      <rect width='32' height='16' x='264' y='208' fill='#ff9811' ry='8' />
      <rect width='32' height='16' x='120' y='304' fill='#ff9811' rx='8' />
      <rect width='32' height='16' x='264' y='304' fill='#ff9811' rx='8' />
      <path
        fill='#ff9811'
        d='M160 272v24c0 8 4 14 9 19l5-6 5 10a21 21 0 0 0 10 0l5-10 5 6c6-5 9-11 9-19v-24h-9l-5 8-5-8h-10l-5 8-5-8z'
      />
      <path d='M122 252h172m-172 24h28m116 0h28' />
      <path
        fill='#d80027'
        d='M122 248a4 4 0 0 0-4 4 4 4 0 0 0 4 4h172a4 4 0 0 0 4-4 4 4 0 0 0-4-4zm0 24a4 4 0 0 0-4 4 4 4 0 0 0 4 4h28a4 4 0 0 0 4-4 4 4 0 0 0-4-4zm144 0a4 4 0 0 0-4 4 4 4 0 0 0 4 4h28a4 4 0 0 0 4-4 4 4 0 0 0-4-4z'
      />
      <path
        fill='#eee'
        d='M196 168c-7 0-13 5-15 11l-5-1c-9 0-16 7-16 16s7 16 16 16c7 0 13-4 15-11a16 16 0 0 0 17-4 16 16 0 0 0 17 4 16 16 0 1 0 10-20 16 16 0 0 0-27-5c-3-4-7-6-12-6zm0 8c5 0 8 4 8 8 0 5-3 8-8 8-4 0-8-3-8-8 0-4 4-8 8-8zm24 0c5 0 8 4 8 8 0 5-3 8-8 8-4 0-8-3-8-8 0-4 4-8 8-8zm-44 10 4 1 4 8c0 4-4 7-8 7s-8-3-8-8c0-4 4-8 8-8zm64 0c5 0 8 4 8 8 0 5-3 8-8 8-4 0-8-3-8-7l4-8z'
      />
      <path fill='none' d='M220 284v12c0 7 5 12 12 12s12-5 12-12v-12z' />
      <path fill='#ff9811' d='M200 160h16v32h-16z' />
      <path fill='#eee' d='M208 224h48v48h-48z' />
      <path
        fill='#d80027'
        d='m248 208-8 8h-64l-8-8c0-13 18-24 40-24s40 11 40 24zm-88 16h48v48h-48z'
      />
      <rect width='20' height='32' x='222' y='232' fill='#d80027' rx='10' ry='10' />
      <path fill='#ff9811' d='M168 232v8h8v16h-8v8h32v-8h-8v-16h8v-8zm8-16h64v8h-64z' />
      <g fill='#ffda44'>
        <circle cx='186' cy='202' r='6' />
        <circle cx='208' cy='202' r='6' />
        <circle cx='230' cy='202' r='6' />
      </g>
      <path
        fill='#d80027'
        d='M169 272v43a24 24 0 0 0 10 4v-47h-10zm20 0v47a24 24 0 0 0 10-4v-43h-10z'
      />
      <g fill='#338af3'>
        <circle cx='208' cy='272' r='16' />
        <rect width='32' height='16' x='264' y='320' ry='8' />
        <rect width='32' height='16' x='120' y='320' ry='8' />
      </g>
    </g>
  </svg>
)

// Ethiopia
const EtFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='m0 345 255.7-31L512 345v167H0z' />
      <path fill='#ffda44' d='m0 167 258-40.7L512 167v178H0z' />
      <path fill='#6da544' d='M0 0h512v167H0z' />
      <circle cx='256' cy='256' r='122.4' fill='#0052b4' />
      <g fill='#ffda44'>
        <path d='m256 161.2 22 68h71.7l-58 42 22.3 68.3-58-42.3-58 42.2 22.2-68.1-58-42H234z' />
        <path d='m344.1 273-70-22.9 43.2-59.6-18-13L256 237l-43.3-59.7-18 13.1 43.3 59.7-70.1 22.7 6.9 21.2 70-22.8V345h22.3v-73.7l70.1 22.8z' />
      </g>
    </g>
  </svg>
)

// European Union
const EuFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M0 0h512v512H0z' />
      <path
        fill='#ffda44'
        d='m256 100.2 8.3 25.5H291l-21.7 15.7 8.3 25.6-21.7-15.8-21.7 15.8 8.3-25.6-21.7-15.7h26.8zm-110.2 45.6 24 12.2 18.9-19-4.2 26.5 23.9 12.2-26.5 4.2-4.2 26.5-12.2-24-26.5 4.3 19-19zM100.2 256l25.5-8.3V221l15.7 21.7 25.6-8.3-15.8 21.7 15.8 21.7-25.6-8.3-15.7 21.7v-26.8zm45.6 110.2 12.2-24-19-18.9 26.5 4.2 12.2-23.9 4.2 26.5 26.5 4.2-24 12.2 4.3 26.5-19-19zM256 411.8l-8.3-25.5H221l21.7-15.7-8.3-25.6 21.7 15.8 21.7-15.8-8.3 25.6 21.7 15.7h-26.8zm110.2-45.6-24-12.2-18.9 19 4.2-26.5-23.9-12.2 26.5-4.2 4.2-26.5 12.2 24 26.5-4.3-19 19zM411.8 256l-25.5 8.3V291l-15.7-21.7-25.6 8.3 15.8-21.7-15.8-21.7 25.6 8.3 15.7-21.7v26.8zm-45.6-110.2-12.2 24 19 18.9-26.5-4.2-12.2 23.9-4.2-26.5-26.5-4.2 24-12.2-4.3-26.5 19 19z'
      />
    </g>
  </svg>
)

// Finland
const FiFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#eee'
        d='M0 0h133.6l35.3 16.7L200.3 0H512v222.6l-22.6 31.7 22.6 35.1V512H200.3l-32-19.8-34.7 19.8H0V289.4l22.1-33.3L0 222.6z'
      />
      <path
        fill='#0052b4'
        d='M133.6 0v222.6H0v66.8h133.6V512h66.7V289.4H512v-66.8H200.3V0h-66.7z'
      />
    </g>
  </svg>
)

// Fiji
const FjFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#338af3' d='M256 0h256v512H0V256Z' />
      <path
        fill='#eee'
        d='M0 0v32l32 32L0 96v160h32l32-32 32 32h32l42-16 41 16h45l-8-16 8-15v-14l-16-42 16-41V96l-32-32 32-32V0H96L64 32 32 0Z'
      />
      <path fill='#0052b4' d='M128 256v-83l83 83zm128-45-83-83h83z' />
      <path
        fill='#eee'
        d='m367.3 144.7-78 22.3h.1v66.7l9.2 11-9.2 11.3c0 45.5 45.3 67 66.8 74.6l11.5-8.8 10.7 8.8c21.5-7.7 66.8-29.1 66.8-74.6l-8-11 8-11.3V167Z'
      />
      <path
        fill='#d80027'
        d='M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97zm317.2 39v-33.4H289.4V167h66.8v66.7h-66.8V256h66.8v74.6a111 111 0 0 0 11.1 3.4s4.4-1 11.1-3.4V256h66.8v-22.3h-66.8V167Z'
      />
    </g>
  </svg>
)

// Falkland Islands
const FkFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M256 0h256v512H0V256Z' />
      <path
        fill='#eee'
        d='M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z'
      />
      <path fill='#d80027' d='M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z' />
      <path
        fill='#ffda44'
        d='M411.8 300.5v11.2h-89v-11.2h-33.4V345h22.3v11.2H423V345h22.2v-44.5z'
      />
      <path fill='#338af3' d='M289.4 133.6V256c0 59.6 77.9 78 77.9 78s78-18.4 78-78V133.6h-156z' />
      <path
        fill='#eee'
        d='M367.3 224.9c-19.5 0-19.5 17.8-39 17.8s-19.4-17.8-39-17.8V256c19.6 0 19.6 17.8 39 17.8s19.5-17.8 39-17.8 19.5 17.8 39 17.8 19.4-17.8 39-17.8v-31.2c-19.6 0-19.6 17.8-39 17.8-19.5 0-19.5-17.8-39-17.8zm0-62.4c-19.5 0-19.5 17.8-39 17.8s-19.4-17.8-39-17.8v31.2c19.6 0 19.6 17.8 39 17.8s19.5-17.8 39-17.8 19.5 17.8 39 17.8 19.4-17.8 39-17.8v-31.2c-19.6 0-19.6 17.8-39 17.8-19.5 0-19.5-17.8-39-17.8z'
      />
    </g>
  </svg>
)

// Micronesia
const FmFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#338af3' d='M0 0h512v512H0z' />
      <path
        fill='#eee'
        d='m256 111.3 11 34h35.8l-29 21 11.1 34-28.9-21-29 21 11.1-34-29-21H245zM111.3 256l34-11v-35.8l21 29 34-11.1-21 28.9 21 29-34-11.1-21 29V267zM256 400.7l-11-34h-35.8l29-21-11.1-34 28.9 21 29-21-11.1 34 29 21H267zM400.7 256l-34 11v35.8l-21-29-34 11.1 21-28.9-21-29 34 11.1 21-29V245z'
      />
    </g>
  </svg>
)

// Faroe Islands
const FoFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#eee'
        d='M0 0h100.2l66.1 53.5L233.7 0H512v189.3L466.3 257l45.7 65.8V512H233.7l-68-50.7-65.5 50.7H0V322.8l51.4-68.5-51.4-65z'
      />
      <path
        fill='#0052b4'
        d='M100.2 0v189.3H0v33.4l24.6 33L0 289.5v33.4h100.2V512h33.4l30.6-26.3 36.1 26.3h33.4V322.8H512v-33.4l-24.6-33.7 24.6-33v-33.4H233.7V0h-33.4l-33.8 25.3L133.6 0z'
      />
      <path
        fill='#d80027'
        d='M133.6 0v222.7H0v66.7h133.6V512h66.7V289.4H512v-66.7H200.3V0h-66.7z'
      />
    </g>
  </svg>
)

// France
const FrFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M167 0h178l25.9 252.3L345 512H167l-29.8-253.4z' />
      <path fill='#0052b4' d='M0 0h167v512H0z' />
      <path fill='#d80027' d='M345 0h167v512H345z' />
    </g>
  </svg>
)

// Gabon
const GaFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ffda44' d='m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z' />
      <path fill='#6da544' d='M0 0h512v167H0z' />
      <path fill='#0052b4' d='M0 345h512v167H0z' />
    </g>
  </svg>
)

// England
const GbEngFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#eee'
        d='M0 0h208l48 32 48-32h208v208l-32 48 32 48v208H304l-48-32-48 32H0V304l32-48-32-48Z'
      />
      <path fill='#d80027' d='M208 0v208H0v96h208v208h96V304h208v-96H304V0h-96z' />
    </g>
  </svg>
)

// NI Nicaragua
const NiFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#338af3'
        d='M0 0h512v144.7l-41.4 111.7L512 367.3V512H0V367.3l41.5-107.9L0 144.7z'
      />
      <path fill='#eee' d='M0 144.7h512v222.6H0z' />
      <path
        fill='#ffda44'
        d='M256 178a78 78 0 1 0 0 156 78 78 0 0 0 0-156zm0 122.5a44.5 44.5 0 1 1 0-89 44.5 44.5 0 0 1 0 89z'
      />
      <path fill='#0052b4' d='M294.6 267.1 256 256l-38.6 11.1-12.8 22.3h102.8z' />
      <path fill='#338af3' d='M256 200.3 230.3 245l25.7 11 25.7-11.1z' />
      <path fill='#6da544' d='M217.4 267.1h77.2L281.7 245h-51.4z' />
    </g>
  </svg>
)

// Northern Ireland
const GbNirFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#eee'
        d='M0 0h224l32 32 32-32h224v224l-32 32 32 32v224H288l-32-32-32 32H0V288l32-32-32-32Z'
      />
      <path fill='#d80027' d='M224 0v224H0v64h224v224h64V288h224v-64H288V0Z' />
      <path fill='#acabb1' d='m256 104-44 76h-87l43 76-43 76h87l44 76 44-76h87l-43-76 43-76h-87z' />
      <path
        fill='#eee'
        d='m256 131-36 62h-73l37 63-37 63h73l36 63 36-63h73l-37-63 37-63h-73l-36-62z'
      />
      <path
        fill='#d80027'
        d='M259 195c-5 0-5 5-5 5v39h-3v-33s0-6-5-6c-6 0-6 6-6 6v35l-3 1v-25s0-6-5-6c-6 0-6 6-6 6v43c0 10 5 20 12 26v21h36v-17c9-5 16-14 18-25 0-6 2-11 4-16l4-14s1-5-4-7-7 3-7 3l-8 19h-3v-47s0-5-5-5c-6 0-6 5-6 5v36h-2v-39s0-5-6-5z'
      />
      <path
        fill='#ffda44'
        d='M245 38v11h-11v22h11v21c-6-6-14-9-22-9a33 33 0 0 0-23 57v20h112v-20c6-7 10-15 10-24a33 33 0 0 0-55-24V71h11V49h-11V38Z'
      />
    </g>
  </svg>
)

// Scotland
const GbSctFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M0 68 68 0h376l68 68v376l-68 68H68L0 444Z' />
      <path
        fill='#eee'
        d='M0 0v68l188 188L0 444v68h68l188-188 188 188h68v-68L324 256 512 68V0h-68L256 188 68 0H0z'
      />
    </g>
  </svg>
)

// Wales
const GbWlsFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#6da544' d='m0 256 256-64 256 64v256H0Z' />
      <path fill='#eee' d='M0 0h512v256H0Z' />
      <path
        fill='#d80027'
        d='M166 149c-12 0-21 9-21 21h-14c-19 0-35 15-35 34h25c3 8 10 14 17 14h7v48l2 14-16 5c-1-15-13-26-27-26-4 0-8 3-8 6v56c0 4 4 7 8 7l12-3 56-15c6 3 14 5 22 5h6v14h-13c-16 0-28 12-28 27 0 4 3 7 7 7h62c4 0 7-3 7-7v-41l9-1h49l9 15h-5c-15 0-27 12-27 27 0 4 3 7 7 7h69c4 0 7-3 7-7 0-6-2-11-5-16l-15-26h23c29 0 52-23 52-52v-3l8 2h6c3-3 4-7 2-10l-28-40-1-1c-3-2-8-2-10 1l-27 40c-1 2-2 4-1 6 1 4 5 6 9 5l8-3v3c0 10-8 18-18 18h-37c12-12 22-26 28-41l25-57 1-5c0-8-6-14-14-14h-95c-15 0-28 12-28 27v17a11 11 0 1 1-22 0v-31c12-4 21-14 21-27h-41z'
      />
    </g>
  </svg>
)

// United Kingdom
const GbFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#eee'
        d='m0 0 8 22-8 23v23l32 54-32 54v32l32 48-32 48v32l32 54-32 54v68l22-8 23 8h23l54-32 54 32h32l48-32 48 32h32l54-32 54 32h68l-8-22 8-23v-23l-32-54 32-54v-32l-32-48 32-48v-32l-32-54 32-54V0l-22 8-23-8h-23l-54 32-54-32h-32l-48 32-48-32h-32l-54 32L68 0H0z'
      />
      <path
        fill='#0052b4'
        d='M336 0v108L444 0Zm176 68L404 176h108zM0 176h108L0 68ZM68 0l108 108V0Zm108 512V404L68 512ZM0 444l108-108H0Zm512-108H404l108 108Zm-68 176L336 404v108z'
      />
      <path
        fill='#d80027'
        d='M0 0v45l131 131h45L0 0zm208 0v208H0v96h208v208h96V304h208v-96H304V0h-96zm259 0L336 131v45L512 0h-45zM176 336 0 512h45l131-131v-45zm160 0 176 176v-45L381 336h-45z'
      />
    </g>
  </svg>
)

// Grenada
const GdFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ffda44' d='M23.6 23.7h464.8v464.7H23.6z' />
      <path
        fill='#496e2d'
        d='M0 75.1 38 38l436.3 436.4 37.7-37.5V75l-39.6-35.5L40.2 471.8 0 436.8z'
      />
      <circle cx='256' cy='256.1' r='89' fill='#a2001d' />
      <path
        fill='#ffda44'
        d='m256 167 20 61.5h64.6l-52.3 38 20 61.3-52.3-38-52.3 38 20-61.3-52.3-38H236zM256 .2z'
      />
      <path fill='#a2001d' d='M0 0h512v75.1H0zm0 436.8h512v75.1H0z' />
      <path
        fill='#ffda44'
        d='m256 28 4.1 12.7h13.5l-10.9 8 4.2 12.6-10.9-7.9-10.8 8 4.1-12.8-10.9-8H252zm-62 0 4 12.7h13.5l-10.9 8 4.2 12.6-10.9-7.9-10.8 8 4.1-12.8-10.8-8h13.4zm124 0 4.2 12.7h13.4l-10.8 8 4.1 12.6-10.8-7.9-10.9 8 4.2-12.8-10.9-8H314zm-62 422.8 4.1 12.7h13.5l-10.9 8 4.2 12.7-10.9-8-10.8 8 4.1-12.8-10.9-7.9H252zm-62 0 4 12.7h13.5l-10.9 8 4.2 12.7-10.9-8-10.8 8 4.1-12.8-10.8-7.9h13.4zm124 0 4.2 12.7h13.4l-10.8 8 4.1 12.7-10.8-8-10.9 8 4.2-12.8-10.9-7.9H314zm-240-199a22.3 22.3 0 0 1-37.6 23.9c-12-18.8-5-49.5-5-49.5S66 233 78 251.9z'
      />
      <circle cx='65.1' cy='273.2' r='11.1' fill='#a2001d' />
    </g>
  </svg>
)

// Georgia
const GeFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#eee'
        d='M0 0h224l32 32 32-32h224v224l-32 32 32 32v224H288l-32-32-32 32H0V288l32-32-32-32Z'
      />
      <path
        fill='#d80027'
        d='M224 0v224H0v64h224v224h64V288h224v-64H288V0h-64zm-96 96v32H96v32h32v32h32v-32h32v-32h-32V96h-32zm224 0v32h-32v32h32v32h32v-32h32v-32h-32V96h-32zM128 320v32H96v32h32v32h32v-32h32v-32h-32v-32h-32zm224 0v32h-32v32h32v32h32v-32h32v-32h-32v-32h-32z'
      />
    </g>
  </svg>
)

// French Guiana
const GfFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#6da544' d='m0 0 216.9 301.6L512 512V0z' />
      <path fill='#ffda44' d='m0 0 512 512H0z' />
      <path fill='#d80027' d='m256 121 90 270-234-168h288L166 391z' />
    </g>
  </svg>
)

// Guernsey
const GgFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#eee'
        d='M0 0h222.6l31 23.4L289.4 0H512v222.6l-21.5 31 21.5 35.8V512H289.4l-34.2-20.5-32.6 20.5H0V289.4l22.7-32.6L0 222.6z'
      />
      <path fill='#d80027' d='M222.6 0v222.6H0v66.8h222.6V512h66.8V289.4H512v-66.8H289.4V0z' />
      <path
        fill='#ffda44'
        d='m328.3 267 16.7 11.3v-44.7L328.3 245h-61.2v-61.2l11.2-16.8h-44.6l11.2 16.8v61.1h-61.2L167 233.6v44.7l16.7-11.3h61.2v61.3l-11.2 16.6h44.6L267 328.3V267z'
      />
    </g>
  </svg>
)

// Ghana
const GhFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ffda44' d='m0 167 256-32 256 32v178l-256 32L0 345Z' />
      <path fill='#d80027' d='M0 0h512v167H0Z' />
      <path fill='#496e2d' d='M0 345h512v167H0Z' />
      <path fill='#333' d='m198 345 151-109H163l151 109-58-178Z' />
    </g>
  </svg>
)

// Gibraltar
const GiFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='m0 345 256.3-31.3L512 345v167H0z' />
      <path fill='#eee' d='M0 0h512v345H0z' />
      <path
        fill='#d80027'
        d='M356.2 211.5V178h11.1v-22.3H345V167h-22.2v-11.2h-22.3v22.3h11.2v33.4h-22.3v-78h11.1v-22.2h-22.2v11.1H267v-11h-22v11h-11.2v-11h-22.2v22.2h11.1v77.9h-22.3V178h11.2v-22.3h-22.3V167H167v-11.2h-22.3v22.3h11.1v33.4h-22.2v89h244.8v-89z'
      />
      <path
        fill='#ffda44'
        d='M256 289.4a33.4 33.4 0 0 0-11.1 64.9v46.4h-33.4v44.5H267v-91a33.4 33.4 0 0 0-11.1-64.8zm0 44.5a11.1 11.1 0 1 1 0-22.2 11.1 11.1 0 0 1 0 22.2z'
      />
    </g>
  </svg>
)

// Greenland
const GlFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='m0 256 259-45.3L512 256v256H0z' />
      <path fill='#eee' d='M0 0h512v256H0z' />
      <path fill='#eee' d='M55.7 256a122.4 122.4 0 1 0 244.8 0l-123-24z' />
      <path fill='#d80027' d='M55.7 256a122.4 122.4 0 1 1 244.8 0z' />
    </g>
  </svg>
)

// Gambia
const GmFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#eee'
        d='m0 155.8 255-30.6 257 30.6v33.4l-27.7 67.2 27.7 66.4v33.4l-256 32.4L0 356.2v-33.4l28.8-68.5L0 189.2z'
      />
      <path fill='#a2001d' d='M0 0h512v155.8H0z' />
      <path fill='#0052b4' d='M0 189.2h512v133.6H0z' />
      <path fill='#496e2d' d='M0 356.2h512V512H0z' />
    </g>
  </svg>
)

// Guinea
const GnFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ffda44' d='M167 0h178l25.9 252.3L345 512H167l-29.8-253.4z' />
      <path fill='#d80027' d='M0 0h167v512H0z' />
      <path fill='#6da544' d='M345 0h167v512H345z' />
    </g>
  </svg>
)

// Guadeloupe
const GpFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M167 0h178l25.9 252.3L345 512H167l-29.8-253.4z' />
      <path fill='#0052b4' d='M0 0h167v512H0z' />
      <path fill='#d80027' d='M345 0h167v512H345z' />
    </g>
  </svg>
)

// Equatorial Guinea
const GqFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M41.3 121.9 512 167v178L43.8 391.3z' />
      <path fill='#6da544' d='M0 0h512v167H111z' />
      <path fill='#d80027' d='M111 345h401v167H0z' />
      <path fill='#0052b4' d='M0 0v512l256-256z' />
      <path fill='#ff9811' d='M334 257.1h22.2v32.3h-22.3z' />
      <path
        fill='#6da544'
        d='M367.3 245a22.3 22.3 0 1 0-44.5 0 11.1 11.1 0 1 0 0 22.1h44.5a11.1 11.1 0 1 0 0-22.2z'
      />
    </g>
  </svg>
)

// Greece
const GrFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#0052b4'
        d='M0 0h99l29 32 28-32h356v57l-32 28 32 29v57l-32 28 32 29v57l-32 28 32 28v57l-32 29 32 28v57H0v-57l32-28-32-29v-56l32-29-32-28V171l32-29-32-28Z'
      />
      <path
        fill='#eee'
        d='M99 0v114H0v57h99v114H0v57h512v-57H156V171h100v-57H156V0Zm157 57v57h256V57Zm0 114v57h256v-57ZM0 398v57h512v-57z'
      />
    </g>
  </svg>
)

// South Georgia and the South Sandwich Islands
const GsFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M256 0h256v512H0V256Z' />
      <path
        fill='#eee'
        d='M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z'
      />
      <path fill='#d80027' d='M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z' />
      <rect width='64' height='32' x='336' y='256' fill='#6da544' rx='16' ry='16' />
      <circle cx='368' cy='96' r='32' fill='#ff9811' />
      <circle cx='368' cy='144' r='48' fill='#acabb1' />
      <path fill='#338af3' d='M320 144v77c0 36 48 48 48 48s48-12 48-48v-77z' />
      <rect width='32' height='128' x='288' y='128' fill='#333' rx='16' ry='16' />
      <rect width='32' height='128' x='416' y='128' fill='#333' rx='16' ry='16' />
      <path fill='#6da544' d='m320 144 48 112 48-112z' />
      <path fill='#ffda44' d='M288 288v32h32v8h96v-8h32v-32h-32v8h-96v-8z' />
    </g>
  </svg>
)

// Guatemala
const GtFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#338af3'
        d='M0 0h144.7l108.4 41.2L367.3 0H512v512H367.3l-110.2-41.4L144.7 512H0z'
      />
      <path fill='#eee' d='M144.7 0h222.6v512H144.7z' />
      <path
        fill='#acabb1'
        d='M322.9 299.3 279.6 256l41.2-41.2L319 193l-11.7-11.8-51.2 51.2-51.2-51.2-11.7 11.8-2 21.8 41.3 41.2-43.3 43.3 23.6 23.6 43.3-43.3 43.3 43.3z'
      />
      <path
        fill='#6da544'
        d='m319 193-23.6 23.6a55.5 55.5 0 0 1-39.4 95 55.7 55.7 0 0 1-39.4-95L193 193a89 89 0 1 0 126 0z'
      />
    </g>
  </svg>
)

// Guam
const GuFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 0h512v44.6l-41.2 207.2L512 467.6V512H0v-44.4l38-219-38-204z' />
      <path fill='#0052b4' d='M0 44.6h512v423H0z' />
      <path
        fill='#d80027'
        d='M241.5 417.7c-3.5-3-85.7-74.5-85.7-161.6 0-87 82.2-158.6 85.7-161.6L256 82.1l14.5 12.4c3.5 3 85.7 74.4 85.7 161.6 0 87.2-82.2 158.6-85.7 161.6L256 430.1z'
      />
      <path
        fill='#338af3'
        d='M334 256.1c0-78-78-144.7-78-144.7s-78 66.8-78 144.7a150 150 0 0 0 17.5 66.8h121a150 150 0 0 0 17.4-66.8z'
      />
      <path
        fill='#0052b4'
        d='M334 256.1a150 150 0 0 1-17.5 66.8L256 334l-60.5-11a150 150 0 0 1-17.4-66.9h155.8z'
      />
      <path fill='#ffda44' d='M256 400.8s37.5-32.2 60.5-78h-121c23 45.8 60.5 78 60.5 78z' />
      <path fill='#6da544' d='M206 211.6h100l-50 50z' />
      <path fill='#a2001d' d='M239.3 245h33.4v100.1h-33.4z' />
    </g>
  </svg>
)

// Guinea-Bissau
const GwFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 0h189.2l54 257.6-54 254.4H0z' />
      <path fill='#ffda44' d='M189.2 0H512v256l-159 53.5L189.1 256z' />
      <path fill='#6da544' d='M189.2 256H512v256H189.2z' />
      <path
        fill='#333'
        d='m96.7 189.2 16.6 51H167l-43.4 31.6 16.5 51-43.4-31.5-43.4 31.5 16.6-51-43.4-31.6h53.7z'
      />
    </g>
  </svg>
)

// GY Guyana
const GyFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#6da544' d='M77.7 0H512v512H77.8z' />
      <path fill='#eee' d='M425.4 254.7 31.4 512h46.4L512 256 77.7 0H31.4z' />
      <path fill='#ffda44' d='M256 256 31.4 512l436.8-256L31.4 0z' />
      <path fill='#333' d='M0 0v1.8l219.6 253.8L0 510v2h31.4l256-256L31.4 0z' />
      <path fill='#d80027' d='M0 0v512l256-256L0 0z' />
    </g>
  </svg>
)

// Hong Kong
const HkFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 0h512v512H0z' />
      <path
        fill='#eee'
        d='M282.4 193.7c-5.8 24.2-16.1 19.6-21.2 40.7a55.7 55.7 0 0 1 26-108.3c-10.1 42.2.4 46-4.8 67.6zM205 211.6c21.2 13 13.6 21.4 32.1 32.8a55.7 55.7 0 0 1-94.9-58.2c37 22.7 43.8 13.8 62.8 25.4zm-7 79.3c19-16.2 24.7-6.4 41.2-20.4a55.7 55.7 0 0 1-84.7 72.2c33-28.2 26.6-37.4 43.6-51.8zm73.4 31c-9.6-23 1.5-25.3-6.8-45.3a55.7 55.7 0 0 1 42.6 102.8c-16.6-40-27.3-36.9-35.8-57.4zm52.2-60c-24.9 2-23.7-9.3-45.3-7.6a55.7 55.7 0 0 1 111-8.7c-43.3 3.4-43.6 14.5-65.7 16.3z'
      />
    </g>
  </svg>
)

// Heard Island and McDonald Islands
const HmFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M0 0h512v512H0z' />
      <path
        fill='#eee'
        d='m154 300 14 30 32-8-14 30 25 20-32 7 1 33-26-21-26 21 1-33-33-7 26-20-14-30 32 8zm222-27h47l-38 27 15-44 14 44zm7-162 7 15 16-4-7 15 12 10-15 3v17l-13-11-13 11v-17l-15-3 12-10-7-15 16 4zm57 67 7 15 16-4-7 15 12 10-15 3v16l-13-10-13 11v-17l-15-3 12-10-7-15 16 4zm-122 22 7 15 16-4-7 15 12 10-15 3v16l-13-10-13 11v-17l-15-3 12-10-7-15 16 4zm65 156 7 15 16-4-7 15 12 10-15 3v17l-13-11-13 11v-17l-15-3 12-10-7-15 16 4zM0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z'
      />
      <path fill='#d80027' d='M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z' />
    </g>
  </svg>
)

// Honduras
const HnFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#338af3' d='M0 0h512v144.7l-40.5 112.6 40.5 110V512H0V367.3l42.2-114L0 144.7z' />
      <path fill='#eee' d='M0 144.7h512v222.6H0z' />
      <path
        fill='#338af3'
        d='m157.5 167 8.3 25.5h26.9L171 208.2l8.2 25.5-21.7-15.7-21.7 15.7 8.3-25.5-21.7-15.7h26.9zm0 111.3 8.3 25.5h26.9L171 319.5l8.2 25.5-21.7-15.7-21.7 15.7 8.3-25.5-21.7-15.7h26.9zm197-111.3 8.2 25.5h26.9l-21.7 15.7 8.3 25.5-21.7-15.7-21.7 15.7 8.2-25.5-21.7-15.7h26.9zm0 111.3 8.2 25.5h26.9l-21.7 15.7 8.3 25.5-21.7-15.7-21.7 15.7 8.2-25.5-21.7-15.7h26.9zM256 222.6l8.3 25.5H291L269.4 264l8.3 25.5-21.7-15.8-21.7 15.8 8.3-25.5-21.7-15.8h26.8z'
      />
    </g>
  </svg>
)

// Croatia
const HrFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z' />
      <path fill='#d80027' d='M0 0h512v167H0z' />
      <path fill='#0052b4' d='M0 345h512v167H0z' />
      <path
        fill='#338af3'
        d='M322.8 178h-44.5l7.4-55.7 29.7-22.2 29.6 22.2V167zm-133.6 0h44.5l-7.4-55.7-29.7-22.2-29.6 22.2V167z'
      />
      <path fill='#0052b4' d='M285.7 178h-59.4v-55.7l29.7-22.2 29.7 22.2z' />
      <path
        fill='#eee'
        d='M167 167v122.3a89 89 0 0 0 35.8 71.3l15.5-3.9 19.7 19.8a89.1 89.1 0 0 0 18 1.8 89 89 0 0 0 17.9-1.8l22.4-18.7 13 2.8a89 89 0 0 0 35.7-71.3V167z'
      />
      <path
        fill='#d80027'
        d='M167 167h35.6v35.5H167zm71.2 0h35.6v35.5h-35.6zm71.2 0H345v35.5h-35.6zm-106.8 35.5h35.6v35.6h-35.6zm71.2 0h35.6v35.6h-35.6zM167 238.1h35.6v35.6H167zm35.6 35.6h35.6v35.6h-35.6zm35.6-35.6h35.6v35.6h-35.6zm71.2 0H345v35.6h-35.6zm-35.6 35.6h35.6v35.6h-35.6zm-35.6 35.6h35.6V345h-35.6zm-35.6 0h-33.3c3 13.3 9 25.4 17.3 35.6h16zM309.4 345h16a88.8 88.8 0 0 0 17.3-35.6h-33.3zm-106.8 0v15.6a88.7 88.7 0 0 0 35.6 16V345zm71.2 0v31.6a88.7 88.7 0 0 0 35.6-16V345z'
      />
    </g>
  </svg>
)

// Haiti
const HtFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#a2001d' d='m0 256 254.8-41.8L512 256v256H0z' />
      <path fill='#0052b4' d='M0 0h512v256H0z' />
      <path fill='#eee' d='m345 322.8-89-11.1-89 11V189.3h178z' />
      <circle cx='256' cy='267.1' r='44.5' fill='#0052b4' />
      <circle cx='256' cy='267.1' r='22.3' fill='#a2001d' />
      <path fill='#6da544' d='M222.6 211.5h66.8L256 244.9z' />
      <path fill='#ffda44' d='M244.9 233.7H267v66.8h-22z' />
      <path fill='#6da544' d='M291.6 293.8h-71.2l-53.4 29h178z' />
    </g>
  </svg>
)

// Hungary
const HuFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z' />
      <path fill='#d80027' d='M0 0h512v167H0z' />
      <path fill='#6da544' d='M0 345h512v167H0z' />
    </g>
  </svg>
)

// Indonesia
const IdFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='m0 256 249.6-41.3L512 256v256H0z' />
      <path fill='#a2001d' d='M0 0h512v256H0z' />
    </g>
  </svg>
)

// Ireland
const IeFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M167 0h178l25.9 252.3L345 512H167l-29.8-253.4z' />
      <path fill='#6da544' d='M0 0h167v512H0z' />
      <path fill='#ff9811' d='M345 0h167v512H345z' />
    </g>
  </svg>
)

// Israel
const IlFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#eee'
        d='M0 0h512v55.7l-25 32.7 25 34v267.2l-26 36 26 30.7V512H0v-55.7l24.8-34.1L0 389.6V122.4l27.2-33.2L0 55.7z'
      />
      <path
        fill='#0052b4'
        d='M0 55.7v66.7h512V55.7zm0 333.9v66.7h512v-66.7zm352.4-189.3H288l-32-55.6-32.1 55.6h-64.3l32.1 55.7-32 55.7h64.2l32.1 55.6 32.1-55.6h64.3L320.3 256l32-55.7zm-57 55.7-19.7 34.2h-39.4L216.5 256l19.8-34.2h39.4l19.8 34.2zM256 187.6l7.3 12.7h-14.6zm-59.2 34.2h14.7l-7.4 12.7zm0 68.4 7.3-12.7 7.4 12.7zm59.2 34.2-7.3-12.7h14.6zm59.2-34.2h-14.7l7.4-12.7zm-14.7-68.4h14.7l-7.3 12.7z'
      />
    </g>
  </svg>
)

// Isle of Man
const ImFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 0h512v512H0z' />
      <path
        fill='#eee'
        d='m350.8 171.6-18.1 64.6-54.3-10-35-72-94.4 33.4-7.4-21-24.7-3 18.6 52.5 65-16.7 18.4 52-44.9 66.3 76.3 65-14.5 17 9.7 22.9 36.1-42.3-46.8-48 35.8-42 79.8 5.8 18.2-98.6 22 4 15-19.8-54.8-10zM256 256z'
      />
    </g>
  </svg>
)

// India
const InFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='m0 160 256-32 256 32v192l-256 32L0 352z' />
      <path fill='#ff9811' d='M0 0h512v160H0Z' />
      <path fill='#6da544' d='M0 352h512v160H0Z' />
      <circle cx='256' cy='256' r='72' fill='#0052b4' />
      <circle cx='256' cy='256' r='48' fill='#eee' />
      <circle cx='256' cy='256' r='24' fill='#0052b4' />
    </g>
  </svg>
)

// British Indian Ocean Territory (the)
const IoFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#eee'
        d='M0 0h32l32 32L96 0h160l12 8 13-8h36l24 8 25-8h36l25 8 24-8h36l25 22v34l-8 17 8 17v35l-8 17 8 17v34l-8 17 8 17v35l-8 17 8 17v34l-8 17 8 18v34l-8 17 8 17v35l-8 17 8 17v10h-22l-21-8-20 8h-44l-21-8-21 8h-44l-20-8-21 8h-44l-21-8-20 8h-44l-21-8-21 8H64l-21-8-21 8H0v-10l8-17-8-17v-35l8-17-8-17v-34l8-18-8-17v-34l8-17-8-17V96l32-32L0 32Z'
      />
      <path fill='#d80027' d='M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z' />
      <path
        fill='#0052b4'
        d='M256 0v22c21 0 21 19 43 19 21 0 21-19 42-19 22 0 22 19 43 19s21-19 43-19c21 0 21 19 42 19 22 0 22-19 43-19V0h-25c-4 4-9 7-18 7-8 0-13-3-18-7h-49c-4 4-9 7-18 7-8 0-14-3-18-7h-49c-5 4-10 7-18 7-9 0-14-3-18-7h-25zm0 56v34c21 0 21 20 43 20 21 0 21-20 42-20 22 0 22 20 43 20s21-20 43-20c21 0 21 20 42 20 22 0 22-20 43-20V56c-21 0-21 19-43 19-21 0-21-19-42-19-22 0-22 19-43 19s-21-19-43-19c-21 0-21 19-42 19-22 0-22-19-43-19zm0 69v3h-83l83 83v16c21 0 21 20 43 20 21 0 21-20 42-20 22 0 22 20 43 20s21-20 43-20c21 0 21 20 42 20 22 0 22-20 43-20v-34c-21 0-21 20-43 20-21 0-21-20-42-20-22 0-22 20-43 20s-21-20-43-20c-21 0-21 20-42 20-22 0-22-20-43-20v-34c21 0 21 19 43 19 21 0 21-19 42-19 22 0 22 19 43 19s21-19 43-19c21 0 21 19 42 19 22 0 22-19 43-19v-34c-21 0-21 19-43 19-21 0-21-19-42-19-22 0-22 19-43 19s-21-19-43-19c-21 0-21 19-42 19-22 0-22-19-43-19zm-128 48v83h83l-83-83zM0 262v34c21 0 21 20 43 20 21 0 21-20 42-20 22 0 22 20 43 20s21-20 43-20c21 0 21 20 42 20 22 0 22-20 43-20s21 20 43 20c21 0 21-20 42-20 22 0 22 20 43 20s21-20 43-20c21 0 21 20 42 20 22 0 22-20 43-20v-34c-21 0-21 19-43 19-21 0-21-19-42-19-22 0-22 19-43 19s-21-19-43-19c-21 0-21 19-42 19-22 0-22-19-43-19s-21 19-43 19c-21 0-21-19-42-19-22 0-22 19-43 19s-21-19-43-19c-21 0-21 19-42 19-22 0-22-19-43-19zm0 68v35c21 0 21 19 43 19 21 0 21-19 42-19 22 0 22 19 43 19s21-19 43-19c21 0 21 19 42 19 22 0 22-19 43-19s21 19 43 19c21 0 21-19 42-19 22 0 22 19 43 19s21-19 43-19c21 0 21 19 42 19 22 0 22-19 43-19v-35c-21 0-21 20-43 20-21 0-21-20-42-20-22 0-22 20-43 20s-21-20-43-20c-21 0-21 20-42 20-22 0-22-20-43-20s-21 20-43 20c-21 0-21-20-42-20-22 0-22 20-43 20s-21-20-43-20c-21 0-21 20-42 20-22 0-22-20-43-20zm0 69v34c21 0 21 20 43 20 21 0 21-20 42-20 22 0 22 20 43 20s21-20 43-20c21 0 21 20 42 20 22 0 22-20 43-20s21 20 43 20c21 0 21-20 42-20 22 0 22 20 43 20s21-20 43-20c21 0 21 20 42 20 22 0 22-20 43-20v-34c-21 0-21 19-43 19-21 0-21-19-42-19-22 0-22 19-43 19s-21-19-43-19c-21 0-21 19-42 19-22 0-22-19-43-19s-21 19-43 19c-21 0-21-19-42-19-22 0-22 19-43 19s-21-19-43-19c-21 0-21 19-42 19-22 0-22-19-43-19zm0 69v34c11 0 16 5 22 10h42c5-5 10-10 21-10s17 5 22 10h42c5-5 11-10 22-10s16 5 22 10h41c6-5 11-10 22-10s16 5 22 10h42c5-5 10-10 21-10s17 5 22 10h42c5-5 11-10 22-10s16 5 22 10h41c6-5 11-10 22-10v-34c-21 0-21 19-43 19-21 0-21-19-42-19-22 0-22 19-43 19s-21-19-43-19c-21 0-21 19-42 19-22 0-22-19-43-19s-21 19-43 19c-21 0-21-19-42-19-22 0-22 19-43 19s-21-19-43-19c-21 0-21 19-42 19-22 0-22-19-43-19z'
      />
      <path fill='#6da544' d='M334 134h100l-50 50z' />
      <path fill='#a2001d' d='M373 173h22v50l-11 8-11-8Zm0 161h22v61h-22z' />
      <path
        fill='#ffda44'
        d='M451 301a34 34 0 0 0-56-25v-20h11v-22h-11v-11h-22v11h-11v22h11v20a34 34 0 0 0-47 3 33 33 0 0 0 2 46v20h112v-20c7-6 11-14 11-24z'
      />
      <path
        fill='#d80027'
        d='M351 289c-3 0-6 2-8 4-4 4-4 12 0 16l8 6v8h65v-8l8-6c4-4 4-12 0-16s-10-5-15-1l-15 14h-21l-15-14a11 11 0 0 0-7-3z'
      />
    </g>
  </svg>
)

// Iraq
const IqFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z' />
      <path fill='#a2001d' d='M0 0h512v167H0z' />
      <path fill='#333' d='M0 345h512v167H0z' />
      <path
        fill='#496e2d'
        d='M194.8 239.3h-49.4a22.3 22.3 0 0 1 21.6-16.7v-33.4c-30.7 0-55.7 25-55.7 55.7v27.8h83.5a5.6 5.6 0 0 1 5.5 5.6v11H89v33.5h144.7v-44.5a39 39 0 0 0-39-39zm83.5 50v-100h-33.4v133.5h55.6v-33.4zm111.3 0v-100h-33.4v100H345V256h-33.3v66.8h100.1v-33.4z'
      />
    </g>
  </svg>
)

// Iran
const IrFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M0 144.7 258.8 39.6 512 144.7v222.6L257 493 0 367.3z' />
      <path
        fill='#6da544'
        d='M0 0v144.7h105.6v-22.2h33.6v22.2h33.3v-22.2h33.6v22.2h33.3v-22.2H273v22.2h33v-22.2h33.6v22.2h33.2v-22.2h33.6v22.2H512V0z'
      />
      <path
        fill='#d80027'
        d='M0 367.3V512h512V367.3H406.4v22.4h-33.6v-22.4h-33.2v22.4H306v-22.4h-33v22.4h-33.6v-22.4h-33.3v22.4h-33.6v-22.4h-33.3v22.4h-33.6v-22.4zm339.1-178h-33.4c.2 3.7.4 7.4.4 11.1 0 24.8-6.2 48.8-17 66-3.3 5.2-9 12.6-16.4 17.6v-94.7h-33.4v94.8c-7.5-5-13-12.4-16.4-17.7-10.8-17-17-41-17-65.9 0-3.7.2-7.4.4-11H173a190 190 0 0 0-.4 11c0 68.7 36.7 122.5 83.5 122.5s83.5-53.8 83.5-122.5c0-3.7-.1-7.4-.4-11z'
      />
    </g>
  </svg>
)

// Iceland
const IsFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#0052b4'
        d='M0 0h100.2l66.1 53.5L233.7 0H512v189.3L466.3 257l45.7 65.8V512H233.7l-68-50.7-65.5 50.7H0V322.8l51.4-68.5-51.4-65z'
      />
      <path
        fill='#eee'
        d='M100.2 0v189.3H0v33.4l24.6 33L0 289.5v33.4h100.2V512h33.4l30.6-26.3 36.1 26.3h33.4V322.8H512v-33.4l-24.6-33.7 24.6-33v-33.4H233.7V0h-33.4l-33.8 25.3L133.6 0z'
      />
      <path fill='#d80027' d='M133.6 0v222.7H0v66.7h133.6V512h66.7V289.4H512v-66.7H200.3V0z' />
    </g>
  </svg>
)

// Italy
const ItFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M167 0h178l25.9 252.3L345 512H167l-29.8-253.4z' />
      <path fill='#6da544' d='M0 0h167v512H0z' />
      <path fill='#d80027' d='M345 0h167v512H345z' />
    </g>
  </svg>
)

// Jersey
const JeFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M0 47.1 47 0h417.8L512 47.2v417.7L464.9 512H47L0 464.9z' />
      <path
        fill='#d80027'
        d='M0 0v47.1L208.8 256 0 464.9V512h47.1L256 303.2 464.9 512H512v-47L303.1 256 512 47.2V0h-47.2L256 208.9 47 0z'
      />
      <path fill='#ffda44' d='M211.5 78 256 89l44.5-11V40l-17.8 9L256 22.3 229.3 49l-17.8-9z' />
      <path fill='#d80027' d='M211.5 78v27.7c0 34.1 44.5 44.6 44.5 44.6s44.5-10.5 44.5-44.6V78z' />
    </g>
  </svg>
)

// JM Jamaica
const JmFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#333' d='M23.3 488.6 0 465V47.1l23.4-23.7 464 464 24.6-22.6V47.1l-24.5-22.7z' />
      <path fill='#6da544' d='M23.3 23.3 47.1 0h417.7l23.8 23.4-464 464L47 512h418l22.6-24.5z' />
      <path
        fill='#ffda44'
        d='M0 0v47.1L208.8 256 0 464.9V512h47.1L256 303.2 464.9 512H512v-47L303.1 256 512 47.2V0h-47.2L256 208.9 47 0z'
      />
    </g>
  </svg>
)

// Jordan
const JoFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='m126 158 127.8-10.3L512 167v178l-254.9 32.3L126 335.9z' />
      <path fill='#333' d='M0 0h512v167H107z' />
      <path fill='#6da544' d='M107 345h405v167H0z' />
      <path fill='#d80027' d='M0 0v512l256-256z' />
      <path
        fill='#eee'
        d='m101.6 200.3 14 29.4 31.8-7.3-14.2 29.3 25.5 20.2-31.8 7.2.1 32.6-25.4-20.4-25.4 20.4V279l-31.7-7.2 25.5-20-14.2-29.4 31.8 7.3z'
      />
    </g>
  </svg>
)

// Japan
const JpFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M0 0h512v512H0z' />
      <circle cx='256' cy='256' r='111.3' fill='#d80027' />
    </g>
  </svg>
)

// Kenya
const KeFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#eee'
        d='m0 144.7 253.4-28.2L512 144.7V178l-36 76.4 36 79.6v33.3L254.7 400 0 367.3V334l39-78-39-78z'
      />
      <path fill='#333' d='M0 0h512v144.7H0z' />
      <path fill='#a2001d' d='M0 178h512v156H0z' />
      <path fill='#496e2d' d='M0 367.3h512V512H0z' />
      <path
        fill='#eee'
        d='m335.9 118.3-30.3-14-49.4 111.9-49.4-111.9-30.3 14L237.8 256l-61.3 137.7 30.3 14 49.4-111.9 49.4 111.9 30.3-14L274.6 256z'
      />
      <path
        fill='#eee'
        d='M256.2 111.3s-7 5.8-16.7 16l-16 127.6 16 129.8c9.7 10.2 16.7 16 16.7 16s7-5.8 16.7-16l15-130.7-15-126.7c-9.7-10.2-16.7-16-16.7-16z'
      />
      <path
        fill='#333'
        d='m311.9 179.2-10 75.5 10 78.1A158.6 158.6 0 0 0 334 256c0-28.2-9.7-54.5-22.2-76.8zm-111.4 0 8.9 74.3-9 79.3a158.6 158.6 0 0 1-22.1-76.8c0-28.2 9.7-54.5 22.2-76.8z'
      />
      <path
        fill='#a2001d'
        d='M200.5 179.2v153.6a269 269 0 0 0 39 51.9V127.3c-11.4 12-26.6 30-39 52zm111.4 0a269 269 0 0 0-39-51.9v257.4c11.4-12 26.5-30 39-52V179.3z'
      />
    </g>
  </svg>
)

// Kyrgyzstan
const KgFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 0h512v512H0z' />
      <path
        fill='#ffda44'
        d='M381.2 256 330 280l27.3 49.6-55.6-10.6-7 56.1-38.7-41.3-38.7 41.3-7-56.1-55.6 10.6 27.3-49.5-51.2-24.1 51.2-24-27.3-49.6 55.6 10.6 7-56.1 38.7 41.3 38.7-41.3 7 56.1 55.6-10.6-27.3 49.5z'
      />
      <circle cx='256' cy='256' r='77.9' fill='#d80027' />
      <path
        fill='#ffda44'
        d='M217 256c-1.8 0-3.7.1-5.5.3a44.3 44.3 0 0 0 10.4 28.3 78 78 0 0 1 15-24.9A55.4 55.4 0 0 0 217 256zm24 42a44.4 44.4 0 0 0 30 0c-2.6-10-7.8-19-15-26-7.2 7-12.4 16-15 26zm53.6-64.3a44.5 44.5 0 0 0-77.2 0 77.4 77.4 0 0 1 38.6 10.5 77.4 77.4 0 0 1 38.6-10.5zm-19.6 26a78 78 0 0 1 15.1 25 44.3 44.3 0 0 0 10.4-28.4 55.8 55.8 0 0 0-5.5-.3 55.3 55.3 0 0 0-20 3.7z'
      />
    </g>
  </svg>
)

// Cambodia
const KhFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M0 0h512v133.7l-39 121.6 39 123.2V512H0V378.5L34.2 255 0 133.7z' />
      <path fill='#d80027' d='M0 133.7h512v244.8H0z' />
      <path
        fill='#eee'
        d='M345 306.1v-33.3h-22.2v-44.5L300.5 206l-22.2 22.3v-44.5L256 161.5l-22.3 22.3v44.5L211.5 206l-22.3 22.3v44.5H167v33.4h-22.3v33.4h222.6v-33.5z'
      />
    </g>
  </svg>
)

// Kiribati
const KiFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 0h512l-.1 234.8-254.7 260.9L.3 234.8z' />
      <path
        fill='#ffda44'
        d='m345 238-36.3 17.2 19.3 35.2-39.5-7.5-5 39.9-27.5-29.4-27.5 29.4-5-40-39.5 7.6 19.3-35.2L167 238l36.3-17.1-19.3-35.3 39.5 7.6 5-40 27.5 29.4 27.5-29.3 5 39.9 39.5-7.6-19.3 35.3zM322.8 83.6h-50.1a16.7 16.7 0 0 0-33.4 0h-50c0 9.2 8 16.7 17.2 16.7h-.6c0 9.2 7.5 16.7 16.7 16.7 0 9.2 7.5 16.7 16.7 16.7h33.4c9.2 0 16.7-7.5 16.7-16.7 9.2 0 16.7-7.5 16.7-16.7h-.6c9.3 0 17.3-7.5 17.3-16.7z'
      />
      <path
        fill='#eee'
        d='M85.3 234.8c-21.3 0-21.3 19.5-42.7 19.5-21.2 0-21.3-19.3-42.3-19.5v34.3l12.3 18.2L.3 303.4V336l12.8 18.2L.3 370.3v32.4l39.1 49.4 441.2 3 31.3-52.4v-32.4l-8.2-16.4 8.2-17.9v-32.6l-10.3-14 10.3-20.3v-34.3c-21.2 0-21.2 19.5-42.5 19.5s-21.4-19.5-42.7-19.5c-21.3 0-21.3 19.5-42.7 19.5-21.3 0-21.3-19.5-42.6-19.5-21.4 0-21.4 19.5-42.7 19.5-21.3 0-21.3-19.5-42.7-19.5-21.4 0-21.4 19.5-42.7 19.5-21.3 0-21.3-19.5-42.7-19.5-21.3 0-21.3 19.5-42.6 19.5s-21.4-19.5-42.7-19.5z'
      />
      <path
        fill='#0052b4'
        d='M85.3 269.1c-21.3 0-21.3 19.5-42.7 19.5-21.2 0-21.3-19.3-42.3-19.5v34.3c21 .2 21.1 19.5 42.3 19.5 21.4 0 21.4-19.5 42.7-19.5 21.3 0 21.3 19.5 42.7 19.5 21.4 0 21.3-19.5 42.6-19.5 21.4 0 21.4 19.5 42.7 19.5 21.3 0 21.3-19.5 42.7-19.5 21.4 0 21.4 19.5 42.7 19.5 21.3 0 21.3-19.5 42.7-19.5 21.3 0 21.3 19.5 42.6 19.5 21.4 0 21.4-19.5 42.7-19.5 21.3 0 21.3 19.5 42.7 19.5 21.4 0 21.3-19.4 42.5-19.5v-34.3c-21.2 0-21.2 19.5-42.5 19.5s-21.4-19.5-42.7-19.5c-21.3 0-21.3 19.5-42.7 19.5-21.3 0-21.3-19.5-42.6-19.5-21.4 0-21.4 19.5-42.7 19.5-21.3 0-21.3-19.5-42.7-19.5-21.4 0-21.4 19.5-42.7 19.5-21.3 0-21.3-19.5-42.7-19.5-21.3 0-21.3 19.5-42.6 19.5s-21.4-19.5-42.7-19.5zm0 66.9C64 336 64 355.5 42.6 355.5c-21.2 0-21.3-19.3-42.3-19.5v34.3c21 .2 21.1 19.5 42.3 19.5 21.4 0 21.4-19.5 42.7-19.5 21.3 0 21.3 19.5 42.7 19.5 21.4 0 21.3-19.5 42.6-19.5 21.4 0 21.4 19.5 42.7 19.5 21.3 0 21.3-19.5 42.7-19.5 21.4 0 21.4 19.5 42.7 19.5 21.3 0 21.3-19.5 42.7-19.5 21.3 0 21.3 19.5 42.6 19.5 21.4 0 21.4-19.5 42.7-19.5 21.3 0 21.3 19.5 42.7 19.5 21.4 0 21.3-19.4 42.5-19.5V336c-21.2 0-21.2 19.5-42.5 19.5S448 336 426.7 336c-21.3 0-21.3 19.5-42.7 19.5-21.3 0-21.3-19.5-42.6-19.5-21.4 0-21.4 19.5-42.7 19.5-21.3 0-21.3-19.5-42.7-19.5-21.4 0-21.4 19.5-42.7 19.5-21.3 0-21.3-19.5-42.7-19.5-21.3 0-21.3 19.5-42.6 19.5S106.6 336 85.3 336zm0 66.7c-21.3 0-21.3 19.5-42.7 19.5-21.2 0-21.3-19.3-42.3-19.5L0 512h512l-.1-109.3c-21.2 0-21.2 19.5-42.5 19.5s-21.4-19.5-42.7-19.5c-21.3 0-21.3 19.5-42.7 19.5-21.3 0-21.3-19.5-42.6-19.5-21.4 0-21.4 19.5-42.7 19.5-21.3 0-21.3-19.5-42.7-19.5-21.4 0-21.4 19.5-42.7 19.5-21.3 0-21.3-19.5-42.7-19.5-21.3 0-21.3 19.5-42.6 19.5s-21.4-19.5-42.7-19.5z'
      />
    </g>
  </svg>
)

// Comoros
const KmFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ffda44' d='M124.4 149.7 512 132.8V0H0z' />
      <path fill='#eee' d='M112.5 132.8H512v122.4l-294.2 16.6z' />
      <path fill='#d80027' d='M512 255.3H234.5l-136 139.8L512 377.7V256z' />
      <path fill='#0052b4' d='M108.2 377.7 0 511.2l512 .8V377.7z' />
      <path fill='#6da544' d='M.8 0 0 511.2l256-256z' />
      <g fill='#eee'>
        <path d='M67.5 255.3a78 78 0 0 1 61.2-76 78.2 78.2 0 0 0-16.7-2 78 78 0 1 0 16.7 154 78 78 0 0 1-61.2-76z' />
        <path d='m127.9 188.5 4.1 12.7h13.4l-10.8 8 4.1 12.7-10.8-8-10.9 8 4.2-12.8-10.9-7.9h13.4zm0 33.4 4.1 12.7h13.4l-10.8 8 4.1 12.7-10.8-8-10.9 8 4.2-12.8-10.9-7.9h13.4zm0 33.4L132 268h13.4l-10.8 8 4.1 12.6-10.8-7.8-10.9 7.8 4.2-12.7-10.9-7.9h13.4zm0 33.3 4.1 12.8h13.4l-10.8 8 4.1 12.6-10.8-7.8L117 322l4.2-12.7-10.9-7.9h13.4z' />
      </g>
    </g>
  </svg>
)

// Saint Kitts and Nevis
const KnFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#ffda44'
        d='m0 401.9 173.6-225.3L401.9 0H449l63 63-.1 47.3-167.3 223.5L110.3 512H63L0 449z'
      />
      <path fill='#6da544' d='M0 0v401.9L401.9 0z' />
      <path fill='#d80027' d='M512 512V110.3L110.3 512z' />
      <path fill='#333' d='M0 512h63L512 63V0h-63L0 449z' />
      <path
        fill='#eee'
        d='m162.8 302 24 12.2 19-19-4.4 26.5 24 12.2-26.6 4.2-4.2 26.5-12-24L156 345l19-19zM302 162.8l24 12.1 19-19-4.3 26.6 24 12.1-26.6 4.2-4.2 26.5-12.2-23.9-26.5 4.2 19-19z'
      />
    </g>
  </svg>
)

// Korea
const KpFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M0 0h512v89l-61.2 165.6L512 423v89H0v-89l62.5-174.6L0 89z' />
      <path fill='#eee' d='M0 89h512v33.4l-28.1 130L512 389.7V423H0v-33.4L30 255 0 122.4z' />
      <path fill='#d80027' d='M0 122.4h512v267.2H0z' />
      <circle cx='157.5' cy='256' r='98.5' fill='#eee' />
      <path
        fill='#d80027'
        d='m157.5 157.5 22.1 68h71.6l-58 42 22.3 68.3-58-42.3-58 42.2 22.2-68.1-57.9-42h71.6z'
      />
    </g>
  </svg>
)

// South Korea
const KrFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M0 0h512v512H0Z' />
      <path
        fill='#333'
        d='m350 335 24-24 16 16-24 23zm-39 39 24-24 15 16-23 24zm87 8 23-24 16 16-24 24zm-40 39 24-23 16 15-24 24Zm16-63 24-23 15 15-23 24zm-39 40 23-24 16 16-24 23zm63-221-63-63 15-15 64 63zm-63-15-24-24 16-16 23 24zm39 39-24-24 16-15 24 23zm8-87-24-23 16-16 24 24Zm39 40-23-24 15-16 24 24ZM91 358l63 63-16 16-63-63zm63 16 23 24-15 15-24-23zm-40-39 24 23-16 16-23-24zm24-24 63 63-16 16-63-63zm16-220-63 63-16-16 63-63zm23 23-63 63-15-16 63-63zm24 24-63 63-16-16 63-63z'
      />
      <path fill='#d80027' d='M319 319 193 193a89 89 0 1 1 126 126z' />
      <path fill='#0052b4' d='M319 319a89 89 0 1 1-126-126z' />
      <circle cx='224.5' cy='224.5' r='44.5' fill='#d80027' />
      <circle cx='287.5' cy='287.5' r='44.5' fill='#0052b4' />
    </g>
  </svg>
)

// Kuwait
const KwFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M138.4 147 512 167v178l-373.6 20z' />
      <path fill='#6da544' d='m0 0 138.4 167H512V0z' />
      <path fill='#d80027' d='m0 512 138.4-167H512v167z' />
      <path fill='#333' d='M167 167 0 0v512l167-167z' />
    </g>
  </svg>
)

// Cayman Islands
const KyFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M256 0h256v512H0V256Z' />
      <path
        fill='#eee'
        d='M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z'
      />
      <path fill='#d80027' d='M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z' />
      <circle cx='367.3' cy='144.7' r='44.5' fill='#6da544' />
      <path fill='#d80027' d='M289.4 133.5h155.8l.1 29-76.9 79.7-79.1-79.7z' />
      <path fill='#496e2d' d='M445.2 256zm-155.8 0z' />
      <path fill='#ffda44' d='M289.4 300.5V345h23.4a77.6 77.6 0 0 0 109 0h23.4v-44.5z' />
      <path
        fill='#338af3'
        d='M289.3 193.7v31.2l8 16.6-7.9 14.5c.1 59.6 77.9 78 77.9 78s78-18.4 78-78l-7.7-13.2 7.7-18v-31.1l-78-10.2z'
      />
      <path
        fill='#eee'
        d='M367.3 224.9c-19.5 0-19.5 17.8-39 17.8s-19.4-17.8-39-17.8V256c19.7 0 19.6 17.8 39 17.8s19.5-17.8 39-17.8 19.5 17.8 39 17.8 19.4-17.8 39-17.8v-31.2c-19.6 0-19.6 17.8-39 17.8-19.5 0-19.5-17.8-39-17.8zm0-62.4c-19.5 0-19.5 17.8-39 17.8s-19.4-17.8-39-17.8v31.2c19.7 0 19.6 17.8 39 17.8s19.5-17.8 39-17.8 19.5 17.8 39 17.8 19.4-17.8 39-17.8v-31.2c-19.6 0-19.6 17.8-39 17.8-19.5 0-19.5-17.8-39-17.8z'
      />
    </g>
  </svg>
)

// KZ Kazakhstan
const KzFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#338af3' d='M0 0h512v512H0z' />
      <path
        fill='#ffda44'
        d='M400.7 258.8H111.3c0 20 17.4 36.2 37.4 36.2h-1.2c0 20 16.2 36.1 36.2 36.1 0 20 16.1 36.2 36.1 36.2h72.4c20 0 36.1-16.2 36.1-36.2 20 0 36.2-16.2 36.2-36.1h-1.2c20 0 37.4-16.2 37.4-36.2z'
      />
      <path fill='#338af3' d='M356.2 211.5a100.2 100.2 0 0 1-200.4 0' />
      <path
        fill='#ffda44'
        d='m332.5 211.5-31.3 14.7 16.7 30.3-34-6.5-4.3 34.3L256 259l-23.6 25.3L228 250l-34 6.5 16.6-30.3-31.2-14.7 31.2-14.7-16.6-30.3 34 6.5 4.3-34.3 23.6 25.2 23.6-25.2L284 173l34-6.5-16.6 30.3z'
      />
    </g>
  </svg>
)

// Lao People's Democratic Republic
const LaFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 0h512v144.8l-45.8 113L512 367.4V512H0V367.4l46.3-111.1L0 144.8z' />
      <path fill='#0052b4' d='M0 144.8h512v222.6H0z' />
      <circle cx='256' cy='256.1' r='89' fill='#eee' />
    </g>
  </svg>
)

// Lebanon
const LbFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 0h512v144.8l-45.8 113L512 367.4V512H0V367.4l46.3-111.1L0 144.8z' />
      <path fill='#eee' d='M0 144.8h512v222.6H0z' />
      <path fill='#6da544' d='M322.8 300.5 256 178.1l-66.8 122.4h50.1V334h33.4v-33.4z' />
    </g>
  </svg>
)

// Saint Lucia
const LcFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#338af3' d='M0 0h512v512H0z' />
      <path fill='#eee' d='M161.4 345h189.2L256 122.4z' />
      <path fill='#333' d='M194.3 322.8 256 182.4l61.7 140.4z' />
      <path fill='#ffda44' d='M161.4 345h189.2L256 256z' />
    </g>
  </svg>
)

//LI Liechtenstein
const LiFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='m0 256 255.2-39.6L512 256v256H0z' />
      <path fill='#0052b4' d='M0 0h512v256H0z' />
      <path
        fill='#ffda44'
        d='M189.2 178a33.4 33.4 0 0 0-55.6-24.8v-19.6h11.1v-22.3h-11.1v-11.1h-22.3v11.1h-11.1v22.3h11.1v19.6A33.4 33.4 0 0 0 66.8 203v19.6H178V203c6.8-6.1 11.1-15 11.1-25z'
      />
    </g>
  </svg>
)

//LK Sri Lanka
const LkFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ff9811' d='M81.4 27.2h135.2v456.5H81.4z' />
      <path fill='#6da544' d='m0 44.5 100.2-22v463L0 467.5z' />
      <path fill='#a2001d' d='m218.6 26.5 293.4 18v93.2l-18.6 106.2 18.6 97.4v126.2l-293.4 18z' />
      <path fill='#ffda44' d='M0 0v44.5h200.3v423H0V512h512v-44.5H233.7v-423H512V0z' />
      <path
        fill='#ffda44'
        d='M300.5 94.6c-18.4 0-33.4 15-33.4 33.4v144.6a33 33 0 0 0 11.2 25v53h22.2v-27.8h100.2v44.5h-22.3v22.3H423V345l20.4-22.2h48.2a72.9 72.9 0 0 0 20.4 18.5V137.7a66 66 0 0 0-22.5 13.1 67.8 67.8 0 0 0-13.2 82.9c-21.3-.1-41 .2-53.3 0V167c0-11.2-16.7-22.3-16.7-22.3s-16.7 11.1-16.7 22.3h-66.8v66.7h33.4v33.4c0 7.1 1.4 14.1 4.1 20.7L345 300.6h-44.5v-206z'
      />
    </g>
  </svg>
)

// LR Liberia
const LrFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#eee'
        d='M0 232.7 256 0h256l-19.2 24L512 46.4v46.7l-19.6 22.6 19.6 23.9v46.5L493.8 209l18.2 23.7v46.6L493 304l19 21.8v46.6l-18 23.5 18 23v46.6l-253.3 21L0 465.5v-46.6l18.8-21.6L0 372.4v-46.6l19.6-21.9L0 279.3z'
      />
      <path
        fill='#d80027'
        d='m256 0-22 46.5h278V0zm-17.1 93.2v46.5H512V93.2zm-4.9 93 22 46.5h256v-46.5zM0 279.3v46.5h512v-46.5zm0 93.1v46.5h512v-46.5zm0 93.1V512h512v-46.5z'
      />
      <path fill='#0052b4' d='M0 0h256v232.7H0z' />
      <path
        fill='#eee'
        d='m152.4 66.8 16.6 51h53.6l-43.4 31.5 16.6 51-43.4-31.5-43.4 31.5 16.6-51-43.4-31.5h53.6z'
      />
    </g>
  </svg>
)

// LS Lesotho
const LsFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='m0 144.7 255.3-36.5L512 144.7v222.6L250.5 407 0 367.3z' />
      <path fill='#0052b4' d='M0 0h512v144.7H0z' />
      <path fill='#6da544' d='M0 367.3h512V512H0z' />
      <path fill='#333' d='M272.7 250.4v-61.2h-33.4v61.2L199 290.8a66.7 66.7 0 0 0 114 0z' />
    </g>
  </svg>
)

// Lithuania
const LtFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#6da544' d='m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z' />
      <path fill='#ffda44' d='M0 0h512v167H0z' />
      <path fill='#d80027' d='M0 345h512v167H0z' />
    </g>
  </svg>
)

// Luxembourg
const LuFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z' />
      <path fill='#d80027' d='M0 0h512v167H0z' />
      <path fill='#338af3' d='M0 345h512v167H0z' />
    </g>
  </svg>
)

// Latvia
const LvFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#a2001d' d='M0 0h512v189.2l-38.5 70 38.5 63.6V512H0V322.8l39.4-63L0 189.1z' />
      <path fill='#eee' d='M0 189.2h512v133.6H0z' />
    </g>
  </svg>
)

// LY Libya
const LyFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#333' d='m0 144.7 257-22.4 255 22.4v222.6l-254.9 31L0 367.3z' />
      <path fill='#d80027' d='M0 0h512v144.7H0z' />
      <path fill='#496e2d' d='M0 367.3h512V512H0z' />
      <g fill='#eee'>
        <path d='m315.6 209.3 21 29 34-11-21 29 21 28.8-34-11-21 29v-36l-34-11 34-11z' />
        <path d='M258.3 328.4a72.3 72.3 0 1 1 34.4-136 89 89 0 1 0 0 127.3 72 72 0 0 1-34.4 8.7z' />
      </g>
    </g>
  </svg>
)

// MA Morocco
const MaFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 0h512v512H0z' />
      <path
        fill='#496e2d'
        d='M407.3 210H291.7L256 100.3 220.3 210H104.7l93.5 68-35.7 109.8L256 320l93.5 68-35.7-110zm-183 59.5 12.2-37.1h39l12.1 37.1-31.6 23-31.6-23zm44-59.4h-24.6l12.3-37.9zm38.3 45.7-7.7-23.4h39.9zM213 232.4l-7.7 23.4-32.2-23.4zm-8.3 97.3 12.3-38 20 14.5zm70.1-23.4 20-14.5 12.3 37.9z'
      />
    </g>
  </svg>
)

// MC Monaco
const McFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='m0 256 258.2-43.3L512 256v256H0z' />
      <path fill='#d80027' d='M0 0h512v256H0z' />
    </g>
  </svg>
)

// MD Moldova (the Republic of)
const MdFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M0 0h144.7l36 254.6-36 257.4H0z' />
      <path fill='#d80027' d='M367.3 0H512v512H367.3l-29.7-257.3z' />
      <path fill='#ffda44' d='M144.7 0h222.6v512H144.7z' />
      <path
        fill='#ff9811'
        d='M345.1 201.4H284a27.8 27.8 0 1 0-55.6 0h-61.2a28.2 28.2 0 0 0 28.3 27.4h-1a27.4 27.4 0 0 0 27.5 27.4c0 13.4 9.6 24.5 22.3 27l-21.6 48.7a88.8 88.8 0 0 0 33.5 6.5 88.8 88.8 0 0 0 33.5-6.5L268.1 283a27.4 27.4 0 0 0 22.3-26.9 27.4 27.4 0 0 0 27.4-27.4h-.9a28.2 28.2 0 0 0 28.3-27.4z'
      />
      <path fill='#0052b4' d='M256.1 239.3 220 256v33.4l36.2 22.3 36.2-22.3V256z' />
      <path fill='#d80027' d='M220 222.6h72.3V256H220z' />
    </g>
  </svg>
)

// ME Montenegro
const MeFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ffda44' d='M0 0h512v44.5l-43.6 209.7L512 467.5V512H0v-44.5l46.6-212L0 44.5z' />
      <path fill='#a2001d' d='M0 44.5h512v423H0z' />
      <path
        fill='#ffda44'
        d='M200.3 189.2h111.4v-44.5l-22.3 11.1-33.4-33.4-33.4 33.4-22.3-11.1zM356.2 256h-55.7a25.5 25.5 0 0 0 3.5-12.8 25.7 25.7 0 0 0-48.3-12.1 25.7 25.7 0 1 0-45 24.9h-54.9c0 17 14.9 30.8 31.9 30.8h-1c0 14 9.2 25.8 22 29.6l-25 25 23.6 23.6 33.5-33.5c1.3.5 2.6.9 4 1.1l-20.2 45.7a83.2 83.2 0 0 0 31.4 6.2 83.2 83.2 0 0 0 31.4-6.2l-20.2-45.7a25.4 25.4 0 0 0 4-1.1l33.5 33.5 23.6-23.6-25-25a30.8 30.8 0 0 0 22-29.6h-1c17 0 31.9-13.8 31.9-30.8z'
      />
      <path fill='#6da544' d='m256 272.7-36.2 16.7v33.4L256 345l36.2-22.2v-33.4z' />
      <path fill='#0052b4' d='M219.8 256h72.4v44.5h-72.4z' />
    </g>
  </svg>
)

// MF Saint Martin (French part)
const MfFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M0 128V0h512v128L299 512h-86z' />
      <circle cx='256' cy='213' r='57' fill='#ffda44' />
      <path fill='#eee' d='M185 213h142l-71 128Z' />
      <path fill='#d80027' d='M256 341 142 235h228z' />
      <path fill='#0052b4' d='m0 128 213 213v171H0Zm512 0L299 341v171h213z' />
    </g>
  </svg>
)

// MG Madagascar
const MgFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M0 0h167l45.6 257.6L167.1 512H0z' />
      <path fill='#d80027' d='M167 0h345v256l-176.7 53.5L166.9 256z' />
      <path fill='#6da544' d='M167 256h345v256H167z' />
    </g>
  </svg>
)

// MH Marshall Islands
const MhFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M0 0h397.6L512 114.2V512H0z' />
      <path fill='#eee' d='M512 0H397.6L0 512 493.4 53.7z' />
      <path fill='#ff9811' d='m0 512 512-397.8V0z' />
      <path
        fill='#eee'
        d='M222.2 150.1 191 164.8l16.7 30.3-34-6.5-4.3 34.3-23.6-25.2-23.7 25.2-4.3-34.3-33.9 6.5 16.6-30.3-31.2-14.7 31.2-14.7L84 105.1l34 6.5 4.2-34.3 23.7 25.3 23.6-25.3 4.3 34.3 34-6.5-16.7 30.3z'
      />
    </g>
  </svg>
)

// MK North Macedonia
const MkFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#ffda44'
        d='M0 0h68.2l86 33.6L216.5 0h78.8l61.2 34.8L443.8 0H512v68.3l-31.4 88 31.4 60.2v78.8L477.4 356l34.6 87.8V512h-68.2l-77-37.3-71.3 37.3h-78.8l-61-39.7L68.2 512H0v-68l40.3-88.2L0 295.5v-78.8L40.3 157 0 68.2z'
      />
      <path
        fill='#d80027'
        d='M295.5 512h148.3L256 256zm-79-512H68.2L256 256zm.2 512L256 256 68.2 512zM0 216.7 256 256 0 68.2zm0 227.2L256 256 0 295.5zM512 68.3 256 256l256-39.5zM443.8 0H295.3L256 256zM512 443.8V295.3L256 256z'
      />
      <circle cx='256' cy='256' r='89' fill='#d80027' />
      <circle cx='256' cy='256' r='66.8' fill='#ffda44' />
    </g>
  </svg>
)

// ML Mali
const MlFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ffda44' d='M167 0h178l25.9 252.3L345 512H167l-29.8-253.4z' />
      <path fill='#6da544' d='M0 0h167v512H0z' />
      <path fill='#d80027' d='M345 0h167v512H345z' />
    </g>
  </svg>
)

// MM Myanmar
const MmFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#6da544' d='m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z' />
      <path fill='#ffda44' d='M0 0h512v167H0z' />
      <path fill='#d80027' d='M0 345h512v167H0z' />
      <path
        fill='#eee'
        d='M431.5 216.5h-134L256 89l-41.4 127.6h-134l108.3 78.8L147.5 423 256 345l108.5 78-41.4-127.6z'
      />
    </g>
  </svg>
)

// MN Mongolia
const MnFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#a2001d' d='M0 0h167l84.9 45L345 0h167v512H345l-87.7-48.1L167 512H0z' />
      <path fill='#0052b4' d='M167 0h178v512H167z' />
      <g fill='#ffda44'>
        <path d='M122.4 256h22.3v89h-22.3zm-89 0h22.3v89H33.4z' />
        <circle cx='89' cy='289.4' r='22.3' />
        <circle cx='89' cy='211.5' r='11.1' />
        <path d='M66.8 322.8h44.5V345H66.8zm0-89h44.5V256H66.8zM89 133.5l8 24.2h25.4l-20.6 15 7.9 24.3L89 182l-20.6 15 7.9-24.3-20.6-15h25.5z' />
      </g>
    </g>
  </svg>
)

// MO Macao
const MoFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#496e2d' d='M0 0h512v512H0z' />
      <path
        fill='#eee'
        d='M300.5 245.3c-6.3 0-12.2 1.3-17.8 3.3 3-6.8 5.1-14.3 5.1-22.4 0-31.8-31.8-55.6-31.8-55.6s-31.8 23.8-31.8 55.6c0 8 2 15.6 5 22.4-5.5-2-11.4-3.3-17.7-3.3-31.8 0-55.7 31.8-55.7 31.8s23.9 31.8 55.7 31.8C230 309 246 298 256 289c10 9.1 25.9 20 44.5 20 31.8 0 55.7-31.8 55.7-31.8s-23.9-31.8-55.7-31.8z'
      />
      <path
        fill='#ffda44'
        d='m256 100.2 6.6 20.2h21.2l-17.2 12.5 6.6 20.2-17.2-12.5-17.2 12.5 6.6-20.2-17.2-12.5h21.2zm-80.8 35.3 12.6 11.4 14.7-8.5-6.9 15.5 12.7 11.4-17-1.8-6.9 15.6-3.5-16.7-17-1.7 14.8-8.5zM116 194.7l16.6 3.5 8.5-14.7 1.8 17 16.6 3.5-15.5 6.9 1.8 16.9-11.4-12.6-15.5 6.9 8.5-14.8zm220.8-59.2L324.2 147l-14.7-8.5 6.9 15.5-12.7 11.4 17-1.8 6.9 15.6 3.5-16.7 17-1.7-14.8-8.5zm59.2 59.2-16.6 3.5-8.5-14.7-1.8 17-16.6 3.5 15.5 6.9-1.8 16.9 11.4-12.6 15.5 6.9-8.5-14.8z'
      />
      <path
        fill='#eee'
        d='M256 398c25.3 0 48.5-8.5 67.2-22.6H188.8c18.7 14.1 42 22.6 67.2 22.6zm-102-66.8a111.3 111.3 0 0 0 13.2 22.6h177.6a111.3 111.3 0 0 0 13.2-22.6z'
      />
    </g>
  </svg>
)

// MP Northern Mariana Islands
const MpFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#338af3' d='M0 0h512v512H0z' />
      <path
        fill='#eee'
        d='M248 417.2a16.7 16.7 0 0 1-15-11 16.7 16.7 0 0 1-29.7-7.6 16.7 16.7 0 0 1-27.6-13.5 16.7 16.7 0 0 1-24.3-18.9 16.7 16.7 0 0 1-17.8-5 16.7 16.7 0 0 1-2.3-18.3 16.7 16.7 0 0 1-15-26.8 16.7 16.7 0 0 1-9.2-29.4 16.7 16.7 0 0 1-3.1-30.5 16.7 16.7 0 0 1 3-30.6 16.7 16.7 0 0 1 9.2-29.4 16.7 16.7 0 0 1 15-26.9 16.7 16.7 0 0 1 2.2-18.3c4.5-5.2 11.5-7 17.7-5a16.7 16.7 0 0 1 6-17.5 16.7 16.7 0 0 1 18.3-1.4 16.7 16.7 0 0 1 27.6-13.6 16.7 16.7 0 0 1 29.7-7.7 16.7 16.7 0 0 1 30.7-1.6 16.7 16.7 0 0 1 30.4 4.6 16.7 16.7 0 0 1 28.9 10.6 16.7 16.7 0 0 1 26.1 16.2c6-2.6 13.2-1.5 18.2 3.2a16.7 16.7 0 0 1 4.1 18 16.7 16.7 0 0 1 17.7 25.1 16.7 16.7 0 0 1 15.4 10.1 16.7 16.7 0 0 1-3.2 18.2 16.7 16.7 0 0 1 6.2 30c6 2.6 10.2 8.5 10.2 15.4v.4c0 6.9-4.2 12.8-10.2 15.4a16.7 16.7 0 0 1-6.1 30 16.7 16.7 0 0 1-12.2 28.3 16.7 16.7 0 0 1-.4 18.5 16.7 16.7 0 0 1-17.1 6.8 16.7 16.7 0 0 1-4.2 18c-5 4.7-12.2 5.7-18.1 3.2a16.7 16.7 0 0 1-26 16.3 16.7 16.7 0 0 1-28.8 10.7 16.7 16.7 0 0 1-30.5 4.6 16.7 16.7 0 0 1-15.9 9.4z'
      />
      <circle cx='256' cy='256' r='111.3' fill='#338af3' />
      <path
        fill='#acabb1'
        d='M280.4 218.2c5.4-4 9-10.5 9-17.9v-11c0-12.4-10-22.3-22.3-22.3H245c-12.3 0-22.3 10-22.3 22.2v11.1c0 7.4 3.6 13.9 9 18L211.5 423s11.1 11 44.5 11 44.5-11 44.5-11z'
      />
      <path
        fill='#eee'
        d='m256 167 19.3 59.5H338l-50.6 36.8 19.3 59.5L256 286l-50.6 36.8 19.3-59.5-50.6-36.8h62.6z'
      />
    </g>
  </svg>
)

// MQ Martinique
const MqFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#6da544' d='M0 0h512v256l-256 44Z' />
      <path fill='#333' d='M210 256h302v256H0z' />
      <path fill='#d80027' d='M0 0v512l256-256L0 0z' />
    </g>
  </svg>
)

// MR Mauritania
const MrFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#496e2d' d='M0 0h512v512H0z' />
      <g fill='#ffda44'>
        <path d='M256 295.8a89 89 0 0 1-87-70 89.4 89.4 0 0 0-2 19 89 89 0 1 0 178 0 89.4 89.4 0 0 0-2-19 89 89 0 0 1-87 70z' />
        <path d='m256 178 8.3 25.6H291l-21.7 15.8 8.3 25.5L256 229l-21.7 15.8 8.3-25.5-21.7-15.8h26.8z' />
      </g>
    </g>
  </svg>
)

// MS Montserrat
const MsFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M256 0h256v512H0V256Z' />
      <path
        fill='#eee'
        d='M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z'
      />
      <path fill='#d80027' d='M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z' />
      <path fill='#338af3' d='M289.4 133.6V256l78 40.4 77.9-40.4V133.6h-156z' />
      <path fill='#a2001d' d='M289.4 256c0 59.6 77.9 78 77.9 78s78-18.4 78-78h-156z' />
      <path
        fill='#333'
        d='M400.7 189.2h-22.3V167h-22.2v22.2h-22.3v22.3h22.3v66.8h22.2v-66.8h22.3z'
      />
    </g>
  </svg>
)

// Malta
const MtFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M0 0h256l52 259.2L256 512H0z' />
      <path fill='#d80027' d='M256 0h256v512H256z' />
      <path
        fill='#acabb1'
        d='M178 100.2V66.8h-33.3v33.4h-33.4v33.4h33.4V167h33.4v-33.4h33.4v-33.4z'
      />
    </g>
  </svg>
)

// MU Mauritius
const MuFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#6da544' d='m0 378.3 254-37.1 258 37V512H0z' />
      <path fill='#ffda44' d='m0 256.1 252.2-33.3L512 256v122.4H0z' />
      <path fill='#0052b4' d='M0 133.7 249.7 97 512 133.7v122.4H0z' />
      <path fill='#d80027' d='M0 0h512v133.7H0z' />
    </g>
  </svg>
)

// MV Maldives
const MvFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 0h512v512H0z' />
      <path fill='#6da544' d='M89 133.6h334v244.8H89z' />
      <path
        fill='#eee'
        d='M297.2 328.3a72.3 72.3 0 1 1 34.4-136 89 89 0 1 0 0 127.3 72 72 0 0 1-34.4 8.7z'
      />
    </g>
  </svg>
)

// MW Malawi
const MwFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z' />
      <path fill='#333' d='M0 0h512v167H0z' />
      <path fill='#496e2d' d='M0 345h512v167H0z' />
      <path
        fill='#d80027'
        d='m332.5 122.4-31.2-14.7 16.6-30.3-34 6.5-4.3-34.3L256 75l-23.6-25.3L228 84l-34-6.5 16.7 30.3-31.3 14.7z'
      />
    </g>
  </svg>
)

// Mexico
const MxFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M144 0h223l33 256-33 256H144l-32-256z' />
      <path fill='#496e2d' d='M0 0h144v512H0z' />
      <path fill='#d80027' d='M368 0h144v512H368z' />
      <path fill='#ffda44' d='M256 277v10h12l10-22z' />
      <path
        fill='#496e2d'
        d='M160 242a96 96 0 0 0 192 0h-11a85 85 0 0 1-170 0zm39 17-4 2c-2 2-2 6 1 8 15 14 34 22 54 24v17h12v-17c20-2 39-10 54-24 3-2 3-6 1-8s-6-2-8 0a78 78 0 0 1-53 21c-19 0-38-8-53-21z'
      />
      <path
        fill='#338af3'
        d='M256 316c-14 0-28-5-40-13l6-9c20 13 48 13 68 0l7 9c-12 8-26 13-41 13z'
      />
      <path
        fill='#751a46'
        d='M256 174c22 11 12 33 11 34l-2-4c-5-11-18-18-31-18v11c6 0 11 5 11 11-7 7-9 17-4 26l4 8-13 23 29-7 18 18v-11l11 11 23-11-35-21-5-21 28 16c4 11 12 21 23 26 9-83-42-91-61-91z'
      />
      <path
        fill='#6da544'
        d='M222 271c-15 0-33-12-38-40l11-2c4 23 18 31 27 31 3 0 5-1 6-3 0-2 0-3-6-5-3-1-7-2-10-5-10-12 4-24 11-30 1-1 2-2 1-3 0 0-2-2-5-2-7 0-12-4-14-11-2-6 2-13 8-17l5 11c-2 0-2 2-2 4 0 0 1 2 3 2 7 0 14 4 16 9 1 3 2 9-5 15-7 7-11 12-9 15l5 1c5 2 14 5 13 17-1 8-8 13-17 13h-1z'
      />
      <path fill='#ffda44' d='m234 186-12 11v11l18-9c3-1 3-5 1-7z' />
      <circle cx='172' cy='275' r='8' fill='#ffda44' />
      <circle cx='189' cy='302' r='8' fill='#ffda44' />
      <circle cx='216' cy='323' r='8' fill='#ffda44' />
      <circle cx='297' cy='323' r='8' fill='#ffda44' />
      <circle cx='324' cy='302' r='8' fill='#ffda44' />
      <circle cx='341' cy='275' r='8' fill='#ffda44' />
      <rect width='34' height='22' x='239' y='299' fill='#ff9811' rx='11' ry='11' />
    </g>
  </svg>
)

// Malaysia
const MyFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#eee'
        d='M0 256 256 0h256v55.7l-19.5 33 19.5 33.7v66.8l-22.1 37.7L512 256v66.8l-20.2 38.5 20.2 28.3v66.7l-254.5 28.2L0 456.3v-66.7l26-35.1-26-31.7z'
      />
      <path
        fill='#d80027'
        d='M256 256h256v-66.8H222.9zm-33.1-133.6H512V55.7H222.9zM512 512v-55.7H0V512zM0 389.6h512v-66.8H0z'
      />
      <path fill='#0052b4' d='M0 0h256v256H0z' />
      <g fill='#ffda44'>
        <path d='M170.2 219.1a63.3 63.3 0 1 1 30.1-119 78 78 0 1 0 0 111.4 63 63 0 0 1-30 7.6z' />
        <path d='m188 111.3 11.3 23.5 25.4-5.9-11.4 23.5 20.4 16.2-25.4 5.7.1 26-20.3-16.2-20.4 16.2.1-26-25.4-5.7 20.4-16.2-11.4-23.5 25.4 6z' />
      </g>
    </g>
  </svg>
)

// MZ Mozambique
const MzFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='m99 136.8 413 20v31.5l-35.9 66.1 36.2 68.4-.3 32.4-413 22z' />
      <path fill='#496e2d' d='M512 156.8V0H0l122 156.8z' />
      <path fill='#333' d='M167 188.3v134.5h345.3l-.3-134.5z' />
      <path fill='#ffda44' d='M512 355.2V512H0l122-156.8z' />
      <path fill='#a2001d' d='M0 0v512l256-256z' />
      <path
        fill='#ffda44'
        d='m103.6 189.2 16.6 51h53.6l-43.4 31.6 16.6 51-43.4-31.5-43.4 31.5 16.6-51-43.4-31.6H87z'
      />
      <path fill='#eee' d='M55.1 256h97v44.5h-97z' />
      <path
        fill='#333'
        d='m170.5 205-15.7-15.8-51.2 51.2-51.1-51.2L36.7 205 88 256l-51.2 51.3 15.8 15.5 51.1-51 51.2 51 15.7-15.5-51.2-51.2z'
      />
    </g>
  </svg>
)

// NA Namibia
const NaFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#eee'
        d='m0 401.9 160.6-237.1L401.9 0H449l63 63v47.3L350.3 339.2 110.3 512H63L0 449z'
      />
      <path fill='#a2001d' d='M0 512h63L512 63V0h-63L0 449z' />
      <path fill='#0052b4' d='M0 0v401.9L401.9 0z' />
      <path fill='#496e2d' d='M512 512V110.3L110.3 512z' />
      <path
        fill='#ffda44'
        d='m211.5 144.7-28.7 13.5L198 186l-31.2-6-4 31.5-21.6-23.2-21.7 23.2-4-31.5-31 6 15.2-27.8L71 144.7l28.7-13.5-15.3-27.8 31.1 6 4-31.5 21.7 23.2L163 78l4 31.5 31-6-15.2 27.8z'
      />
    </g>
  </svg>
)

// NC New Caledonia
const NcFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#496e2d' d='M0 352h512v160H0z' />
      <path fill='#d80027' d='M0 160h512v192H0z' />
      <path fill='#0052b4' d='M0 0h512v160H0z' />
      <path fill='#ffda44' d='M398 256a168 168 0 1 1-336 0 168 168 0 0 1 336 0z' />
      <path
        fill='#333'
        d='M230 80a176 176 0 1 0 0 352 176 176 0 0 0 0-352zm-8 16v34c-8 4-14 8-15 16l-1 16 6-3 10-4v8a24 24 0 0 0-16 23 24 24 0 0 0 16 22v8h-20v16h20v8a24 24 0 0 0-16 22 24 24 0 0 0 16 23v7h-20v17h20v7a24 24 0 0 0-16 23 24 24 0 0 0 16 22v8c-10 0-18 3-23 7-7 5-22 20-30 28a160 160 0 0 1 53-308zm16 0a160 160 0 0 1 51 309l-30-29c-5-4-12-6-21-7v-8a24 24 0 0 0 16-22 24 24 0 0 0-16-23v-7h21v-16h-21v-8a24 24 0 0 0 16-23 24 24 0 0 0-16-22v-8h21v-16h-21v-7a24 24 0 0 0 16-23 24 24 0 0 0-16-23v-20c6-5 11-13 17-23 4-8 2-11 2-11l-2 3-17 11V96z'
      />
    </g>
  </svg>
)

// NE Niger
const NeFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='m0 144.7 255.3-36.5L512 144.7v222.6L250.5 407 0 367.3z' />
      <path fill='#ff9811' d='M0 0h512v144.7H0z' />
      <path fill='#6da544' d='M0 367.3h512V512H0z' />
      <circle cx='256' cy='256.1' r='89' fill='#ff9811' />
    </g>
  </svg>
)

// NF Norfolk Island
const NfFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#6da544'
        d='M0 0h144.7l108.4 41.2L367.3 0H512v512H367.3l-110.2-41.4L144.7 512H0z'
      />
      <path fill='#eee' d='M144.7 0h222.6v512H144.7z' />
      <path fill='#6da544' d='m323 334-67-211.6L189.3 334h50.1v55.7h33.4V334z' />
    </g>
  </svg>
)

// Nigeria
const NgFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#6da544' d='M0 0v512h160l96-64 96 64h160V0H352l-96 64-96-64Z' />
      <path fill='#eee' d='M160 0h192v512H160Z' />
    </g>
  </svg>
)

// Netherlands
const NlFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z' />
      <path fill='#a2001d' d='M0 0h512v167H0z' />
      <path fill='#0052b4' d='M0 345h512v167H0z' />
    </g>
  </svg>
)

// Norway
const NoFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#d80027'
        d='M0 0h100.2l66.1 53.5L233.7 0H512v189.3L466.3 257l45.7 65.8V512H233.7l-68-50.7-65.5 50.7H0V322.8l51.4-68.5-51.4-65z'
      />
      <path
        fill='#eee'
        d='M100.2 0v189.3H0v33.4l24.6 33L0 289.5v33.4h100.2V512h33.4l30.6-26.3 36.1 26.3h33.4V322.8H512v-33.4l-24.6-33.7 24.6-33v-33.4H233.7V0h-33.4l-33.8 25.3L133.6 0z'
      />
      <path fill='#0052b4' d='M133.6 0v222.7H0v66.7h133.6V512h66.7V289.4H512v-66.7H200.3V0z' />
    </g>
  </svg>
)

// NP Nepal
const NpFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M228.4 0H512v512h-27.4L159.4 258.5z' />
      <path
        fill='#0052b4'
        d='M510.5 283.8 228.5 0h-39.3l-70.9 253.8L445.2 512h39.4L256.4 283.8h254z'
      />
      <path fill='#d80027' d='M445.2 256 189.2 0H0v512h445.2l-256-256z' />
      <path
        fill='#eee'
        d='m243.5 378-31.3-14.7L229 333l-34 6.5-4.3-34.3-23.6 25.2-23.7-25.2-4.3 34.3-34-6.5 16.7 30.3L90.4 378l31.3 14.7-16.6 30.3 34-6.5 4.2 34.3 23.7-25.2 23.6 25.2 4.3-34.3 34 6.5-16.7-30.3zM149.8 89l-3.2 25-24.7-4.7 12.1 22-22.7 10.7h-11.1a66.8 66.8 0 0 0 133.5 0h-11.1L200 131.3l12-22-24.6 4.7-3.1-25-17.2 18.4z'
      />
    </g>
  </svg>
)

// NR Nauru
const NrFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M0 0h512v233.7L494.3 257l17.7 21.3V512H0V278.3l18.7-22.9L0 233.7z' />
      <path
        fill='#eee'
        d='m211.5 345-28.7 13.5 15.3 27.8-31.2-6-4 31.5-21.6-23.1-21.7 23.1-4-31.4-31.1 6 15.3-27.9L71 345l28.7-13.4-15.3-27.8 31.1 6 4-31.5 21.7 23.1 21.7-23.1 4 31.4 31-6-15.2 27.9z'
      />
      <path fill='#ffda44' d='M0 233.7h512v44.6H0z' />
    </g>
  </svg>
)

// NU Niue
const NuFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ffda44' d='M0 256 256 0h256v512H0z' />
      <path
        fill='#eee'
        d='M0 0v32l32 32L0 96v160h32l32-32 32 32h32l42-16 41 16h45l-8-16 8-15v-14l-16-42 16-41V96l-32-32 32-32V0H96L64 32 32 0Z'
      />
      <path fill='#0052b4' d='M128 256v-83l83 83zm128-45-83-83h83z' />
      <path fill='#d80027' d='m128 128 128 128v-31l-97-97Z' />
      <path fill='#d80027' d='M32 0v32H0v64h32v160h64V96h160V32H96V0Z' />
      <circle cx='64' cy='64' r='48' fill='#0052b4' />
      <path
        fill='#ffda44'
        d='m50 198 14-44 15 44-38-27h47zM162 86l14-44 15 44-38-27h47ZM64 17l28 86-73-53h90l-73 53Z'
      />
    </g>
  </svg>
)

// New Zealand
const NzFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M256 0h256v512H0V256Z' />
      <path
        fill='#eee'
        d='M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Zm382 92-11 35h-37l30 21-12 35 30-22 30 22-12-35 30-21h-37l-11-35Zm61 72-11 35h-37l30 21-11 35 29-21 30 21-12-35 30-21h-37Zm-123 10-11 35h-37l30 22-11 35 29-22 30 22-11-35 29-22h-36zm59 130-11 35h-37l30 21-11 35 29-21 30 21-11-35 29-21h-36z'
      />
      <path
        fill='#d80027'
        d='M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97zm251 201-5 18h-19l15 10-6 18 15-11 15 11-5-18 14-10h-18Zm-59-129-5 17h-19l15 11-6 17 15-11 15 11-6-17 15-11h-18l-6-17zm123-11-6 18h-18l15 11-6 17 15-11 15 11-6-17 15-11h-18l-6-18zm-61-72-6 17h-18l15 11-6 17 15-10 15 10-6-17 15-11h-18z'
      />
    </g>
  </svg>
)

// OM Oman
const OmFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M189.2 0H512v167l-347.5 24.6z' />
      <path fill='#6da544' d='m163 320 349 25v167H189.2z' />
      <path fill='#d80027' d='M0 0h189.2v167H512v178H189.2v167H0z' />
      <path
        fill='#eee'
        d='M156.6 112.7 133 89l-15.7 15.8L101.5 89 78 112.7l15.8 15.7L78 144l23.6 23.6 15.8-15.7 15.7 15.7 23.6-23.6-15.7-15.7z'
      />
    </g>
  </svg>
)

// PA Panama
const PaFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M0 0h256l256 256v256H256L0 256z' />
      <path fill='#0052b4' d='M0 256v256h256V256z' />
      <path fill='#d80027' d='M256 0h256v256H256z' />
      <path
        fill='#0052b4'
        d='m152.4 89 16.6 51h53.6l-43.4 31.6 16.6 51-43.4-31.5-43.4 31.5 16.6-51L82.2 140h53.6z'
      />
      <path
        fill='#d80027'
        d='m359.6 289.4 16.6 51h53.6L386.4 372l16.6 51-43.4-31.5-43.4 31.6 16.6-51-43.4-31.6H343z'
      />
    </g>
  </svg>
)

// PK Pakistan
const PkFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M0 0h133.6l50.2 252.5L133.6 512H0z' />
      <path fill='#496e2d' d='M133.6 0H512v512H133.6z' />
      <path
        fill='#eee'
        d='M365.5 298.3A72.3 72.3 0 1 1 313.7 168a89 89 0 1 0 74.6 103.2 72 72 0 0 1-22.8 27.2zM364 167l18.2 19.6 24.3-11.3-13 23.5 18.2 19.6-26.3-5.1-13 23.4-3.3-26.7-26.1-5 24.4-11.3z'
      />
    </g>
  </svg>
)

// Peru
const PeFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 0h167l86 41.2L345 0h167v512H345l-87.9-41.4L167 512H0z' />
      <path fill='#eee' d='M167 0h178v512H167z' />
    </g>
  </svg>
)

// PF French Polynesia
const PfFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 0h512v133.7l-52 126 52 118.8V512H0V378.5l53-121L0 133.6z' />
      <path fill='#eee' d='M0 133.7h512v244.8H0z' />
      <path fill='#ffda44' d='M345 256.1c0 49.2-39.8 78-89 78s-89-28.8-89-78a89 89 0 1 1 178 0z' />
      <path fill='#0052b4' d='M345 256.1a89 89 0 1 1-178 0' />
      <path
        fill='#d80027'
        d='M200.3 233.8h22.3v44.6h-22.3zm89 0h22.4v44.6h-22.3zM245 200.4h22v78h-22z'
      />
    </g>
  </svg>
)

// PG Papua New Guinea
const PgFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#333' d='M512 512 301.3 226.6 0 0v512z' />
      <path fill='#a2001d' d='m0 0 512 512V0z' />
      <path
        fill='#eee'
        d='m195 346 4.2 12.9h13.6l-11 8 4.2 12.8-11-7.9-11 7.9 4.2-12.9-11-8h13.6zm-34.6-123.7 7 21.5h22.5L171.7 257l7 21.5-18.3-13.3-18.2 13.3 6.9-21.5-18.2-13.2h22.5zm0 157.4 7 21.5h22.5l-18.2 13.2 7 21.6-18.3-13.4-18.2 13.4 6.9-21.6-18.2-13.2h22.5zm66-101.2 7 21.5H256l-18.2 13.3 6.9 21.4-18.2-13.2-18.3 13.2 7-21.4-18.3-13.3h22.5zm-132 0 7 21.5h22.5l-18.2 13.3 7 21.4-18.3-13.2-18.3 13.2 7-21.4L64.8 300h22.5z'
      />
      <path
        fill='#ffda44'
        d='M430.3 189a67 67 0 0 0-42.6-19.7l48.2-37.6a89.7 89.7 0 0 0-70.3-26A67.2 67.2 0 0 0 348.5 76l-19.2 38.2a28 28 0 0 0-4.8-6.3 28 28 0 1 0-39.7 39.7 28 28 0 0 0 6.3 4.8L253 171.5a67.2 67.2 0 0 0 29.6 17.2 89.7 89.7 0 0 0 26 70.2l42.2-54.2a16.8 16.8 0 0 1 11.9-4.9c4.4 0 8.7 1.7 12 5a16.8 16.8 0 0 1 4.8 11.9c0 4.5-1.7 8.8-4.9 12l15.9 15.9a39.1 39.1 0 0 0 3.7-51.4 44.7 44.7 0 0 1 20.2 11.6 45 45 0 0 1 0 63.6l15.9 15.9a67 67 0 0 0 0-95.4z'
      />
    </g>
  </svg>
)

// Philippines
const PhFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M0 0h512v256l-265 45.2z' />
      <path fill='#d80027' d='M210 256h302v256H0z' />
      <path fill='#eee' d='M0 0v512l256-256z' />
      <path
        fill='#ffda44'
        d='M175.3 256 144 241.3l16.7-30.3-34 6.5-4.3-34.3-23.6 25.2L75 183.2l-4.3 34.3-34-6.5 16.7 30.3L22.3 256l31.2 14.7L37 301l34-6.5 4.2 34.3 23.7-25.2 23.6 25.2 4.3-34.3 34 6.5-16.7-30.3zm-107-155.8 10.4 14.5 17-5.4-10.6 14.4 10.4 14.5-17-5.6L68 147l.2-17.9-17-5.6 17-5.4zm0 264.8 10.4 14.6 17-5.4-10.6 14.3 10.4 14.6-17-5.7L68 411.8l.2-17.9-17-5.6 17-5.4zm148.4-132.4L206.3 247l-17-5.4 10.5 14.4-10.4 14.6 17-5.7 10.6 14.4-.1-17.9 17-5.6-17.1-5.4z'
      />
    </g>
  </svg>
)

// Poland
const PlFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='m0 256 256.4-44.3L512 256v256H0z' />
      <path fill='#eee' d='M0 0h512v256H0z' />
    </g>
  </svg>
)

// PM Saint Pierre and Miquelon
const PmFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#338af3' d='M160 0h352v512H160l-32-256z' />
      <path fill='#eee' d='m0 160 80-32 80 32v192l-80 32-80-32z' />
      <rect width='160' height='160' fill='#d80027' ry='0' />
      <path fill='#6da544' d='M160 21V0h-20L0 139v21h20z' />
      <path fill='#6da544' d='M0 21V0h20l140 139v21h-20z' />
      <path fill='#eee' d='M0 64h160v32H0z' />
      <path fill='#eee' d='M64 0h32v160H64z' />
      <path fill='#d80027' d='M0 512h160V352H0z' />
      <path
        fill='#ffda44'
        d='M340 146v158h-40c-24 0-24-32-24-32h-96v32h20l147 32 145-32v-24h-80s0 24-24 24h-32V146z'
      />
      <path
        fill='#ffda44'
        d='M356 138v32c-31-11-61 8-80-32 33 23 51-10 80 0zm-72 46s-24 24-16 72h-72s32-56 88-72zm16 104h95c-31-48 0-104 0-104h-95s-40 56 0 104zm101-24a96 96 0 0 1 4-64h63s-16 32-1 64zm-101 40h192s-8 0-16 24-16 48-56 48H276c-39 0-52-50-76-72z'
      />
      <rect width='96' height='32' x='32' y='384' fill='#ffda44' rx='16' ry='16' />
      <rect width='96' height='32' x='32' y='448' fill='#ffda44' rx='16' ry='16' />
    </g>
  </svg>
)

// PN Pitcairn
const PnFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M256 0h256v512H0V256Z' />
      <path fill='#acabb1' d='m401 156-34 11-33-11-11-28 11-28h67l-11 28Z' />
      <path fill='#338af3' d='M289 156v122c0 60 78 78 78 78s78-18 78-78V156H289z' />
      <path fill='#6da544' d='M296 307c20 37 71 49 71 49s52-12 71-49l-71-118-71 118z' />
      <path
        fill='#ffda44'
        d='m445 277-78-121-78 121v1a62 62 0 0 0 7 29l71-110 71 110a62 62 0 0 0 7-29z'
      />
      <path
        fill='#eee'
        d='M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z'
      />
      <path fill='#d80027' d='M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z' />
    </g>
  </svg>
)

// Puerto Rico
const PrFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='m27 63.3 485 39.1v102.4L477.3 259l34.7 48.2v102.4L27.4 446.9z' />
      <path
        fill='#d80027'
        d='m0 0 51.2 102.4H512V0zm0 512h512V409.6H51.2zm180-204.8h332V204.8H180z'
      />
      <path fill='#0052b4' d='M0 0v512l256-256z' />
      <path
        fill='#eee'
        d='m103.6 189.2 16.6 51h53.6l-43.4 31.6 16.6 51-43.4-31.5-43.4 31.5 16.6-51-43.4-31.6H87z'
      />
    </g>
  </svg>
)

// PS Palestine
const PsFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M41.3 121.9 512 167v178L43.8 391.3z' />
      <path fill='#333' d='M0 0h512v167H111z' />
      <path fill='#6da544' d='M111 345h401v167H0z' />
      <path fill='#d80027' d='M0 0v512l256-256z' />
    </g>
  </svg>
)

// Portugal
const PtFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#6da544' d='M0 512h167l37.9-260.3L167 0H0z' />
      <path fill='#d80027' d='M512 0H167v512h345z' />
      <circle cx='167' cy='256' r='89' fill='#ffda44' />
      <path fill='#d80027' d='M116.9 211.5V267a50 50 0 1 0 100.1 0v-55.6H117z' />
      <path
        fill='#eee'
        d='M167 283.8c-9.2 0-16.7-7.5-16.7-16.7V245h33.4v22c0 9.2-7.5 16.7-16.7 16.7z'
      />
    </g>
  </svg>
)

// PW Palau
const PwFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#338af3' d='M0 0h512v512H0z' />
      <circle cx='200.3' cy='256' r='111.3' fill='#ffda44' />
    </g>
  </svg>
)

// PY Paraguay
const PyFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='m0 144.7 255.3-36.5L512 144.7v222.6L250.5 407 0 367.3z' />
      <path fill='#d80027' d='M0 0h512v144.7H0z' />
      <path fill='#0052b4' d='M0 367.3h512V512H0z' />
      <path
        fill='#6da544'
        d='m319 182-23.6 23.5a55.5 55.5 0 0 1-39.4 95 55.7 55.7 0 0 1-39.3-95L193 182a89 89 0 1 0 126 0z'
      />
      <path
        fill='#ffda44'
        d='m256 211.5 8.3 25.5H291l-21.7 15.8 8.3 25.5-21.7-15.8-21.7 15.8 8.3-25.5-21.7-15.8h26.8z'
      />
    </g>
  </svg>
)

// Qatar
const QaFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M0 0h173l61 255.8L173.4 512H0z' />
      <path
        fill='#751a46'
        d='m173 0-72.7 30.8L176 63l-75.7 32.2 75.7 32.1-75.7 32.2 75.7 32.1-75.7 32.1 75.7 32.2-75.7 32.2 75.7 32.1-75.7 32.2 75.7 32.1-75.7 32.2 75.7 32.1-75.7 32.2 73.1 31H512V0z'
      />
    </g>
  </svg>
)

// RE Réunion
const ReFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#0052b4'
        d='M64 0 0 64v160l32 32-32 32v224l256-32 256 32V288l-32-32 32-32V64L448 0H288l-32 32-32-32H64z'
      />
      <path fill='#d80027' d='M256 256 0 512h512z' />
      <path fill='#ffda44' d='M0 224v64l512-64v64z' />
      <path fill='#ffda44' d='M256 256 0 64V0h64zm0 0L448 0h64v64zm0 0L224 0h64z' />
    </g>
  </svg>
)

// Romania
const RoFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ffda44' d='M167 0h178l25.9 252.3L345 512H167l-29.8-253.4z' />
      <path fill='#0052b4' d='M0 0h167v512H0z' />
      <path fill='#d80027' d='M345 0h167v512H345z' />
    </g>
  </svg>
)

// RS Serbia
const RsFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z' />
      <path fill='#d80027' d='M0 0h512v167H0z' />
      <path fill='#eee' d='M0 345h512v167H0z' />
      <path fill='#d80027' d='M66.2 144.7v127.7c0 72.6 94.9 95 94.9 95s94.9-22.4 94.9-95V144.7z' />
      <path
        fill='#ffda44'
        d='M105.4 167h111.4v-44.6l-22.3 11.2-33.4-33.4-33.4 33.4-22.3-11.2zm128.3 123.2-72.3-72.4L89 290.2l23.7 23.6 48.7-48.7 48.7 48.7z'
      />
      <path
        fill='#eee'
        d='M233.7 222.6H200a22.1 22.1 0 0 0 3-11.1 22.3 22.3 0 0 0-42-10.5 22.3 22.3 0 0 0-41.9 10.5 22.1 22.1 0 0 0 3 11.1H89a23 23 0 0 0 23 22.3h-.7c0 12.3 10 22.2 22.3 22.2 0 11 7.8 20 18.1 21.9l-17.5 39.6a72.1 72.1 0 0 0 27.2 5.3 72.1 72.1 0 0 0 27.2-5.3L171.1 289c10.3-2 18.1-11 18.1-21.9 12.3 0 22.3-10 22.3-22.2h-.8a23 23 0 0 0 23-22.3z'
      />
    </g>
  </svg>
)

// RU Russian Federation
const RuFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M512 170v172l-256 32L0 342V170l256-32z' />
      <path fill='#eee' d='M512 0v170H0V0Z' />
      <path fill='#d80027' d='M512 342v170H0V342Z' />
    </g>
  </svg>
)

// RW Rwanda
const RwFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#496e2d' d='m0 378.5 254.1-22.1L512 378.5V512H0z' />
      <path fill='#ffda44' d='m0 256.1 255-30.3 257 30.3v122.4H0z' />
      <path fill='#338af3' d='M0 0h512v256H0z' />
      <path
        fill='#ffda44'
        d='m289.4 150 31.3 14.6L304 195l34-6.5 4.3 34.3 23.6-25.2 23.7 25.2 4.3-34.3 34 6.5-16.7-30.3 31.2-14.7-31.2-14.7 16.6-30.3-34 6.5-4.2-34.3-23.7 25.3-23.6-25.3-4.3 34.3-34-6.5 16.7 30.3z'
      />
    </g>
  </svg>
)

// Saudi Arabia
const SaFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#496e2d' d='M0 0h512v512H0z' />
      <g fill='#eee'>
        <path d='M144.7 306c0 18.5 15 33.5 33.4 33.5h100.2a27.8 27.8 0 0 0 27.8 27.8h33.4a27.8 27.8 0 0 0 27.8-27.8V306zm225.4-161.3v78c0 12.2-10 22.2-22.3 22.2v33.4c30.7 0 55.7-25 55.7-55.7v-77.9H370zm-239.3 78c0 12.2-10 22.2-22.3 22.2v33.4c30.7 0 55.7-25 55.7-55.7v-77.9h-33.4z' />
        <path d='M320 144.7h33.4v78H320zm-50 44.5a5.6 5.6 0 0 1-11.2 0v-44.5h-33.4v44.5a5.6 5.6 0 0 1-11.1 0v-44.5h-33.4v44.5a39 39 0 0 0 39 39 38.7 38.7 0 0 0 22.2-7 38.7 38.7 0 0 0 22.2 7c1.7 0 3.4-.1 5-.3a22.3 22.3 0 0 1-21.6 17v33.4c30.6 0 55.6-25 55.6-55.7v-77.9H270z' />
        <path d='M180.9 244.9h50v33.4h-50z' />
      </g>
    </g>
  </svg>
)

// SB Solomon Islands
const SbFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#496e2d' d='M512 512V23.6L256 255.9 23.6 512z' />
      <path fill='#0052b4' d='M0 0h488.4L256 256 0 488.4z' />
      <path fill='#ffda44' d='M488.4 0 0 488.4V512h23.6L512 23.6V0z' />
      <path
        fill='#eee'
        d='m107.8 89 5.5 17h18l-14.6 10.5 5.5 17L108 123l-14.5 10.6 5.5-17L84.4 106h17.8zm91.3 0 5.5 17h18L208 116.4l5.6 17L199 123l-14.5 10.6 5.6-17-14.5-10.6h18zm-91.3 89 5.5 17h18l-14.6 10.5 5.5 17-14.4-10.5-14.5 10.5 5.5-17L84.4 195h17.8zm91.3 0 5.5 17h18L208 205.5l5.6 17-14.5-10.5-14.5 10.5 5.6-17-14.5-10.5h18zm-45.7-44.5 5.6 17h17.8L162.4 161l5.5 17-14.5-10.5L139 178l5.5-17-14.5-10.5h18z'
      />
    </g>
  </svg>
)

// SC Seychelles
const ScFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M0 0v332l150.9-138.5L225.2 0z' />
      <path fill='#ffda44' d='M273.1 253.3 512 0H225.2L0 332v80.2z' />
      <path fill='#d80027' d='M512 0 0 412.2v50.4L277.9 390 512 256z' />
      <path fill='#eee' d='M0 462.6 512 256v133.5l-223.9 78.8L0 488.4z' />
      <path fill='#6da544' d='m512 389.5-512 99V512h512z' />
    </g>
  </svg>
)

// SD Sudan
const SdFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M43.6 109.4 512 144.7v222.6L43.8 397.2z' />
      <path fill='#d80027' d='M0 0h512v144.7H111z' />
      <path fill='#333' d='M111 367.3h401V512H0z' />
      <path fill='#496e2d' d='M0 0v512l256-256z' />
    </g>
  </svg>
)

// Sweden
const SeFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#0052b4'
        d='M0 0h133.6l35.3 16.7L200.3 0H512v222.6l-22.6 31.7 22.6 35.1V512H200.3l-32-19.8-34.7 19.8H0V289.4l22.1-33.3L0 222.6z'
      />
      <path fill='#ffda44' d='M133.6 0v222.6H0v66.8h133.6V512h66.7V289.4H512v-66.8H200.3V0z' />
    </g>
  </svg>
)

// Singapore
const SgFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='m0 256 257.7-51L512 256v256H0z' />
      <path fill='#d80027' d='M0 0h512v256H0z' />
      <g fill='#eee'>
        <path d='M155.8 133.6A78 78 0 0 1 217 57.5a78.2 78.2 0 0 0-16.7-1.8 78 78 0 1 0 16.7 154 78 78 0 0 1-61.2-76.1zM256 61.2l5.5 17h18l-14.6 10.5 5.6 17L256 95.2l-14.5 10.5 5.6-17-14.5-10.5h17.9z' />
        <path d='m212.6 94.6 5.6 17H236l-14.4 10.5 5.5 17-14.5-10.5-14.4 10.5 5.5-17-14.5-10.5h17.9zm86.8 0 5.5 17h17.9l-14.5 10.5 5.5 17-14.4-10.5-14.5 10.5 5.5-17-14.4-10.5h17.8zm-16.7 50.1 5.5 17h17.9l-14.5 10.5 5.5 17-14.4-10.5-14.5 10.5 5.5-17-14.4-10.5h17.9zm-53.4 0 5.5 17h18l-14.5 10.5 5.5 17-14.5-10.5-14.4 10.5 5.5-17-14.5-10.5h17.9z' />
      </g>
    </g>
  </svg>
)

// SH Saint Helena, Ascension and Tristan da Cunha
const ShFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M256 0h256v512H0V256Z' />
      <path
        fill='#eee'
        d='M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z'
      />
      <path fill='#d80027' d='M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z' />
      <path fill='#eee' d='M288 128h160v80l-80 32-80-32z' />
      <path
        fill='#333'
        d='M368 140a14 14 0 0 0-14 14h-42a14 14 0 0 0 14 14 14 14 0 0 0 14 14 14 14 0 0 0 14 14h28a14 14 0 0 0 14-14 14 14 0 0 0 14-14 14 14 0 0 0 14-14h-42a14 14 0 0 0-14-14z'
      />
      <path fill='#338af3' d='M288 208v48c0 61 80 80 80 80s80-19 80-80v-48z' />
      <path
        fill='#eee'
        d='M372 221c-9 0-15 8-25 1 5 12 14 9 22 10v6h-14s-14 20 0 38h14v5h-14c-9 0-9-11-9-11h-34v11h7c9 8 13 26 27 26h52c15 0 17-9 20-17 3-7 5-8 6-9v-8h-29s0 8-8 8h-12v-6h14c-11-17 0-37 0-37h-14v-16l-4-1zm-23 17c-20 6-31 26-31 26h25c-2-17 6-26 6-26zm44 6a34 34 0 0 0-2 23h24c-5-12 0-23 0-23z'
      />
    </g>
  </svg>
)

// Slovenia
const SiFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z' />
      <path fill='#eee' d='M0 0h512v167H0z' />
      <path fill='#d80027' d='M0 345h512v167H0z' />
      <path fill='#0052b4' d='M222.7 167v-66.8H89V167l67 82.6z' />
      <path
        fill='#eee'
        d='M89 167v22.2c0 51.1 66.8 66.8 66.8 66.8s66.8-15.7 66.8-66.8V167l-22.3 22.2-44.5-33.4-44.5 33.4z'
      />
    </g>
  </svg>
)

// Slovakia
const SkFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='m0 160 256-32 256 32v192l-256 32L0 352z' />
      <path fill='#eee' d='M0 0h512v160H0z' />
      <path fill='#d80027' d='M0 352h512v160H0z' />
      <path fill='#eee' d='M64 63v217c0 104 144 137 144 137s144-33 144-137V63z' />
      <path fill='#d80027' d='M96 95v185a83 78 0 0 0 9 34h206a83 77 0 0 0 9-34V95z' />
      <path
        fill='#eee'
        d='M288 224h-64v-32h32v-32h-32v-32h-32v32h-32v32h32v32h-64v32h64v32h32v-32h64z'
      />
      <path
        fill='#0052b4'
        d='M152 359a247 231 0 0 0 56 24c12-3 34-11 56-24a123 115 0 0 0 47-45 60 56 0 0 0-34-10l-14 2a60 56 0 0 0-110 0 60 56 0 0 0-14-2c-12 0-24 4-34 10a123 115 0 0 0 47 45z'
      />
    </g>
  </svg>
)

// SJ Svalbard and Jan Mayen
// no svg was there in github link

// SL Sierra Leone
const SlFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z' />
      <path fill='#6da544' d='M0 0h512v167H0z' />
      <path fill='#338af3' d='M0 345h512v167H0z' />
    </g>
  </svg>
)

// SM San Marino
const SmFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#338af3' d='m0 256 256-52.3L512 256v256H0z' />
      <path fill='#eee' d='M0 0h512v256H0z' />
      <path
        fill='#6da544'
        d='M357.6 176.6 256 278.3 154.4 176.6a121.7 121.7 0 0 0-20.8 68.3v33.4c0 53.6 34.6 99.2 82.7 115.8a37 37 0 0 0 4 40l36.4-29.2 36.4 29.2a37 37 0 0 0 3.9-40.5 122.6 122.6 0 0 0 81.4-115.3v-33.4c0-25.3-7.6-48.7-20.8-68.3z'
      />
      <path
        fill='#ffda44'
        d='M256 367.3c-49.1 0-89-40-89-89v-33.4a89.1 89.1 0 0 1 178 0v33.4c0 49-39.9 89-89 89z'
      />
      <path fill='#338af3' d='M311.7 278.3v-33.4a55.7 55.7 0 0 0-111.4 0v33.4l55.7 11z' />
      <path fill='#6da544' d='M200.3 278.3a55.7 55.7 0 0 0 111.4 0z' />
      <path
        fill='#ffda44'
        d='M322.8 155.8A33.4 33.4 0 0 0 267 131v-19.6h11.2V89H267V78h-22v11h-11.2v22.3H245v19.6a33.4 33.4 0 0 0-44.5 49.8v19.6h111.3v-19.6c6.8-6.1 11-15 11-24.9z'
      />
    </g>
  </svg>
)

// SN Senegal
const SnFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ffda44' d='M144.8 0h222.4l32 260-32 252H144.8l-32.1-256z' />
      <path fill='#496e2d' d='M0 0h144.8v512H0z' />
      <path fill='#d80027' d='M367.2 0H512v512H367.2z' />
      <path
        fill='#496e2d'
        d='m256.1 167 22.1 68h71.5L292 277l22 68-57.8-42-57.9 42 22.1-68-57.8-42H234z'
      />
    </g>
  </svg>
)

// SO Somalia
const SoFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#338af3' d='M0 0h512v512H0z' />
      <path
        fill='#eee'
        d='m256 133.6 27.6 85H373L300.7 271l27.6 85-72.3-52.5-72.3 52.6 27.6-85-72.3-52.6h89.4z'
      />
    </g>
  </svg>
)

// SR Suriname
const SrFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#6da544' d='M0 0h512v111.3l-85.3 143.1L512 400.7V512H0V400.7l87-149L0 111.3z' />
      <path fill='#eee' d='M0 111.3h512V167l-41 84.7 41 93.3v55.7H0V345l44.2-86.6L0 167z' />
      <path fill='#a2001d' d='M0 167h512v178H0z' />
      <path
        fill='#ffda44'
        d='m256 167 22.1 68h71.5l-57.8 42 22 68-57.8-42-57.9 42 22.1-68-57.8-42h71.5z'
      />
    </g>
  </svg>
)

// SS South Sudan
const SsFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M74.1 115 512 156.9v31.5l-42.4 70.3 42.4 64.2v31.5L74.1 386.8z' />
      <path fill='#333' d='M0 0h512v156.8H50z' />
      <path fill='#a2001d' d='M150.6 188.3H512v134.5H150.6z' />
      <path fill='#496e2d' d='M50 354.3h462V512H0z' />
      <path fill='#0052b4' d='M0 0v512l256-256z' />
      <path
        fill='#ffda44'
        d='m83.4 192.4 31.2 43.6 51.2-16.3-31.9 43.2 31.3 43.6-51-16.9-31.7 43.2.3-53.7L32 262.2 83 246z'
      />
    </g>
  </svg>
)

// ST Sao Tome and Principe
const StFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#6da544' d='M0 0h512v167l-52.6 83.8L512 345v167H0l72-264.3z' />
      <path fill='#ffda44' d='M114.9 166.9H512v178H114.9z' />
      <path fill='#d80027' d='M0 0v512l256-256z' />
      <path
        fill='#333'
        d='m325 211.5 11.1 34H372l-29 21 11.1 34-29-21-28.9 21 11-34-28.8-21H314zm111.4 0 11 34h35.8l-29 21 11.1 34-29-21-28.9 21 11.1-34-29-21h35.8z'
      />
    </g>
  </svg>
)

// SV El Salvador
const SvFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M0 0h512v144.7l-40.5 112.6 40.5 110V512H0V367.3l42.2-114L0 144.7z' />
      <path fill='#eee' d='M0 144.7h512v222.6H0z' />
      <path fill='#ffda44' d='m204.6 267.1 51.4-89 51.4 89z' />
      <path fill='#6da544' d='M322.8 296.5 256 330l-66.8-33.4V252h133.6z' />
      <path
        fill='#ffda44'
        d='m319 182-23.6 23.5a55.5 55.5 0 0 1-39.4 95 55.7 55.7 0 0 1-39.3-95L193 182a89 89 0 1 0 126 0z'
      />
    </g>
  </svg>
)

// SX Sint Maarten (Dutch part)
const SxFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 0h512v256l-265 45.2z' />
      <path fill='#0052b4' d='M210 256h302v256H0z' />
      <path fill='#eee' d='M0 0v512l256-256z' />
      <g fill='#ffda44'>
        <path d='M28 256a73.1 73.1 0 0 0-.2 5.6 72.3 72.3 0 1 0 144.5-5.6z' />
        <circle cx='100.2' cy='200.3' r='22.3' />
      </g>
      <path fill='#d80027' d='M50 194.8V267c0 38.4 50.2 50 50.2 50s50-11.6 50-50v-72.3h-100z' />
      <path
        fill='#338af3'
        d='M100.2 294c-9.3-3.4-28-12-28-27v-50H128v50c0 15-18.6 23.6-27.8 26.9z'
      />
      <path fill='#eee' d='M111.3 244.9v-11.2l-11.1-5.5-11.2 5.5V245l-5.5 5.5v22.3h33.4v-22.3z' />
    </g>
  </svg>
)

// SY Syrian Arab Republic
const SyFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z' />
      <path fill='#d80027' d='M0 0h512v167H0z' />
      <path fill='#333' d='M0 345h512v167H0z' />
      <path
        fill='#6da544'
        d='m153 194.8 13.8 42.5h44.7l-36.2 26.3 13.8 42.5-36.1-26.3-36.2 26.3 13.8-42.5-36.2-26.3h44.7zm206 0 13.9 42.5h44.7l-36.2 26.3 13.8 42.5-36.2-26.3-36.1 26.3 13.8-42.5-36.2-26.3h44.7z'
      />
    </g>
  </svg>
)

// SZ Eswatini
const SzFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#ffda44'
        d='m0 144.7 256-20.5 256 20.5V178l-37.4 79 37.4 77v33.3l-256 24.1L0 367.3V334l37.7-77.3L0 178z'
      />
      <path fill='#333' d='M0 0h512v144.7H0z' />
      <path fill='#0052b4' d='M0 367.3h512V512H0z' />
      <path fill='#a2001d' d='M0 178h512v156H0z' />
      <path fill='#ffda44' d='M89.2 244.9h334V267h-334zm44.6-44.6h244.8v22.3H133.8z' />
      <path
        fill='#eee'
        d='m256.2 189.2-18 65.2 18 68.4c66.8 0 124-66.8 124-66.8s-57.2-66.8-124-66.8z'
      />
      <path fill='#333' d='M256.2 322.8c-66.8 0-124-66.8-124-66.8s57.2-66.8 124-66.8' />
      <path fill='#eee' d='M211.7 233.7h22.2v44.6h-22.2z' />
      <path fill='#333' d='M278.5 233.7h22.2v44.6h-22.2z' />
      <g fill='#0052b4' transform='translate(.2)'>
        <circle cx='89' cy='256' r='22.3' />
        <circle cx='423' cy='256' r='22.3' />
      </g>
    </g>
  </svg>
)

// TC Turks and Caicos Islands
const TcFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M256 0h256v512H0V256Z' />
      <path
        fill='#eee'
        d='M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z'
      />
      <path fill='#d80027' d='M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z' />
      <path fill='#ffda44' d='M289.4 133.6V256c0 59.6 77.9 78 77.9 78s78-18.4 78-78V133.6h-156z' />
      <path
        fill='#ff9811'
        d='M356.2 178c0 12.4-10 44.6-22.3 44.6s-22.2-32.2-22.2-44.5c0-12.3 22.2-22.3 22.2-22.3s22.3 10 22.3 22.3z'
      />
      <path
        fill='#a2001d'
        d='M415.2 202.3a92.2 92.2 0 0 0 6.4-28c0-10.2-13.3-18.5-13.3-18.5s-13.4 8.3-13.4 18.6c0 6.4 2.8 19.2 6.4 28l-7.7 17.3a38.9 38.9 0 0 0 14.7 3 38.9 38.9 0 0 0 14.7-3z'
      />
      <path
        fill='#6da544'
        d='M350.6 256s-11.1 22.3-11.1 44.5H395c0-22.2-11.1-44.5-11.1-44.5l-16.7-11.1-16.7 11.1Z'
      />
      <path fill='#d80027' d='M384 256v-5.6a16.7 16.7 0 0 0-33.4 0v5.6z' />
    </g>
  </svg>
)

// TD Chad
const TdFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ffda44' d='M167 0h178l25.9 252.3L345 512H167l-29.8-253.4z' />
      <path fill='#026' d='M0 0h167v512H0z' />
      <path fill='#d80027' d='M345 0h167v512H345z' />
    </g>
  </svg>
)

// TF French Southern Territories
const TfFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M256 0h256v512H0V256Z' />
      <path fill='#eee' d='M0 0h256v256H0z' />
      <path fill='#0052b4' d='M0 0h75v224H0z' />
      <path fill='#d80027' d='M149 0h75v224h-75z' />
      <path
        fill='#eee'
        d='m323 158 13 21h36v71l-27-43-37 59h18l19-34 39 70 39-70 19 34h18l-37-59-27 43v-39h16l12-20h-28v-12h36l13-21zm43 88h-40v14h40zm76 0h-40v14h40z'
      />
      <path
        fill='#eee'
        d='m301 181 13 38-34-23h42l-34 23zm166 0 13 38-34-23h42l-34 23zM339 282l13 38-34-23h42l-34 23zm90 0 13 38-34-23h42l-34 23zm-45 34 13 38-34-23h42l-34 23z'
      />
    </g>
  </svg>
)

// TG Togo
const TgFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#496e2d'
        d='M256 0h256v102.4L483.8 151l28.2 53.8v102.4l-30.5 50.7 30.5 51.7V512H0V409.6l34.7-51L0 307.1z'
      />
      <path fill='#ff9811' d='M0 44.5v423V256z' />
      <path
        fill='#ffda44'
        d='M231.7 102.4v102.4H512V102.4zM0 307.2v102.4h512V307.2H256l-128.2-26.4z'
      />
      <path fill='#d80027' d='M256 307.2V0H0v307.2z' />
      <path
        fill='#eee'
        d='m141.4 122.4 16.5 51h53.7L168 205l16.6 51-43.4-31.5L98 256l16.5-51L71 173.5h53.7z'
      />
    </g>
  </svg>
)

// Thailand
const ThFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 0h512v89l-79.2 163.7L512 423v89H0v-89l82.7-169.6L0 89z' />
      <path fill='#eee' d='M0 89h512v78l-42.6 91.2L512 345v78H0v-78l40-92.5L0 167z' />
      <path fill='#0052b4' d='M0 167h512v178H0z' />
    </g>
  </svg>
)
// TJ Tajikistan
const TjFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='m0 144.7 255.3-36.5L512 144.7v222.6L250.5 407 0 367.3z' />
      <path fill='#d80027' d='M0 0h512v144.7H0z' />
      <path fill='#6da544' d='M0 367.3h512V512H0z' />
      <path
        fill='#ffda44'
        d='M211.5 323h89v-38l-17.8 9-26.7-26.9-26.7 26.7-17.8-8.9zm-51-44.6 4.2 12.7H178l-10.9 8 4.2 12.7-10.9-8-10.8 8 4.1-12.8-10.7-7.9h13.4zm12.9-44.6 4.1 12.8H191l-10.8 8 4.1 12.6-10.8-7.9-10.9 8 4.2-12.8-10.9-8h13.4zm36.7-33.4 4.2 12.8h13.4l-10.9 8 4.2 12.6-11-7.7-10.8 7.8 4.1-12.7-10.8-7.9H206zm141.4 78-4.2 12.7H334l10.9 8-4.2 12.7 10.9-8 10.8 8-4.1-12.8 10.7-7.9h-13.4zm-12.9-44.6-4.1 12.8H321l10.8 8-4.1 12.6 10.8-7.9 10.9 8-4.2-12.8 10.9-8h-13.4zM302 200.4l-4.2 12.8h-13.4l10.9 8-4.2 12.6 10.9-7.7 10.8 7.8-4.1-12.7 10.8-7.9H306zm-46-16.6 4.1 12.7h13.5l-10.9 8 4.1 12.6-10.8-7.8-10.8 7.8 4.1-12.7-10.9-7.9H252z'
      />
    </g>
  </svg>
)

// TK Tokelau
const TkFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M0 0h512v512H0z' />
      <path
        fill='#eee'
        d='m188 133.6 5.6 17h17.9L197 161l5.5 17-14.4-10.5-14.5 10.5 5.5-17-14.4-10.5h17.8zM115.5 256l7 21.3h22.3l-18 13 6.8 21.4-18-13.2-18.1 13.2 6.9-21.3-18.1-13.1h22.3zm0-178 7 21.2h22.3l-18 13.1 6.8 21.3-18-13.2-18.1 13.2 6.9-21.3-18.1-13.1h22.3zM59.8 178l6.9 21.3H89l-18 13.2 6.9 21.2-18.1-13.1-18.1 13.1 7-21.2-18.2-13.2H53z'
      />
      <path
        fill='#eee'
        d='m188 133.6 5.6 17h17.9L197 161l5.5 17-14.4-10.5-14.5 10.5 5.5-17-14.4-10.5h17.8zM115.5 256l7 21.3h22.3l-18 13 6.8 21.4-18-13.2-18.1 13.2 6.9-21.3-18.1-13.1h22.3zm0-178 7 21.2h22.3l-18 13.1 6.8 21.3-18-13.2-18.1 13.2 6.9-21.3-18.1-13.1h22.3zM59.8 178l6.9 21.3H89l-18 13.2 6.9 21.2-18.1-13.1-18.1 13.1 7-21.2-18.2-13.2H53z'
      />
      <path
        fill='#ffda44'
        d='M411.8 122.4 144.7 345h361.7v-35.8a167.4 167.4 0 0 1-97.9-152.3c0-11.7 1-23.5 3.3-34.5zm94.6 244.9H144.7v33.4h361.7z'
      />
    </g>
  </svg>
)

// TL Timor-Leste
const TlFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ffda44' d='m0 0 214 251.8L0 512l418-256z' />
      <path fill='#d80027' d='M512 0H0l367.3 256L0 512h512z' />
      <path fill='#333' d='M0 0v512l256-256z' />
      <path
        fill='#eee'
        d='m71 197.4 39 36.8 47-25.6-23 48.4 39 36.9-53.2-7-23 48.5-9.9-52.7-53.2-7 47.1-25.6z'
      />
    </g>
  </svg>
)

// TM Turkmenistan
const TmFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#496e2d' d='M0 0h66.8l67.8 32.3L200.3 0H512v512H200.3l-70.2-34.1L66.8 512H0z' />
      <path fill='#d80027' d='M66.8 0h133.5v512H66.8z' />
      <g fill='#eee'>
        <path d='M374.4 193.1a78 78 0 0 0-31.9-92.3 78.2 78.2 0 0 1 16.3 4 78 78 0 1 1-52.6 146.6 78.1 78.1 0 0 1-15.1-7.3 78 78 0 0 0 83.3-51zm-69.8-102-11 14.2-16.8-6 10 14.8-10.9 14 17.2-5 10 14.9.6-18 17.2-5-16.9-6z' />
        <path d='m334.1 137.3-11 14-16.8-6 10.1 14.8-11 14.2 17.2-5 10.1 14.7.5-17.8 17.2-5-16.8-6zM252.5 108l-11 14.1-16.8-6 10 14.7-10.9 14.2 17.2-5 10 14.7.6-17.8 17.1-5-16.8-6zm-1.2 52.7-11 14.2-16.8-6 10 14.7-10.9 14.2 17.2-5 10 14.7.6-17.8 17.1-5-16.8-6zm50.2 18-11 14.2-16.8-6 10 14.7-10.9 14.2 17.2-5 10 14.7.6-17.8 17.2-5-16.9-6z' />
      </g>
      <path fill='#eee' d='M117.8 134.8 95.4 118v-12l38.2-28 15.8-.1 22.3 16.7v11.5l-38.1 28.7z' />
      <path
        fill='#ff9811'
        d='M133.6 78h-15.8L95.4 94.5V106h38.2zm0 56.8h15.8l22.3-16.7v-12h-38.1z'
      />
      <path
        fill='#496e2d'
        d='m117.8 284.4-22.4-16.6v-23.6l22.4-16.6h31.6l22.3 16.6v23.6l-22.3 16.6zm54.7 36.7h-9.7v-9.8h-17.1l-12.1-12-12.1 12h-17.2v9.8h-9.7v19.5h9.7v9.7h17.2l12 12.1 12.2-12.1h17v-9.7h9.8zm0-149.7h-9.7v-9.7h-17.1l-12.1-12.1-12.1 12h-17.2v9.8h-9.7V191h9.7v9.8h17.2l12 12 12.2-12h17V191h9.8z'
      />
      <g fill='#d80027'>
        <path d='M122.4 244.9h22.3V267h-22.3z' />
        <circle cx='133.6' cy='181.2' r='11.1' />
        <circle cx='133.6' cy='330.8' r='11.1' />
      </g>
      <path fill='#eee' d='m117.8 434-22.4-16.8v-12l38.2-28 15.8-.1 22.3 16.7v11.5L133.6 434z' />
      <path
        fill='#ff9811'
        d='M133.6 377.2h-15.8l-22.4 16.5v11.5h38.2zm0 56.8h15.8l22.3-16.7v-12h-38.1z'
      />
    </g>
  </svg>
)

// TN Tunisia
const TnFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 0h512v512H0z' />
      <circle cx='256' cy='256' r='122.4' fill='#eee' />
      <g fill='#d80027'>
        <path d='m271 209.2 21 29 34.1-11.1-21 29 21 28.9-34-11.1-21 29V267L237 256l34-11z' />
        <path d='M283.8 328.3a72.3 72.3 0 1 1 34.4-136 89 89 0 1 0 0 127.3 72 72 0 0 1-34.4 8.7z' />
      </g>
    </g>
  </svg>
)

// TO Tonga
const ToFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 256 256 0h256v512H0z' />
      <path fill='#eee' d='M0 0h256v256H0z' />
      <path
        fill='#d80027'
        d='M167 133.6v-33.4h-33.4v33.4h-33.4V167h33.4v33.3H167V167h33.3v-33.4z'
      />
    </g>
  </svg>
)

// Turkey
const TrFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 0h512v512H0z' />
      <g fill='#eee'>
        <path d='m350 182 33 46 54-18-33 46 33 46-54-18-33 46v-57l-54-17 54-18v-56Z' />
        <path d='M260 370a114 114 0 1 1 54-215 141 141 0 1 0 0 202c-17 9-35 13-54 13Z' />
      </g>
    </g>
  </svg>
)

// Trinidad And Tobago
const TtFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 110.2 110.2 0H512v401.8L401.8 512H0z' />
      <path fill='#eee' d='M110.2 0H63L0 63v47.2L401.8 512H449l63-63v-47.2z' />
      <path fill='#333' d='M512 512v-63L63 0H0v63l449 449z' />
    </g>
  </svg>
)

// TV Tuvalu
const TvFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#338af3' d='M0 256 256 0h256v512H0z' />
      <path
        fill='#eee'
        d='M0 0h33.4l32 16.9L100.3 0H256v33.4l-14.8 33.5 14.8 33.3v33.4l-9.3 33.7 9.3 41.5v15.7l-6.2 11.6L256 256h-47.2l-39.3-7-35.9 7.1-33.4-.1-32.6-16.6L33.4 256H0V100.2l14.2-35.8L0 33.4z'
      />
      <path fill='#d80027' d='m256 224.5-91-91h-31.4L256 256z' />
      <path fill='#d80027' d='M33.4 0v33.4H0v66.8h33.4V256h66.8V100.2H256V33.4H100.2V0z' />
      <path
        fill='#ffda44'
        d='m279.4 423 5.5 17h18l-14.6 10.5 5.6 17-14.5-10.5-14.5 10.5 5.6-17L256 440h17.9zm142.4-111.3 5.5 17h18l-14.5 10.5 5.5 17-14.5-10.5-14.5 10.5 5.6-17-14.5-10.5h17.9zm35.7-167 5.5 17h18l-14.5 10.5 5.6 17-14.5-10.5-14.5 10.5 5.6-17-14.5-10.5H452zm8.8 122.4 5.6 17h17.8l-14.4 10.5 5.5 17-14.5-10.5-14.4 10.6 5.5-17-14.5-10.6h18zM305 383l16 8 12.6-12.6-2.8 17.7 16 8.1L329 407l-2.8 17.7-8.1-16-17.7 2.8 12.7-12.6zm0-66.8 16 8.1 12.6-12.6-2.8 17.6 16 8.1-17.7 2.8-2.8 17.7-8.1-16-17.7 2.9 12.7-12.7zm55.7 42.8 16 8.1 12.6-12.6-2.8 17.6 16 8.1-17.8 2.8-2.7 17.7-8.2-16-17.6 2.9 12.6-12.7zm0-143 16 8.1 12.6-12.6-2.8 17.6 16 8.2-17.8 2.8-2.7 17.6-8.2-16-17.6 2.9 12.6-12.7zm54-1.7 15.9 8.1 12.6-12.6-2.8 17.6 16 8.1-17.7 2.8-2.8 17.7-8.1-16-17.8 3 12.7-12.7z'
      />
      <path fill='#0052b4' d='M180.8 133.6H256v75.2zm-47.2 47.2v75.3l75.2-.1z' />
    </g>
  </svg>
)

// Taiwan
const TwFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 256 256 0h256v512H0z' />
      <path fill='#0052b4' d='M256 256V0H0v256z' />
      <path
        fill='#eee'
        d='m222.6 149.8-31.3 14.7 16.7 30.3-34-6.5-4.3 34.3-23.6-25.2-23.7 25.2-4.3-34.3-34 6.5 16.7-30.3-31.2-14.7 31.2-14.7-16.6-30.3 34 6.5 4.2-34.3 23.7 25.3L169.7 77l4.3 34.3 34-6.5-16.7 30.3z'
      />
      <circle cx='146.1' cy='149.8' r='47.7' fill='#0052b4' />
      <circle cx='146.1' cy='149.8' r='41.5' fill='#eee' />
    </g>
  </svg>
)

// TZ Tanzania
const TzFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M0 0h512v512H0z' />
      <path fill='#ffda44' d='M399 0 167 167 0 399v45l68 68h45l232-167 167-232V68L444 0Z' />
      <path fill='#333' d='M444 0 0 444v68h68L512 68V0Z' />
      <path fill='#338af3' d='m113 512 399-399v399z' />
      <path fill='#6da544' d='M0 399V0h399Z' />
    </g>
  </svg>
)

// UA Ukraine
const UaFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ffda44' d='m0 256 258-39.4L512 256v256H0z' />
      <path fill='#338af3' d='M0 0h512v256H0z' />
    </g>
  </svg>
)

// UG Uganda
const UgFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ffda44' d='M0 85v342l256 31 256-31V85L256 53Z' />
      <path fill='#333' d='M0 0h512v85H0z' />
      <path fill='#d80027' d='M0 171h512v85l-256 31L0 256Z' />
      <path fill='#333' d='M0 256h512v85H0z' />
      <path fill='#d80027' d='M0 427h512v85H0z' />
      <circle cx='256' cy='256' r='85.3' fill='#eee' />
      <path
        fill='#333'
        d='m287 260-31-13 8-26a17 17 0 0 0-5-16l8-8a28 28 0 0 0-19-8 28 28 0 0 0-20 8l8 8a17 17 0 0 0-5 12l1 5-12 12h21s-9 13-14 24c-4 11 0 25 12 30l6 2 11 10v12l-11 11h22v-23l10-10h21a22 22 0 0 0-11-30z'
      />
    </g>
  </svg>
)

// United States
const UsFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#eee'
        d='M256 0h256v64l-32 32 32 32v64l-32 32 32 32v64l-32 32 32 32v64l-256 32L0 448v-64l32-32-32-32v-64z'
      />
      <path
        fill='#d80027'
        d='M224 64h288v64H224Zm0 128h288v64H256ZM0 320h512v64H0Zm0 128h512v64H0Z'
      />
      <path fill='#0052b4' d='M0 0h256v256H0Z' />
      <path
        fill='#eee'
        d='m187 243 57-41h-70l57 41-22-67zm-81 0 57-41H93l57 41-22-67zm-81 0 57-41H12l57 41-22-67zm162-81 57-41h-70l57 41-22-67zm-81 0 57-41H93l57 41-22-67zm-81 0 57-41H12l57 41-22-67Zm162-82 57-41h-70l57 41-22-67Zm-81 0 57-41H93l57 41-22-67zm-81 0 57-41H12l57 41-22-67Z'
      />
    </g>
  </svg>
)

// Uruguay
const UyFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#338af3'
        d='M0 256 256 0h256v55.7l-20.7 34.5 20.7 32.2v66.8l-21.2 32.7L512 256v66.8l-24 31.7 24 35.1v66.7l-259.1 28.3L0 456.3v-66.7l27.1-33.3L0 322.8z'
      />
      <path
        fill='#eee'
        d='M256 256h256v-66.8H236.9zm-19.1-133.6H512V55.7H236.9zM512 512v-55.7H0V512zM0 389.6h512v-66.8H0z'
      />
      <path fill='#eee' d='M0 0h256v256H0z' />
      <path
        fill='#ffda44'
        d='m222.6 149.8-31.3 14.7 16.7 30.3-34-6.5-4.3 34.3-23.6-25.2-23.7 25.2-4.3-34.3-33.9 6.5 16.6-30.3-31.2-14.7 31.2-14.7-16.6-30.3 34 6.5 4.2-34.3 23.7 25.3L169.7 77l4.3 34.3 34-6.5-16.7 30.3z'
      />
    </g>
  </svg>
)

// UZ Uzbekistan
const UzFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path
        fill='#d80027'
        d='m0 178 254.2-22L512 178v22.3l-40.2 54.1 40.2 57.3V334l-254 23.4L0 334v-22.3l36.7-59.4-36.7-52z'
      />
      <path fill='#338af3' d='M0 0h512v178H0z' />
      <path fill='#eee' d='M0 200.3h512v111.4H0z' />
      <path fill='#6da544' d='M0 334h512v178H0z' />
      <path
        fill='#eee'
        d='M117.2 105.7a50 50 0 0 1 39.3-48.9 50.2 50.2 0 0 0-10.7-1.1 50 50 0 1 0 10.7 99c-22.5-5-39.3-25-39.3-49zm69 22.8 3.3 10.4h11l-9 6.5 3.5 10.4-9-6.4-8.7 6.4 3.4-10.4-9-6.5h11zm35 0 3.4 10.4h11l-9 6.5 3.4 10.4-8.8-6.4-9 6.4 3.5-10.4-9-6.5h11zm35 0 3.4 10.4h11l-9 6.5 3.5 10.4-9-6.4-8.8 6.4 3.4-10.4-9-6.5h11zm35 0 3.4 10.4h11l-9 6.5 3.5 10.4-9-6.4-8.8 6.4 3.4-10.4-9-6.5h11zm35 0 3.4 10.4h11l-9 6.5 3.5 10.4-9-6.4-8.8 6.4 3.4-10.4-8.8-6.5h11zm-105-36.4 3.4 10.4h11l-9 6.5 3.4 10.4-8.8-6.5-9 6.5 3.5-10.4-9-6.5h11zm35 0 3.4 10.4h11l-9 6.5 3.5 10.4-9-6.5-8.8 6.5 3.4-10.4-9-6.5h11zm35 0 3.4 10.4h11l-9 6.5 3.5 10.4-9-6.5-8.8 6.5 3.4-10.4-9-6.5h11zm35 0 3.4 10.4h11l-9 6.5 3.5 10.4-9-6.5-8.8 6.5 3.4-10.4-8.8-6.5h11zm-70-36.4 3.4 10.4h11l-9 6.4 3.6 10.5-9-6.5-8.8 6.5 3.4-10.5-9-6.4h11zm35 0 3.4 10.4h11l-9 6.4 3.6 10.5-9-6.5-8.8 6.5 3.4-10.5-9-6.4h11zm35 0 3.4 10.4h11l-9 6.4 3.6 10.5-9-6.5-8.8 6.5 3.4-10.5-8.8-6.4h11z'
      />
    </g>
  </svg>
)

// VA Holy See
const VaFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ffda44' d='M0 0h256l51.7 254.7L256 512H0z' />
      <path fill='#eee' d='M256 0h256v512H256z' />
      <path
        fill='#acabb1'
        d='m354 222.8 48.1 63.6A33.4 33.4 0 1 0 420 273l-75-99.2-17.7 13.4-26.7 20.2 26.9 35.5 26.6-20.1zm69.3 73.1a11.1 11.1 0 1 1 13.4 17.8 11.1 11.1 0 0 1-13.4-17.8z'
      />
      <path
        fill='#ffda44'
        d='m436.6 242.9 26.8-35.5-26.6-20.2-17.8-13.4-75 99.2a33.4 33.4 0 1 0 17.8 13.4l48-63.6 26.8 20zm-93.8 68.6a11.1 11.1 0 1 1-17.8-13.4 11.1 11.1 0 0 1 17.8 13.4z'
      />
    </g>
  </svg>
)

// VC Saint Vincent and the Grenadines
const VcFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#ffda44' d='M378.5 0H133.7l-22.3 256 22.3 256h244.8l22.3-256z' />
      <path fill='#338af3' d='M133.7 512V0H0v512z' />
      <path
        fill='#6da544'
        d='M512 0H378.5v512H512zM200.4 322.8 156 256l44.5-66.8 44.7 66.8zm111.4 0L267.1 256l44.6-66.8 44.5 66.8zm-55.7 89L211.6 345l44.5-66.7 44.5 66.7z'
      />
    </g>
  </svg>
)
// VE Venezuela (Bolivarian Republic of)
const VeFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='m0 144.7 255.3-36.5L512 144.7v222.6L250.5 407 0 367.3z' />
      <path fill='#ffda44' d='M0 0h512v144.7H0z' />
      <path fill='#d80027' d='M0 367.3h512V512H0z' />
      <path
        fill='#eee'
        d='M443.4 306.4 429.8 317l6 16.1-14.3-9.6-13.5 10.7 4.7-16.5-14.2-9.6 17.1-.6 4.7-16.5 6 16.1zm-34.7-60-9 14.5 11 13.2L394 270l-9 14.6-1.3-17-16.6-4.3 15.9-6.4-1.2-17 11 13zm-53-44.5-3.6 16.8 14.9 8.4-17 1.8-3.6 16.8-7-15.7-17 1.8 12.7-11.5-7-15.6 14.8 8.6zm-65-23.7 2.3 17 17 3-15.5 7.5 2.4 17-12-12.4-15.4 7.6 8-15.2-11.8-12.3 16.9 3zm-69.3 0 8 15.1 17-3-12 12.4 8 15.2-15.4-7.6-11.9 12.4 2.4-17-15.4-7.5 16.9-3zm-65 23.7 12.7 11.5 14.8-8.6-7 15.7 12.8 11.4-17-1.8-7 15.7-3.7-16.7-17-1.8 14.8-8.5zm-53.1 44.5 15.9 6.4 11-13-1.2 17 16 6.4-16.7 4.2-1.2 17L118 270l-16.7 4.2 11-13.2zm-34.7 60 17.2.5 5.9-16 4.7 16.4 17.1.6-14.2 9.6 4.7 16.6-13.5-10.6-14.2 9.6 5.9-16z'
      />
    </g>
  </svg>
)

// VG Virgin Islands (British)
const VgFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M256 0h256v512H0V256Z' />
      <path fill='#ffda44' d='m367.3 256-69.2 69.2a77.9 77.9 0 0 0 138.4 0z' />
      <path fill='#6da544' d='M289.4 133.6V256c0 59.6 77.9 78 77.9 78s78-18.4 78-78V133.6h-156z' />
      <path fill='#496e2d' d='M445.2 256zm-155.8 0z' />
      <path
        fill='#ffda44'
        d='M311.7 155.8h22.2v22.3h-22.2zm0 50.1h22.2v22.3h-22.2zm0 50.1h22.2v22.3h-22.2zm89-100.2H423v22.3h-22.3zm0 50.1H423v22.3h-22.3zm0 50.1H423v22.3h-22.3z'
      />
      <path
        fill='#eee'
        d='M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z'
      />
      <path fill='#d80027' d='M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z' />
      <path fill='#eee' d='M350.6 189.2H384v89h-33.4z' />
      <circle cx='367.3' cy='189.2' r='16.7' fill='#a2001d' />
    </g>
  </svg>
)

// US Virgin Islands
const ViFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M0 0h512v512H0z' />
      <g fill='#ffda44'>
        <path d='M299.5 178.8a43.5 43.5 0 1 0-87 0H117a44 44 0 0 0 44.2 42.9h-1.4a42.8 42.8 0 0 0 42.8 42.8l53.5 42 53.5-42a42.8 42.8 0 0 0 42.8-42.8H351a44 44 0 0 0 44.2-42.9h-95.6z' />
        <path d='m236.9 302.3-27 60.9a122 122 0 0 0 46.1 9 122 122 0 0 0 46-9l-26.9-60.9H237z' />
      </g>
      <path
        fill='#eee'
        d='m255.3 214-55 21.5v39.7a49.1 49.1 0 0 0 22.3 40l11.3-2.3 11 14.3a98.2 98.2 0 0 0 11.1 3.6s4.6-1.1 11.1-3.6l9.4-14.1 13 2.1a49.2 49.2 0 0 0 22.2-40.1v-39.6z'
      />
      <path
        fill='#338af3'
        d='M62 257.8 92.3 342l29.8-84.2h22.7l-43.4 111.3H83L39.3 257.8h22.8zm349.8 111.3V257.8h21.7v111.3z'
      />
      <path
        fill='#d80027'
        d='M222.6 224.4v90.8a96 96 0 0 0 22.3 12V224.3zm66.8 0v90.8a98 98 0 0 1-22.3 12V224.3z'
      />
      <path fill='#0052b4' d='M200.3 200.2h111.4v35.3H200.3z' />
    </g>
  </svg>
)

// Vietnam
const VnFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 0h512v512H0z' />
      <path
        fill='#ffda44'
        d='m256 133.6 27.6 85H373L300.7 271l27.6 85-72.3-52.5-72.3 52.6 27.6-85-72.3-52.6h89.4z'
      />
    </g>
  </svg>
)

// VU Vanuatu
const VuFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M512 222.6V0H0l215.6 239.4z' />
      <path fill='#6da544' d='M512 289.4V512H0l216.5-240z' />
      <path
        fill='#333'
        d='m0 0 222.6 222.6H512v22.2l-10.9 11.8L512 267v22.4H222.6L0 512v-31.5l8-23-8-8.6V63l9.5-10.4-9.5-21z'
      />
      <g fill='#ffda44'>
        <path d='M512 244.8H213.2L0 31.7V63l192.8 193L0 449v31.5L213.2 267H512z' />
        <path d='M62.2 310.6V289a38.8 38.8 0 0 0 38.8-38.8A27.5 27.5 0 0 0 73.5 223a18.7 18.7 0 0 0-18.7 18.7 12 12 0 0 0 12 12c3.7 0 6.8-3 6.8-6.8H95A28.2 28.2 0 0 1 66.8 275c-18.4 0-33.4-15-33.4-33.4 0-22.2 18-40.2 40-40.2a49 49 0 0 1 49 49c0 33.1-27 60.2-60.2 60.2z' />
      </g>
    </g>
  </svg>
)

// WF Wallis and Futuna
const WfFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M256 0h256v512H0V256Z' />
      <path fill='#eee' d='M0 0h256v256H0Z' />
      <path fill='#0052b4' d='M0 0h75v224H0Z' />
      <path fill='#d80027' d='M149 0h75v224h-75z' />
      <path
        fill='#eee'
        d='m384 232-72-72h144zm-24 24-72-72v144zm24 24-72 72h144zm24-24 72-72v144z'
      />
    </g>
  </svg>
)

// WS Samoa
const WsFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#d80027' d='M0 256 256 0h256v512H0z' />
      <path fill='#0052b4' d='M0 0h256v256H0z' />
      <path
        fill='#eee'
        d='m205 167 4.2 12.7h13.4l-10.8 7.9 4.1 12.7-10.8-7.8-10.9 7.8 4.1-12.7-10.8-7.9h13.4zM137.8 66.8l7 21.2H167l-18.1 13.2 6.9 21.2-18.1-13.1-18 13.1 6.8-21.2-18-13.2h22.3zM204.5 89l6.9 21.3h22.3l-18 13.1 6.9 21.3-18.1-13.1-18.1 13.1 7-21.3-18.2-13.1h22.4zm-52.8 89 6.9 21.3H181l-18.1 13.2 6.9 21.2-18.1-13.1-18 13.1 6.8-21.2-18-13.2h22.3zm-58.5-55.6 6.9 21.3h22.3l-18 13.1 6.9 21.3-18.1-13.2L75 178.1l6.9-21.3-18-13.1h22.3z'
      />
    </g>
  </svg>
)

// XK Kosovo
const XkFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#0052b4' d='M0 0h512v512H0z' />
      <path
        fill='#eee'
        d='m112.4 155.8 5.6 17h17.9l-14.5 10.5 5.5 17-14.5-10.5L98 200.3l5.5-17L89 172.8h18zm55.7-16.7 5.5 17h18L177 166.6l5.6 17-14.5-10.5-14.5 10.6 5.6-17-14.5-10.6h17.9zm55.7-16.7 5.5 17h17.9L232.7 150l5.5 17-14.4-10.6-14.5 10.6 5.5-17-14.5-10.6h18zm175.8 33.4-5.6 17h-17.9l14.5 10.5-5.5 17 14.5-10.5 14.4 10.5-5.5-17 14.5-10.5h-18zm-55.7-16.7-5.5 17h-18l14.6 10.5-5.6 17 14.5-10.5 14.5 10.6-5.6-17 14.5-10.6h-17.9zm-55.7-16.7-5.5 17h-17.9l14.5 10.6-5.5 17 14.4-10.6 14.5 10.6-5.5-17 14.5-10.6h-18z'
      />
      <path
        fill='#ffda44'
        d='M300.5 267.1 256 211.5l-22.3 11.1V245l-33.4 22h-22.2v29a89 89 0 0 1 55.6 82.5H256v-22.2l22.3-22.3 22.2 22.3 22.3-22.3v-22.2l22.2-33.4-44.5-11.2z'
      />
    </g>
  </svg>
)

// YE Yemen
const YeFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z' />
      <path fill='#d80027' d='M0 0h512v167H0z' />
      <path fill='#333' d='M0 345h512v167H0z' />
    </g>
  </svg>
)

// YT Mayotte
const YtFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='M0 0h512v512H0z' />
      <path
        fill='#acabb1'
        d='M113 139c-4 0-11 2-23 8a59 59 0 0 0-13 9c-28 27-20 68-11 79 3 4 16 23 32 30 22 8 36 28 37 51 0 24-15 44-34 46h-4c-19 0-36-19-37-43v2c1 29 20 52 43 52s44-12 55-32l5-8a43 43 0 0 0 4-14c4-19 6-70-47-95-40-20-45-36-40-43a4 4 0 0 1 3-1 19 19 0 0 0 18 19 15 15 0 0 0 10-4s18 18 24 11 0-7-6-14c-5-7 0-21-11-28-12-7-18-7-12-15a16 16 0 0 1 12-7s0-3-5-3zm287 0c-5 0-5 3-5 3 5 1 9 3 12 7 5 8 0 8-12 15s-6 21-12 28c-5 7-11 7-5 14 5 7 24-11 24-11a15 15 0 0 0 10 4 19 19 0 0 0 18-19 4 4 0 0 1 2 1c6 7 1 23-40 43-52 25-50 76-47 95l5 14a189 189 0 0 0 5 8c10 20 32 33 54 32 24 0 43-23 44-52v-2c-2 24-18 43-38 43h-4c-19-2-33-22-33-46 1-23 15-43 36-51 16-7 29-26 33-30 8-11 17-52-11-79a59 59 0 0 0-14-9c-12-6-18-8-22-8zM26 199c-1 0-2 1-2 3-2 16-1 52 33 64a2 2 0 0 0 3-1l6-8v-4c-5-7-22-31-22-44l-2-2a19 19 0 0 1-15-7l-1-1zm460 0-1 1a19 19 0 0 1-15 7l-2 2c0 13-17 37-21 44v4l5 8a2 2 0 0 0 3 1c34-12 35-48 34-64l-3-3z'
      />
      <path
        fill='#0052b4'
        d='M211 147a22.5 22.5 0 0 0 0 45 22.5 22.5 0 0 0 0 45l45 32 45-32a22.5 22.5 0 0 0 0-45 22.5 22.5 0 1 0-22.5-22.5 22.5 22.5 0 0 0-45 0A22.5 22.5 0 0 0 211 147z'
      />
      <path
        fill='#d80027'
        d='M211 327a22.5 22.5 0 0 1-22.5-22.5A22.5 22.5 0 0 1 211 282a22.5 22.5 0 0 1-22.5-22.5A22.5 22.5 0 0 1 211 237h90a22.5 22.5 0 0 1 22.5 22.5A22.5 22.5 0 0 1 301 282a22.5 22.5 0 0 1 22.5 22.5A22.5 22.5 0 0 1 301 327a22.5 22.5 0 0 1-22.5-22.5A22.5 22.5 0 0 1 256 327a22.5 22.5 0 0 1-22.5-22.5A22.5 22.5 0 0 1 211 327z'
      />
      <path
        fill='#eee'
        d='M232 188a25 25 0 0 0-1 5 25 25 0 0 0 25 25 25 25 0 0 0 25-25 25 25 0 0 0-1-5 25 25 0 0 1-24 19 25 25 0 0 1-24-19z'
      />
      <path
        fill='#ffda44'
        d='M283 254a4 4 0 0 0-4 4v8l-7-4a4 4 0 0 0-2-1 4 4 0 0 0-3 2 4 4 0 0 0 1 6l7 4-7 3a4 4 0 0 0-1 6 4 4 0 0 0 5 1l7-3v7a4 4 0 0 0 4 4 4 4 0 0 0 4-4v-7l7 3a4 4 0 0 0 5-1 4 4 0 0 0-1-6l-7-3 7-4a4 4 0 0 0 1-6 4 4 0 0 0-3-2 4 4 0 0 0-2 1l-7 4v-8a4 4 0 0 0-4-4zm-54 0a4 4 0 0 0-4 4v8l-7-4a4 4 0 0 0-2-1 4 4 0 0 0-3 2 4 4 0 0 0 1 6l7 4-7 3a4 4 0 0 0-1 6 4 4 0 0 0 5 1l7-3v7a4 4 0 0 0 4 4 4 4 0 0 0 4-4v-7l7 3a4 4 0 0 0 5-1 4 4 0 0 0-1-6l-7-3 7-4a4 4 0 0 0 1-6 4 4 0 0 0-3-2 4 4 0 0 0-2 1l-7 4v-8a4 4 0 0 0-4-4z'
      />
    </g>
  </svg>
)

// South Africa
const ZaFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#eee' d='m0 0 192 256L0 512h47l465-189v-34l-32-33 32-33v-34L47 0Z' />
      <path fill='#333' d='M0 142v228l140-114z' />
      <path fill='#ffda44' d='M192 256 0 95v47l114 114L0 370v47z' />
      <path fill='#6da544' d='M512 223H223L0 0v94l161 162L0 418v94l223-223h289z' />
      <path fill='#d80027' d='M512 0H47l189 189h276z' />
      <path fill='#0052b4' d='M512 512H47l189-189h276z' />
    </g>
  </svg>
)

// ZM Zambia
const ZmFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#496e2d' d='M0 0h512v256L256 512H0z' />
      <path
        fill='#ff9811'
        d='M473 167h-66.7a22.3 22.3 0 0 0-44.6 0H295a23 23 0 0 0 23 22.2h-.8c0 12.3 10 22.3 22.3 22.3 0 12.3 10 22.2 22.2 22.2h44.6c12.3 0 22.2-10 22.2-22.2 12.3 0 22.3-10 22.3-22.3h-.8a23 23 0 0 0 23-22.2z'
      />
      <path fill='#333' d='M341.3 256h85.4l21.1 126.3L426.7 512h-85.4l-23.5-128z' />
      <path fill='#d80027' d='M256 256h85.3v256H256z' />
      <path fill='#ff9811' d='M426.7 256H512v256h-85.3z' />
    </g>
  </svg>
)

// ZW Zimbabwe
const ZwFlag = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
    <mask id='countryFlag'>
      <circle cx='256' cy='256' r='256' fill='#fff' />
    </mask>
    <g mask='countryFlag'>
      <path fill='#6da544' d='M31.4 0H512v512H31.4z' />
      <path fill='#ffda44' d='M57.8 73.3H512v73.3l-65.1 110 65.1 110v73.3H57.8z' />
      <path fill='#d80027' d='M132 146.6h380v73.3l-27 36 27 37.3v73.3H132z' />
      <path fill='#eee' d='M0 0v512l279.8-256z' />
      <path
        fill='#d80027'
        d='m103 189.2 16.5 51h53.6l-43.4 31.6 16.6 51-43.4-31.5-43.4 31.5 16.6-51-43.4-31.6h53.6z'
      />
      <path
        fill='#ffda44'
        d='m148.5 260.2-43.2-15.3-3.4-31a16.7 16.7 0 1 0-32.5 7.6l-12 12.1h21.5c0 22.4-16.7 22.4-16.7 44.7l9.2 22.2h55.7l9.3-22.2a22.2 22.2 0 0 0 1.7-6.6c8-3.2 10.4-11.5 10.4-11.5z'
      />
      <path fill='#333' d='m31.4 0 220 220H512v73.2H250.2L31.4 512H0l256-256L0 0z' />
    </g>
  </svg>
)

// Map country names to their corresponding components
export const FLAGS_MAPPING: Record<string, React.FC> = {
  adFlag: AdFlag,
  aeFlag: AeFlag,
  afFlag: AfFlag,
  agFlag: AgFlag,
  aiFlag: AiFlag,
  alFlag: AlFlag,
  amFlag: AmFlag,
  aoFlag: AoFlag,
  aqFlag: AqFlag,
  arFlag: ArFlag,
  asFlag: AsFlag,
  atFlag: AtFlag,
  auFlag: AuFlag,
  awFlag: AwFlag,
  axFlag: AxFlag,
  azFlag: AzFlag,
  baFlag: BaFlag,
  bbFlag: BbFlag,
  bdFlag: BdFlag,
  beFlag: BeFlag,
  bfFlag: BfFlag,
  bgFlag: BgFlag,
  bhFlag: BhFlag,
  biFlag: BiFlag,
  bjFlag: BjFlag,
  blFlag: BlFlag,
  bmFlag: BmFlag,
  bnFlag: BnFlag,
  boFlag: BoFlag,
  bqFlag: BqFlag,
  brFlag: BrFlag,
  bsFlag: BsFlag,
  btFlag: BtFlag,
  bvFlag: BvFlag,
  bwFlag: BwFlag,
  byFlag: ByFlag,
  bzFlag: BzFlag,
  caFlag: CaFlag,
  ccFlag: CcFlag,
  cdFlag: CdFlag,
  cfFlag: CfFlag,
  cgFlag: CgFlag,
  chFlag: ChFlag,
  ciFlag: CiFlag,
  ckFlag: CkFlag,
  clFlag: ClFlag,
  cmFlag: CmFlag,
  cnFlag: CnFlag,
  coFlag: CoFlag,
  crFlag: CrFlag,
  cuFlag: CuFlag,
  cvFlag: CvFlag,
  cwFlag: CwFlag,
  cxFlag: CxFlag,
  cyFlag: CyFlag,
  czFlag: CzFlag,
  deFlag: DeFlag,
  djFlag: DjFlag,
  dkFlag: DkFlag,
  dmFlag: DmFlag,
  doFlag: DoFlag,
  dzFlag: DzFlag,
  ecFlag: EcFlag,
  eeFlag: EeFlag,
  egFlag: EgFlag,
  ehFlag: EhFlag,
  erFlag: ErFlag,
  esFlag: EsFlag,
  etFlag: EtFlag,
  euFlag: EuFlag,
  fiFlag: FiFlag,
  fjFlag: FjFlag,
  fkFlag: FkFlag,
  fmFlag: FmFlag,
  foFlag: FoFlag,
  frFlag: FrFlag,
  gaFlag: GaFlag,
  'gb-engFlag': GbEngFlag,
  'gb-nirFlag': GbNirFlag,
  'gb-sctFlag': GbSctFlag,
  'gb-wls': GbWlsFlag,
  gbFlag: GbFlag,
  gdFlag: GdFlag,
  geFlag: GeFlag,
  gfFlag: GfFlag,
  ggFlag: GgFlag,
  ghFlag: GhFlag,
  giFlag: GiFlag,
  glFlag: GlFlag,
  gmFlag: GmFlag,
  gnFlag: GnFlag,
  gpFlag: GpFlag,
  gqFlag: GqFlag,
  grFlag: GrFlag,
  gsFlag: GsFlag,
  gtFlag: GtFlag,
  guFlag: GuFlag,
  gwFlag: GwFlag,
  gyFlag: GyFlag,
  hkFlag: HkFlag,
  hmFlag: HmFlag,
  hnFlag: HnFlag,
  hrFlag: HrFlag,
  htFlag: HtFlag,
  huFlag: HuFlag,
  idFlag: IdFlag,
  ieFlag: IeFlag,
  ilFlag: IlFlag,
  imFlag: ImFlag,
  inFlag: InFlag,
  ioFlag: IoFlag,
  iqFlag: IqFlag,
  irFlag: IrFlag,
  isFlag: IsFlag,
  itFlag: ItFlag,
  jeFlag: JeFlag,
  jmFlag: JmFlag,
  joFlag: JoFlag,
  jpFlag: JpFlag,
  keFlag: KeFlag,
  kgFlag: KgFlag,
  khFlag: KhFlag,
  kiFlag: KiFlag,
  kmFlag: KmFlag,
  knFlag: KnFlag,
  kpFlag: KpFlag,
  krFlag: KrFlag,
  kwFlag: KwFlag,
  kyFlag: KyFlag,
  kzFlag: KzFlag,
  laFlag: LaFlag,
  lbFlag: LbFlag,
  lcFlag: LcFlag,
  liFlag: LiFlag,
  lkFlag: LkFlag,
  lrFlag: LrFlag,
  lsFlag: LsFlag,
  ltFlag: LtFlag,
  luFlag: LuFlag,
  lvFlag: LvFlag,
  lyFlag: LyFlag,
  maFlag: MaFlag,
  mcFlag: McFlag,
  mdFlag: MdFlag,
  meFlag: MeFlag,
  mfFlag: MfFlag,
  mgFlag: MgFlag,
  mhFlag: MhFlag,
  mkFlag: MkFlag,
  mlFlag: MlFlag,
  mmFlag: MmFlag,
  mnFlag: MnFlag,
  moFlag: MoFlag,
  mpFlag: MpFlag,
  mqFlag: MqFlag,
  mrFlag: MrFlag,
  msFlag: MsFlag,
  mtFlag: MtFlag,
  muFlag: MuFlag,
  mvFlag: MvFlag,
  mwFlag: MwFlag,
  mxFlag: MxFlag,
  myFlag: MyFlag,
  mzFlag: MzFlag,
  naFlag: NaFlag,
  ncFlag: NcFlag,
  neFlag: NeFlag,
  nfFlag: NfFlag,
  ngFlag: NgFlag,
  niFlag: NiFlag,
  nlFlag: NlFlag,
  noFlag: NoFlag,
  npFlag: NpFlag,
  nrFlag: NrFlag,
  nuFlag: NuFlag,
  nzFlag: NzFlag,
  omFlag: OmFlag,
  paFlag: PaFlag,
  peFlag: PeFlag,
  pfFlag: PfFlag,
  phFlag: PhFlag,
  pgFlag: PgFlag,
  pkFlag: PkFlag,
  plFlag: PlFlag,
  pmFlag: PmFlag,
  pnFlag: PnFlag,
  prFlag: PrFlag,
  psFlag: PsFlag,
  ptFlag: PtFlag,
  pwFlag: PwFlag,
  pyFlag: PyFlag,
  qaFlag: QaFlag,
  reFlag: ReFlag,
  roFlag: RoFlag,
  rsFlag: RsFlag,
  ruFlag: RuFlag,
  rwFlag: RwFlag,
  saFlag: SaFlag,
  sbFlag: SbFlag,
  scFlag: ScFlag,
  sdFlag: SdFlag,
  seFlag: SeFlag,
  sgFlag: SgFlag,
  shFlag: ShFlag,
  siFlag: SiFlag,
  skFlag: SkFlag,
  slFlag: SlFlag,
  smFlag: SmFlag,
  snFlag: SnFlag,
  soFlag: SoFlag,
  srFlag: SrFlag,
  ssFlag: SsFlag,
  stFlag: StFlag,
  svFlag: SvFlag,
  sxFlag: SxFlag,
  syFlag: SyFlag,
  szFlag: SzFlag,
  tcFlag: TcFlag,
  tdFlag: TdFlag,
  tfFlag: TfFlag,
  tgFlag: TgFlag,
  thFlag: ThFlag,
  tjFlag: TjFlag,
  tkFlag: TkFlag,
  tlFlag: TlFlag,
  tmFlag: TmFlag,
  tnFlag: TnFlag,
  toFlag: ToFlag,
  trFlag: TrFlag,
  ttFlag: TtFlag,
  tvFlag: TvFlag,
  twFlag: TwFlag,
  tzFlag: TzFlag,
  uaFlag: UaFlag,
  ugFlag: UgFlag,
  umFlag: UsFlag,
  usFlag: UsFlag,
  uyFlag: UyFlag,
  uzFlag: UzFlag,
  vaFlag: VaFlag,
  vcFlag: VcFlag,
  veFlag: VeFlag,
  vgFlag: VgFlag,
  viFlag: ViFlag,
  vnFlag: VnFlag,
  vuFlag: VuFlag,
  wfFlag: WfFlag,
  wsFlag: WsFlag,
  xkFlag: XkFlag,
  yeFlag: YeFlag,
  ytFlag: YtFlag,
  zaFlag: ZaFlag,
  zmFlag: ZmFlag,
  zwFlag: ZwFlag,
}
